var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/pages/ticket/ticket-page.tsx
import React12, { useEffect as useEffect2, useState as useState7 } from "react";
import { FlexComponent as FlexComponent6, PageContent, PageLayout, TextComponent as TextComponent4 } from "@ontruck/fe-ui";
import styled9 from "styled-components";
import { useHistory } from "react-router-dom";
import { IconComponent as IconComponent4, iconNames as iconNames5 } from "@ontruck/fe-icons";
import { Toaster } from "sonner";

// src/business/tickets/hooks/get-ticket-hook.ts
import useSWR, { mutate } from "swr";

// src/config/config-hook.ts
import { useContext } from "react";

// src/config/config-context.ts
import { createContext } from "react";
var config = {
  token: "",
  apiBase: ""
};
var ConfigContext = createContext(config);

// src/config/config-hook.ts
function useConfigHook() {
  return useContext(ConfigContext);
}

// src/business/tickets/api/get-ticket-api.ts
import { toast } from "sonner";
function getTicketApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, ticketId) {
    var _a;
    try {
      const baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticketId}/`;
      const response = yield fetch(baseURL, {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) {
        toast.error("Ha ocurrido un error al obtener la cotizaci\xF3n.");
        return null;
      }
      const data = yield response.json();
      if ((_a = data.quote) == null ? void 0 : _a.id) {
        const quoteResponse = yield fetch(
          `${apiBase}/v1/price-negotiation/tickets/${ticketId}/quotes/${data.quote.id}/`,
          {
            method: "GET",
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (quoteResponse.ok) {
          const quoteData = yield quoteResponse.json();
          data.quote.suggested_price = quoteData.suggested_price;
          if (data.quote.suggested_price) {
            data.quote.suggested_price.classification = quoteData.classification;
          }
        }
      }
      return data;
    } catch (error) {
      toast.error("Ha ocurrido un error al obtener el precio sugerido de la cotizaci\xF3n.");
      return null;
    }
  });
}

// src/business/tickets/mappers/ticket-mapper.ts
import moment3 from "moment";

// src/business/tickets/hooks/ticket-utils.ts
import moment from "moment";
var MONTHS_NAMES = [
  { abrev: "Ene", nombre: "enero" },
  { abrev: "Feb", nombre: "febrero" },
  { abrev: "Mar", nombre: "marzo" },
  { abrev: "Abr", nombre: "abril" },
  { abrev: "May", nombre: "mayo" },
  { abrev: "Jun", nombre: "junio" },
  { abrev: "Jul", nombre: "julio" },
  { abrev: "Ago", nombre: "agosto" },
  { abrev: "Sep", nombre: "septiembre" },
  { abrev: "Oct", nombre: "octubre" },
  { abrev: "Nov", nombre: "noviembre" },
  { abrev: "Dic", nombre: "diciembre" }
];
function useTicketUtils() {
  function getTicketFormattedId(id) {
    if (!id) {
      return "";
    }
    const numberOfWantedDigits = 4;
    const numberOfActualDigits = id.toString().length;
    const amountOfMissingDigits = numberOfWantedDigits - numberOfActualDigits;
    let formatedId = "";
    for (let i = 0; i < amountOfMissingDigits; i++)
      formatedId = `${formatedId}0`;
    formatedId = formatedId + id;
    return formatedId;
  }
  function handleAiTicketRejectionChange(ticketId, valueKey, value, ticketState) {
    const key = getTicketRejectionKey(ticketId, valueKey);
    if (!value) {
      window.localStorage.removeItem(key);
      return;
    }
    const rejectionData = {
      rejectedValue: String(value),
      ticketState
    };
    window.localStorage.setItem(key, JSON.stringify(rejectionData));
  }
  return {
    getTicketFormattedId,
    handleAiTicketRejectionChange
  };
}
function ticketFormatTime(time) {
  if (!time) {
    return "";
  }
  return moment(time, "HH:mm:ss").format("HH:mm");
}
function ticketFormatDateTime(date, timeFrom, timeTo) {
  var _a;
  const dateMoment = date ? moment(date) : null;
  const monthName = dateMoment ? MONTHS_NAMES[dateMoment.month()] : null;
  const formatedDate = dateMoment ? `${(_a = monthName == null ? void 0 : monthName.abrev) != null ? _a : ""} ${dateMoment.format("DD/YYYY")}` : "";
  const formattedTimeFrom = ticketFormatTime(timeFrom);
  const formattedTimeTo = ticketFormatTime(timeTo);
  const formatedTime = `${formattedTimeFrom} - ${formattedTimeTo}`;
  return `${formatedDate} ${formatedTime}`.trim();
}
function checkIfTicketValIsValidSuggestion(aiStorageKey, ticketId, ticketState, ticketValue, aiSuggestion) {
  if (!aiSuggestion || !aiStorageKey) {
    return false;
  }
  const aiValue = String(aiSuggestion).toLowerCase();
  const storedRejection = getTicketRejectionData(aiStorageKey, ticketId);
  if (storedRejection) {
    if (storedRejection.ticketState !== ticketState) {
    } else if (storedRejection.rejectedValue === aiValue) {
      return false;
    }
  }
  if (!ticketValue) {
    return true;
  }
  return String(ticketValue).toLowerCase() !== aiValue;
}
function formatPrice(price, showAlways = false) {
  if (!showAlways && !price) {
    return "";
  }
  return price ? Number(price).toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR"
  }) : "0,00 \u20AC";
}
function getTicketRejectionKey(ticketId, valueKey) {
  return `ticket_${ticketId}_ai_${valueKey}_rejection`;
}
function getTicketRejectionData(valueKey, ticketId) {
  const key = getTicketRejectionKey(ticketId, valueKey);
  const stored = window.localStorage.getItem(key);
  if (!stored) {
    return null;
  }
  try {
    const parsed = JSON.parse(stored);
    return {
      rejectedValue: parsed.rejectedValue.toLowerCase(),
      ticketState: parsed.ticketState
    };
  } catch (e) {
    return {
      rejectedValue: stored.toLowerCase(),
      ticketState: "UNKNOWN"
    };
  }
}

// src/business/tickets/models/ticket.ts
var TicketColorStates = {
  ["REJECTED" /* REJECTED */]: "#CC000A",
  ["PENDING" /* PENDING */]: "#FF6400",
  ["QUOTE_SENT" /* QUOTESENT */]: "#2563EB",
  ["ACCEPTED" /* ACCEPTED */]: "#4CA202",
  ["CANCELLED" /* CANCELLED */]: "#2c3137",
  ["DRAFT" /* DRAFT */]: "#eeb93f",
  ["MISSINGFIELDS" /* MISSINGFIELDS */]: "#eeb93f",
  ["DONE" /* DONE */]: "#54708C"
};

// src/business/tickets/api/get-ticket-ai-price-api.ts
function getTicketAiPriceApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket) {
    if (!ticket || !validateTicketIsReadyForAiPrice(ticket)) {
      return null;
    }
    const data = {
      input: {
        order_data: {
          pickup: processedTicketAddressChanges(ticket.orderData.pickup),
          dropoff: processedTicketAddressChanges(ticket.orderData.dropoff),
          cargo: processedTicketCargoChanges(ticket.orderData.cargo),
          service_type: {
            vehicle_type: "FTL (max. 24Tn) Tautliner Standard"
            // Harcoded as truck for now AI pricing only supports old vehicle types (FTL (max. 24Tn) Tautliner Standard, ...)
          },
          vehicle_type: "OTHER"
        },
        shipper_data: processedShipperDataChanges(ticket.shipperData),
        currency: "EUR"
      }
    };
    const baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/prices/`;
    const response = yield fetch(baseURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      const errorFromBackend = JSON.stringify(yield response.json());
      const errorToThrow = new Error(errorFromBackend);
      throw errorToThrow;
    }
    const price = yield response.json();
    const priceAmount = roundAiPricing(price.price.amount);
    return {
      id: price.id,
      price: {
        amount: priceAmount,
        currency: price.price.currency,
        formatted_amount: formatPrice(priceAmount)
      },
      classification: price.classification
    };
  });
}
function roundAiPricing(price) {
  return Math.round(Number(price) / 10) * 10;
}
function validateTicketIsReadyForAiPrice(ticket) {
  const validStates = ["PENDING" /* PENDING */, "QUOTE_SENT" /* QUOTESENT */, "ACCEPTED" /* ACCEPTED */];
  return Boolean(
    validStates.includes(ticket.state) && checkAddressRequiredFields(ticket.orderData.pickup) && checkAddressRequiredFields(ticket.orderData.dropoff) && checkCargoRequiredFields(ticket.orderData.cargo) && ticket.orderData.vehicleType
  );
}
function checkAddressRequiredFields(address) {
  return Boolean(address.country && address.zipcode && address.date);
}
function checkCargoRequiredFields(cargo) {
  return Boolean(cargo.numberOfPallets && cargo.goodsType && cargo.varietyId);
}
function processedShipperDataChanges(newShipperData) {
  const data = {};
  if (newShipperData.companyId) {
    data.company_id = newShipperData.companyId;
  }
  if (newShipperData.companyName) {
    data.company_name = newShipperData.companyName;
  }
  if (newShipperData.contactName) {
    data.contact_name = newShipperData.contactName;
  }
  if (newShipperData.language) {
    data.language = newShipperData.language;
  }
  if (newShipperData.email) {
    data.email = newShipperData.email;
  }
  if (newShipperData.phone) {
    data.phone = newShipperData.phone;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}
function processedTicketCargoChanges(newCargo) {
  const data = {};
  if (newCargo.weight) {
    data.weight = newCargo.weight ? Number(newCargo.weight) : null;
  }
  if (newCargo.linearMeters) {
    data.linear_meters = newCargo.linearMeters ? Number(newCargo.linearMeters) : null;
  }
  if (newCargo.volume) {
    data.volume = newCargo.volume ? Number(newCargo.volume) : null;
  }
  if (newCargo.numberOfPallets) {
    data.number_of_pallets = newCargo.numberOfPallets ? Number(newCargo.numberOfPallets) : null;
  }
  if (newCargo.cargoType) {
    data.cargo_type = newCargo.cargoType;
  }
  if (newCargo.goodsType) {
    data.goods_type = newCargo.goodsType;
  }
  if (newCargo.varietyId) {
    data.variety_id = newCargo.varietyId;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}
function processedTicketAddressChanges(newAddress) {
  const data = {};
  if (newAddress.date) {
    data.date = newAddress.date;
  }
  if (newAddress.timeFrom) {
    data.time_from = newAddress.timeFrom;
  }
  if (newAddress.timeTo) {
    data.time_to = newAddress.timeTo;
  }
  if (newAddress.country) {
    data.country = newAddress.country;
  }
  if (newAddress.zipcode) {
    data.zipcode = newAddress.zipcode;
  }
  if (newAddress.address) {
    data.address = newAddress.address;
  }
  if (newAddress.city) {
    data.city = newAddress.city;
  }
  if (newAddress.observations) {
    data.observations = newAddress.observations;
  }
  if (newAddress.contact) {
    data.contact = newAddress.contact;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}

// src/business/tickets/hooks/conversation-utils.ts
function markTicketMessageAsViewed(ticket) {
  var _a;
  if ((_a = ticket.conversation) == null ? void 0 : _a.messages.length) {
    const lastMessage = ticket.conversation.messages[ticket.conversation.messages.length - 1];
    if (lastMessage.author.role === "client") {
      setTicketMessageViewed(ticket.id, lastMessage.id);
      return;
    }
  }
  removeTicketMessageViewed(ticket.id);
}
function getTemporalMessage(messageId) {
  const key = getStorageTicketTemporalMessageKey(messageId);
  return localStorage.getItem(key) || null;
}
function removeTemporalMessage(messageId) {
  const key = getStorageTicketTemporalMessageKey(messageId);
  localStorage.removeItem(key);
}
function getTicketMessageViewed(ticketId) {
  const key = getStorageTicketSawMessageKey(ticketId);
  const sawMessage = localStorage.getItem(key);
  return sawMessage ? parseInt(sawMessage) : null;
}
function removeTicketMessageViewed(ticketId) {
  const key = getStorageTicketSawMessageKey(ticketId);
  localStorage.removeItem(key);
}
function setTicketMessageViewed(ticketId, messageId) {
  const key = getStorageTicketSawMessageKey(ticketId);
  localStorage.setItem(key, messageId.toString());
}
function getStorageTicketSawMessageKey(ticketId) {
  return `ticket-conversation-${ticketId}`;
}
function getStorageTicketTemporalMessageKey(messageId) {
  return `ticket-conversation-temporal-message-${messageId}`;
}

// src/business/tickets/mappers/draft-ticket-mapper.ts
import moment2 from "moment";
function draftTicketMapper(draftTicketDto, ticket) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  if (!draftTicketDto)
    return null;
  const getField = (newPath, oldPath) => newPath != null ? newPath : oldPath;
  return {
    orderData: {
      pickup: draftTicketAddressMapper(
        getField((_a = draftTicketDto.order_data) == null ? void 0 : _a.pickup, draftTicketDto.pickup),
        ticket.orderData.pickup
      ),
      dropoff: draftTicketAddressMapper(
        getField((_b = draftTicketDto.order_data) == null ? void 0 : _b.dropoff, draftTicketDto.dropoff),
        ticket.orderData.dropoff
      ),
      cargo: draftTicketCargoMapper(
        getField((_c = draftTicketDto.order_data) == null ? void 0 : _c.cargo, draftTicketDto.cargo)
      ),
      vehicleType: getField((_d = draftTicketDto.order_data) == null ? void 0 : _d.vehicle_type, draftTicketDto.vehicle_type),
      complementaryInfo: {
        customerInternalReference: getField(
          (_f = (_e = draftTicketDto.order_data) == null ? void 0 : _e.complementary_info) == null ? void 0 : _f.customer_internal_reference,
          (_g = draftTicketDto.complementary_info) == null ? void 0 : _g.customer_internal_reference
        )
      }
    },
    shipperData: {
      companyId: (_h = draftTicketDto.shipper_data) == null ? void 0 : _h.company_id,
      companyName: (_i = draftTicketDto.shipper_data) == null ? void 0 : _i.company_name,
      contactName: (_j = draftTicketDto.shipper_data) == null ? void 0 : _j.contact_name,
      language: ((_k = draftTicketDto.shipper_data) == null ? void 0 : _k.language) ? draftTicketDto.shipper_data.language.toUpperCase() : void 0,
      email: (_l = draftTicketDto.shipper_data) == null ? void 0 : _l.email,
      phone: (_m = draftTicketDto.shipper_data) == null ? void 0 : _m.phone
    },
    quote: draftTicketDto.quote ? {
      id: draftTicketDto.quote.id,
      price: ((_n = draftTicketDto.quote.price) == null ? void 0 : _n.currency) && draftTicketDto.quote.price.formatted ? {
        amount: draftTicketDto.quote.price.amount,
        currency: draftTicketDto.quote.price.currency,
        formatted: draftTicketDto.quote.price.formatted
      } : void 0
    } : null
  };
}
function draftTicketAddressMapper(draftTicketAddressDto, ticketAddress) {
  if (draftTicketAddressDto) {
    if (!draftTicketAddressDto.date) {
      draftTicketAddressDto.date = ticketAddress.date;
    }
    if (!draftTicketAddressDto.time_from) {
      draftTicketAddressDto.time_from = ticketAddress.timeFrom || void 0;
    }
    if (!draftTicketAddressDto.time_to) {
      draftTicketAddressDto.time_to = ticketAddress.timeTo || void 0;
    }
    if (!draftTicketAddressDto.city) {
      draftTicketAddressDto.city = ticketAddress.city;
    }
    if (!draftTicketAddressDto.country) {
      draftTicketAddressDto.country = ticketAddress.country;
    }
    if (!draftTicketAddressDto.zipcode) {
      draftTicketAddressDto.zipcode = ticketAddress.zipcode;
    }
  }
  return draftTicketAddressDto ? {
    address: draftTicketAddressDto.address,
    city: draftTicketAddressDto.city,
    country: draftTicketAddressDto.country,
    zipcode: draftTicketAddressDto.zipcode,
    contact: draftTicketAddressDto.contact || draftTicketAddressDto.company_name,
    observations: draftTicketAddressDto.observations,
    date: draftTicketAddressDto.date,
    addressInfoFormatted: getDraftTicketAddressInfoFormatted(draftTicketAddressDto),
    dateFormatted: draftTicketAddressDto.date ? moment2(draftTicketAddressDto.date).format("DD/MM/YYYY") : void 0,
    timeFrom: draftTicketAddressDto.time_from ? ticketFormatTime(draftTicketAddressDto.time_from) : void 0,
    timeTo: draftTicketAddressDto.time_to ? ticketFormatTime(draftTicketAddressDto.time_to) : void 0,
    formattedDateTime: draftTicketAddressDto.date ? ticketFormatDateTime(
      draftTicketAddressDto.date,
      draftTicketAddressDto.time_from || "",
      draftTicketAddressDto.time_to || ""
    ) : void 0
  } : void 0;
}
function draftTicketCargoMapper(draftTicketCargoDto) {
  return draftTicketCargoDto ? {
    cargoType: draftTicketCargoDto.cargo_type,
    goodsType: draftTicketCargoDto.goods_type,
    varietyId: draftTicketCargoDto.variety_id,
    linearMeters: draftTicketCargoDto.linear_meters,
    numberOfPallets: draftTicketCargoDto.number_of_pallets,
    volume: draftTicketCargoDto.volume,
    weight: draftTicketCargoDto.weight
  } : void 0;
}
function getDraftTicketAddressInfoFormatted(address) {
  if (!address)
    return "";
  return `${address.city ? address.city : ""} ${address.zipcode ? address.zipcode : ""} ${address.country ? address.country : ""}`;
}

// src/business/tickets/mappers/conversation-mapper.ts
function ticketConversationMapper(conversationToMap, ticket) {
  if (!conversationToMap) {
    return null;
  }
  const draftTicket = draftTicketMapper(conversationToMap.draft_ticket, ticket);
  const draftSuggestions = getDraftSuggestions(draftTicket, ticket);
  const messages = conversationToMap.messages.map(messageMapper);
  let pendingMessage = false;
  if (messages.length > 0) {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage.author.role === "client") {
      const sawMessage = getTicketMessageViewed(ticket.id);
      if (lastMessage.id !== sawMessage) {
        pendingMessage = true;
      }
    } else {
      removeTicketMessageViewed(ticket.id);
    }
  }
  return {
    id: conversationToMap.id,
    channel: conversationToMap.channel,
    externalId: conversationToMap.external_id,
    draftMessage: conversationToMap.draft_message,
    subject: conversationToMap.subject,
    draftTicket,
    messages,
    draftSuggestions,
    pendingMessage
  };
}
function messageMapper(message) {
  var _a, _b;
  if (!message.content) {
    message.content = getTemporalMessage(message.id);
  } else {
    removeTemporalMessage(message.id);
  }
  return {
    id: message.id,
    externalId: message.external_id,
    content: message.content,
    attachments: (_b = (_a = message.attachments) == null ? void 0 : _a.map(attachmentMapper)) != null ? _b : [],
    author: {
      id: message.author.id,
      externalId: message.author.external_id,
      name: message.author.name,
      identifier: message.author.identifier,
      role: message.author.external_id ? "user" : "client"
    },
    createdAt: message.created_at
  };
}
function attachmentMapper(attachment) {
  return {
    id: attachment.id,
    filename: attachment.filename,
    contentType: attachment.content_type,
    size: attachment.size,
    fileUrl: attachment.file_url
  };
}
function getDraftSuggestions(draftTicket, ticket) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  const draftSuggestions = {
    pickup: createAddressSuggestion(
      {
        address: "PICKUP_ADDRESS" /* PickupAddress */,
        addressInfo: "PICKUP_ADDRESS_INFO" /* PickupAddressInfo */,
        date: "PICKUP_DATE" /* PickupDate */,
        observations: "PICKUP_OBSERVATIONS" /* PickupObservations */,
        contact: "PICKUP_CONTACT" /* PickupContact */
      },
      ticket.id,
      ticket.state,
      ticket.orderData.pickup,
      (_a = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _a.pickup
    ),
    dropoff: createAddressSuggestion(
      {
        address: "DROPOFF_ADDRESS" /* DropoffAddress */,
        addressInfo: "DROPOFF_ADDRESS_INFO" /* DropoffAddressInfo */,
        date: "DROPOFF_DATE" /* DropoffDate */,
        observations: "DROPOFF_OBSERVATIONS" /* DropoffObservations */,
        contact: "DROPOFF_CONTACT" /* DropoffContact */
      },
      ticket.id,
      ticket.state,
      ticket.orderData.dropoff,
      (_b = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _b.dropoff
    ),
    numberOfPallets: createSuggestion(
      "CARGO_NUMBER_OF_PALLETS" /* CargoNumberOfPallets */,
      ticket.id,
      ticket.state,
      (_d = (_c = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _c.cargo) == null ? void 0 : _d.numberOfPallets,
      ticket.orderData.cargo.numberOfPallets
    ),
    cargoType: createSuggestion(
      "CARGO_TYPE" /* CargoType */,
      ticket.id,
      ticket.state,
      (_f = (_e = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _e.cargo) == null ? void 0 : _f.cargoType,
      ticket.orderData.cargo.cargoType
    ),
    goodsType: createSuggestion(
      "CARGO_GOODS_TYPE" /* CargoGoodsType */,
      ticket.id,
      ticket.state,
      (_h = (_g = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _g.cargo) == null ? void 0 : _h.goodsType,
      ticket.orderData.cargo.goodsType
    ),
    varietyId: createSuggestion(
      "CARGO_VARIETY_ID" /* CargoVarietyId */,
      ticket.id,
      ticket.state,
      (_j = (_i = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _i.cargo) == null ? void 0 : _j.varietyId,
      ticket.orderData.cargo.varietyId
    ),
    linearMeters: createSuggestion(
      "CARGO_LINEAR_METERS" /* CargoLinearMeters */,
      ticket.id,
      ticket.state,
      (_l = (_k = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _k.cargo) == null ? void 0 : _l.linearMeters,
      ticket.orderData.cargo.linearMeters
    ),
    volume: createSuggestion(
      "CARGO_VOLUME" /* CargoVolume */,
      ticket.id,
      ticket.state,
      (_n = (_m = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _m.cargo) == null ? void 0 : _n.volume,
      ticket.orderData.cargo.volume
    ),
    weight: createSuggestion(
      "CARGO_WEIGHT" /* CargoWeight */,
      ticket.id,
      ticket.state,
      (_p = (_o = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _o.cargo) == null ? void 0 : _p.weight,
      ticket.orderData.cargo.weight
    ),
    vehicleType: createSuggestion(
      "VEHICLE_TYPE" /* VehicleType */,
      ticket.id,
      ticket.state,
      (_q = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _q.vehicleType,
      ticket.orderData.vehicleType
    ),
    shipperDataCompanyName: createSuggestion(
      "SHIPPER_DATA_COMPANY_NAME" /* ShipperDataCompanyName */,
      ticket.id,
      ticket.state,
      (_r = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _r.companyName,
      ticket.shipperData.companyName
    ),
    shipperDataContactName: createSuggestion(
      "SHIPPER_DATA_CONTACT_NAME" /* ShipperDataContactName */,
      ticket.id,
      ticket.state,
      (_s = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _s.contactName,
      ticket.shipperData.contactName
    ),
    shipperDataEmail: createSuggestion(
      "SHIPPER_DATA_EMAIL" /* ShipperDataEmail */,
      ticket.id,
      ticket.state,
      (_t = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _t.email,
      ticket.shipperData.email
    ),
    shipperDataPhone: createSuggestion(
      "SHIPPER_DATA_PHONE" /* ShipperDataPhone */,
      ticket.id,
      ticket.state,
      (_u = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _u.phone,
      ticket.shipperData.phone
    ),
    shipperDataLanguage: createSuggestion(
      "SHIPPER_DATA_LANGUAGE" /* ShipperDataLanguage */,
      ticket.id,
      ticket.state,
      (_v = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _v.language,
      ticket.shipperData.language
    ),
    shipperDataId: createSuggestion(
      "SHIPPER_DATA_ID" /* ShipperDataId */,
      ticket.id,
      ticket.state,
      (_w = draftTicket == null ? void 0 : draftTicket.shipperData) == null ? void 0 : _w.companyId,
      ticket.shipperData.companyId
    ),
    complementaryInfoExternalReference: createSuggestion(
      "COMPLEMENTARY_INFO_EXTERNAL_REFERENCE" /* ComplementaryInfoExternalReference */,
      ticket.id,
      ticket.state,
      (_y = (_x = draftTicket == null ? void 0 : draftTicket.orderData) == null ? void 0 : _x.complementaryInfo) == null ? void 0 : _y.customerInternalReference,
      ticket.orderData.complementaryInfo.customerInternalReference
    )
  };
  return Object.values(draftSuggestions).some(Boolean) ? draftSuggestions : void 0;
}
function createAddressSuggestion(storageKeys, ticketId, ticketState, ticketAddress, draftTicketAddress) {
  const suggestion = {
    address: createSuggestion(
      storageKeys.address,
      ticketId,
      ticketState,
      draftTicketAddress == null ? void 0 : draftTicketAddress.address,
      ticketAddress.address
    ),
    addressInfo: createSuggestion(
      storageKeys.addressInfo,
      ticketId,
      ticketState,
      draftTicketAddress == null ? void 0 : draftTicketAddress.addressInfoFormatted,
      ticketAddress.addressInfoFormatted
    ),
    formattedDateTime: createSuggestion(
      storageKeys.date,
      ticketId,
      ticketState,
      draftTicketAddress == null ? void 0 : draftTicketAddress.formattedDateTime,
      ticketAddress.formattedDateTime
    ),
    observations: createSuggestion(
      storageKeys.observations,
      ticketId,
      ticketState,
      draftTicketAddress == null ? void 0 : draftTicketAddress.observations,
      ticketAddress.observations
    ),
    contact: createSuggestion(
      storageKeys.contact,
      ticketId,
      ticketState,
      draftTicketAddress == null ? void 0 : draftTicketAddress.contact,
      ticketAddress.contact
    )
  };
  return Object.values(suggestion).some(Boolean) ? suggestion : void 0;
}
function createSuggestion(aiStorageDataKey, ticketId, ticketState, aiValue, ticketValue) {
  if (!checkIfTicketValIsValidSuggestion(
    aiStorageDataKey,
    ticketId,
    ticketState,
    ticketValue,
    aiValue
  )) {
    return void 0;
  }
  return {
    aiStorageDataKey,
    aiSuggestion: aiValue,
    ticketValue,
    activated: true
  };
}

// src/business/tickets/mappers/ticket-mapper.ts
function ticketMapper(ticketDto) {
  const momentDate = moment3(ticketDto.created_at);
  const momentModifiedDate = moment3(ticketDto.modified_at);
  const momentLastReceivedMessage = moment3(ticketDto.last_received_message);
  const ticket = {
    id: ticketDto.id,
    createdAt: momentDate.format("YYYY-MM-DD HH:mm:ss"),
    createdAtDate: momentDate.format("YYYY-MM-DD"),
    modifiedAt: momentModifiedDate.format("YYYY-MM-DD HH:mm:ss"),
    lastReceivedMessage: momentLastReceivedMessage.format("YYYY-MM-DD HH:mm:ss"),
    state: ticketDto.synthetic_state,
    shipperData: {
      companyId: ticketDto.shipper_data.company_id,
      companyName: ticketDto.shipper_data.company_name,
      contactName: ticketDto.shipper_data.contact_name,
      language: ticketDto.shipper_data.language ? ticketDto.shipper_data.language.toUpperCase() : "",
      phone: ticketDto.shipper_data.phone,
      email: ticketDto.shipper_data.email
    },
    createdBy: {
      firstName: ticketDto.created_by.first_name,
      lastName: ticketDto.created_by.last_name,
      id: ticketDto.created_by.id,
      url: ticketDto.created_by.url,
      username: ticketDto.created_by.username
    },
    assignedTo: ticketDto.assigned_to ? {
      firstName: ticketDto.assigned_to.first_name,
      lastName: ticketDto.assigned_to.last_name,
      id: ticketDto.assigned_to.id,
      url: ticketDto.assigned_to.url,
      username: ticketDto.assigned_to.username
    } : null,
    orderData: {
      pickup: ticketAddressMapper(ticketDto.order_data.pickup),
      dropoff: ticketAddressMapper(ticketDto.order_data.dropoff),
      cargo: ticketCargoMapper(ticketDto.order_data.cargo),
      vehicleType: ticketDto.order_data.vehicle_type,
      complementaryInfo: {
        customerInternalReference: ticketDto.order_data.complementary_info.customer_internal_reference
      }
    },
    quote: ticketQuoteMapper(ticketDto.quote)
  };
  if (ticketDto.conversation) {
    ticket.conversation = ticketConversationMapper(ticketDto.conversation, ticket);
  }
  return ticket;
}
function ticketQuoteMapper(ticketQuoteDto) {
  if (!ticketQuoteDto) {
    return void 0;
  }
  return {
    id: ticketQuoteDto.id,
    price: ticketPriceMapper(ticketQuoteDto.price),
    suggestedPrice: ticketQuoteDto.suggested_price ? ticketPriceMapper(ticketQuoteDto.suggested_price, true) : void 0,
    expirationReminderSent: ticketQuoteDto.expiration_reminder_sent
  };
}
function ticketPriceMapper(ticketPriceDto, isSuggestedPrice = false) {
  if (isSuggestedPrice) {
    ticketPriceDto.amount = roundAiPricing(ticketPriceDto.amount);
  }
  return {
    amount: ticketPriceDto.amount,
    currency: ticketPriceDto.currency,
    classification: ticketPriceDto.classification,
    formatted: formatPrice(ticketPriceDto.amount)
  };
}
function ticketAddressMapper(ticketAddressDto) {
  return {
    addressInfoFormatted: getTicketAddressInfoFormatted(ticketAddressDto),
    address: ticketAddressDto.address ? ticketAddressDto.address : "",
    city: ticketAddressDto.city ? ticketAddressDto.city : "",
    country: ticketAddressDto.country ? ticketAddressDto.country : "",
    zipcode: ticketAddressDto.zipcode ? ticketAddressDto.zipcode : "",
    contact: ticketAddressDto.contact || ticketAddressDto.company_name || "",
    observations: ticketAddressDto.observations ? ticketAddressDto.observations : "",
    date: ticketAddressDto.date,
    dateFormatted: ticketAddressDto.date ? moment3(ticketAddressDto.date).format("DD/MM/YYYY") : "",
    timeFrom: ticketFormatTime(ticketAddressDto.time_from),
    timeTo: ticketFormatTime(ticketAddressDto.time_to),
    formattedDateTime: ticketFormatDateTime(
      ticketAddressDto.date,
      ticketAddressDto.time_from,
      ticketAddressDto.time_to
    )
  };
}
function ticketCargoMapper(ticketCargoDto) {
  var _a, _b;
  return {
    billingReference: ticketCargoDto.billing_reference,
    cargoType: ticketCargoDto.cargo_type,
    goodsType: (_a = ticketCargoDto.goods_type) != null ? _a : null,
    varietyId: (_b = ticketCargoDto.variety_id) != null ? _b : null,
    linearMeters: ticketCargoDto.linear_meters,
    loadingReference: ticketCargoDto.loading_reference,
    numberOfPallets: ticketCargoDto.number_of_pallets,
    temperature: ticketCargoDto.temperature,
    volume: ticketCargoDto.volume,
    weight: ticketCargoDto.weight
  };
}
function getTicketAddressInfoFormatted(address) {
  return `${address.city ? address.city : ""} ${address.zipcode ? address.zipcode : ""} ${address.country ? address.country : ""}`;
}

// src/business/tickets/hooks/get-ticket-hook.ts
var RELOAD_TICKET_INTERVAL_IN_SECONDS = 10;
function useGetTicketHook({ ticketId }) {
  const key = `copilot/tickets/${JSON.stringify(ticketId)}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(this, null, function* () {
    return getTicketApi(config2, ticketId);
  });
  const { data, error, isLoading } = useSWR(key, fetcher, {
    refreshInterval: RELOAD_TICKET_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const refreshData = () => __async(this, null, function* () {
    const updatedData = yield mutate(key);
    return updatedData ? ticketMapper(updatedData) : null;
  });
  const ticket = data ? ticketMapper(data) : null;
  return {
    refreshData,
    ticket,
    isLoading,
    error,
    config: config2
  };
}

// src/business/tickets/api/set-ticket-api.ts
import { toast as toast2 } from "sonner";
function setTicketApi(_0, _1, _2) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket, oldTicket) {
    try {
      const data = {
        order_data: {}
      };
      const pickupChanges = processedTicketAddressChanges2(
        ticket.orderData.pickup,
        oldTicket.orderData.pickup
      );
      if (pickupChanges) {
        data.order_data.pickup = pickupChanges;
      }
      const dropoffChanges = processedTicketAddressChanges2(
        ticket.orderData.dropoff,
        oldTicket.orderData.dropoff
      );
      if (dropoffChanges) {
        data.order_data.dropoff = dropoffChanges;
      }
      const cargoChanges = processedTicketCargoChanges2(
        ticket.orderData.cargo,
        oldTicket.orderData.cargo
      );
      if (cargoChanges) {
        data.order_data.cargo = cargoChanges;
      }
      const shipperDataChanges = processedShipperDataChanges2(
        ticket.shipperData,
        oldTicket.shipperData
      );
      if (shipperDataChanges) {
        data.shipper_data = shipperDataChanges;
      }
      if (ticket.orderData.complementaryInfo.customerInternalReference !== oldTicket.orderData.complementaryInfo.customerInternalReference) {
        data.order_data.complementary_info = {
          customer_internal_reference: ticket.orderData.complementaryInfo.customerInternalReference
        };
      }
      if (ticket.orderData.vehicleType !== oldTicket.orderData.vehicleType) {
        data.order_data.vehicle_type = ticket.orderData.vehicleType;
      }
      const baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/`;
      const response = yield fetch(baseURL, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        return returnError();
      }
      return response.status === 200;
    } catch (error) {
      return returnError();
    }
  });
}
function returnError() {
  toast2.error("Ha ocurrido un error al actualizar la cotizaci\xF3n.");
  return false;
}
function processedShipperDataChanges2(newShipperData, oldShipperData) {
  const data = {};
  if (newShipperData.companyId !== oldShipperData.companyId) {
    data.company_id = newShipperData.companyId;
  }
  if (newShipperData.companyName !== oldShipperData.companyName) {
    data.company_name = newShipperData.companyName;
  }
  if (newShipperData.contactName !== oldShipperData.contactName) {
    data.contact_name = newShipperData.contactName;
  }
  if (newShipperData.language !== oldShipperData.language) {
    data.language = newShipperData.language;
  }
  if (newShipperData.email !== oldShipperData.email) {
    data.email = newShipperData.email;
  }
  if (newShipperData.phone !== oldShipperData.phone) {
    data.phone = newShipperData.phone;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}
function processedTicketAddressChanges2(newAddress, oldAddress) {
  const data = {};
  if (newAddress.date !== oldAddress.date) {
    data.date = newAddress.date ? newAddress.date : null;
  }
  if (newAddress.timeFrom !== oldAddress.timeFrom) {
    data.time_from = newAddress.timeFrom ? `${newAddress.timeFrom}:00` : null;
  }
  if (newAddress.timeTo !== oldAddress.timeTo) {
    data.time_to = newAddress.timeTo ? `${newAddress.timeTo}:00` : null;
  }
  if (newAddress.country !== oldAddress.country) {
    data.country = newAddress.country;
  }
  if (newAddress.zipcode !== oldAddress.zipcode) {
    data.zipcode = newAddress.zipcode;
  }
  if (newAddress.address !== oldAddress.address) {
    data.address = newAddress.address;
  }
  if (newAddress.city !== oldAddress.city) {
    data.city = newAddress.city;
  }
  if (newAddress.observations !== oldAddress.observations) {
    data.observations = newAddress.observations;
  }
  if (newAddress.contact !== oldAddress.contact) {
    data.contact = newAddress.contact;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}
function processedTicketCargoChanges2(newCargo, oldCargo) {
  const data = {};
  if (newCargo.weight !== oldCargo.weight) {
    data.weight = newCargo.weight ? Number(newCargo.weight) : null;
  }
  if (newCargo.linearMeters !== oldCargo.linearMeters) {
    data.linear_meters = newCargo.linearMeters ? Number(newCargo.linearMeters) : null;
  }
  if (newCargo.volume !== oldCargo.volume) {
    data.volume = newCargo.volume ? Number(newCargo.volume) : null;
  }
  if (newCargo.numberOfPallets !== oldCargo.numberOfPallets) {
    data.number_of_pallets = newCargo.numberOfPallets ? Number(newCargo.numberOfPallets) : null;
  }
  if (newCargo.cargoType !== oldCargo.cargoType) {
    data.cargo_type = newCargo.cargoType;
  }
  if (newCargo.goodsType !== oldCargo.goodsType) {
    data.goods_type = newCargo.goodsType;
  }
  if (newCargo.varietyId !== oldCargo.varietyId) {
    data.variety_id = newCargo.varietyId;
  }
  return Object.keys(data).length > 0 ? data : void 0;
}

// src/business/tickets/api/set-ticket-price-api.ts
import { toast as toast3 } from "sonner";
function setTicketPriceApi(_0, _1, _2) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket, aiPricing) {
    if (!ticket.quote) {
      return false;
    }
    try {
      let suggestedPrice = {
        amount: 0,
        currency: "EUR"
      };
      if (aiPricing == null ? void 0 : aiPricing.price) {
        suggestedPrice = { amount: aiPricing.price.amount, currency: aiPricing.price.currency };
      } else if (ticket.quote.suggestedPrice) {
        suggestedPrice = {
          amount: ticket.quote.suggestedPrice.amount,
          currency: ticket.quote.suggestedPrice.currency
        };
      }
      const data = {
        price: {
          amount: ticket.quote.price.amount,
          currency: ticket.quote.price.currency
        },
        price_suggestion_id: aiPricing == null ? void 0 : aiPricing.id,
        suggested_price: suggestedPrice,
        ticket_id: ticket.id,
        order_data: {
          pickup: {
            date: ticket.orderData.pickup.date,
            time_from: ticket.orderData.pickup.timeFrom ? `${ticket.orderData.pickup.timeFrom}:00` : null,
            time_to: ticket.orderData.pickup.timeTo ? `${ticket.orderData.pickup.timeTo}:00` : null,
            country: ticket.orderData.pickup.country,
            zipcode: ticket.orderData.pickup.zipcode,
            address: ticket.orderData.pickup.address,
            city: ticket.orderData.pickup.city,
            contact: ticket.orderData.pickup.contact,
            observations: ticket.orderData.pickup.observations
          },
          dropoff: {
            date: ticket.orderData.dropoff.date,
            time_from: ticket.orderData.dropoff.timeFrom ? `${ticket.orderData.dropoff.timeFrom}:00` : null,
            time_to: ticket.orderData.dropoff.timeTo ? `${ticket.orderData.dropoff.timeTo}:00` : null,
            country: ticket.orderData.dropoff.country,
            zipcode: ticket.orderData.dropoff.zipcode,
            address: ticket.orderData.dropoff.address,
            city: ticket.orderData.dropoff.city,
            contact: ticket.orderData.dropoff.contact,
            observations: ticket.orderData.dropoff.observations
          },
          cargo: {
            weight: ticket.orderData.cargo.weight ? ticket.orderData.cargo.weight : null,
            linear_meters: ticket.orderData.cargo.linearMeters ? ticket.orderData.cargo.linearMeters : null,
            volume: ticket.orderData.cargo.volume ? ticket.orderData.cargo.volume : null,
            number_of_pallets: ticket.orderData.cargo.numberOfPallets ? ticket.orderData.cargo.numberOfPallets : null,
            cargo_type: ticket.orderData.cargo.cargoType,
            billing_reference: ticket.orderData.cargo.billingReference,
            loading_reference: ticket.orderData.cargo.loadingReference,
            temperature: ticket.orderData.cargo.temperature,
            max_height: 0
          },
          vehicle_type: ticket.orderData.vehicleType
        },
        quote: {
          price: {
            amount: ticket.quote.price.amount,
            currency: ticket.quote.price.currency
          }
        }
      };
      const baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/quotes/`;
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        return returnError2();
      }
      return response.status === 200;
    } catch (error) {
      return returnError2();
    }
  });
}
function returnError2() {
  toast3.error("Ha ocurrido un error al actualizar el precio de la cotizaci\xF3n.");
  return false;
}

// src/business/tickets/api/set-ticket-status-api.ts
import { toast as toast4 } from "sonner";
function setTicketStatusApi(_0, _1, _2, _3) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket, state, feedBackDTO) {
    var _a;
    try {
      let baseURL = "";
      const params = {
        id: ticket.id,
        feedback: {
          stars: 0,
          reasons: [
            {
              category: "OTHER"
            }
          ]
        }
      };
      if (feedBackDTO) {
        params.feedback = feedBackDTO;
      }
      if (state === "CANCELLED" /* CANCELLED */) {
        baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/cancellations/`;
      }
      if (state === "ACCEPTED" /* ACCEPTED */ || state === "REJECTED" /* REJECTED */) {
        if (!((_a = ticket.quote) == null ? void 0 : _a.id)) {
          return false;
        }
        if (state === "ACCEPTED" /* ACCEPTED */) {
          baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/quotes/${ticket.quote.id}/acceptances/`;
        }
        if (state === "REJECTED" /* REJECTED */) {
          baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/quotes/${ticket.quote.id}/rejections/`;
        }
      }
      if (!baseURL) {
        return false;
      }
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(params)
      });
      if (!response.ok) {
        return returnError3();
      }
      return response.status === 200 || response.status === 204;
    } catch (error) {
      return returnError3();
    }
  });
}
function returnError3() {
  toast4.error("Ha ocurrido un error al actualizar el estado de la cotizaci\xF3n.");
  return false;
}

// src/business/tickets/api/generate-ticket-confirmation-api.ts
import { toast as toast5 } from "sonner";
function generateTicketConfirmationApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket) {
    var _a;
    if (!((_a = ticket.quote) == null ? void 0 : _a.price.amount)) {
      return "";
    }
    try {
      const baseURL = `${apiBase}/api/copilot/ticket/${ticket.id}/summary/`;
      const params = {
        suggested_price: ticket.quote.price.amount
      };
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(params)
      });
      const data = yield response.json();
      if (!response.ok) {
        return returnError4();
      }
      return data.response;
    } catch (error) {
      return returnError4();
    }
  });
}
function returnError4() {
  toast5.error("Ha ocurrido un error al generar la confirmaci\xF3n. Por favor, int\xE9ntelo m\xE1s tarde.");
  return "";
}

// src/business/tickets/api/send-ticket-message-api.ts
import { toast as toast6 } from "sonner";
import { cloneDeep } from "lodash";
function sendTicketMessageApi(_0, _1, _2) {
  return __async(this, arguments, function* ({ token, apiBase }, conversation, message) {
    if (!conversation || conversation.messages.length === 0) {
      return false;
    }
    try {
      const lastMessage = cloneDeep(conversation.messages[conversation.messages.length - 1]);
      const lastClientMessage = cloneDeep(conversation.messages).reverse().find((m) => m.author.role === "client");
      if (!lastClientMessage) {
        return false;
      }
      const baseURL = `${apiBase}/api/channel/email/message/`;
      const params = {
        subject: conversation.subject,
        content: message,
        name_to: lastClientMessage.author.name,
        email_to: lastClientMessage.author.identifier,
        conversation_external_id: conversation.externalId,
        in_reply_to_message_external_id: lastMessage.externalId
      };
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(params)
      });
      if (!response.ok) {
        return returnError5();
      }
      return response.status === 200;
    } catch (error) {
      return returnError5();
    }
  });
}
function returnError5() {
  toast6.error("Ha ocurrido un error al enviar el mensaje.");
  return false;
}

// src/business/tickets/api/move-ticket-to-tms-api.ts
import { toast as toast7 } from "sonner";
function moveTicketToTmsApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, ticket) {
    try {
      const randomOrderId = `ORD-${Date.now()}-${Math.random().toString(36).substring(2, 9).toUpperCase()}`;
      const orderIdDTO = {
        order_id: randomOrderId
      };
      const baseURL = `${apiBase}/v1/price-negotiation/tickets/${ticket.id}/completions/`;
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(orderIdDTO)
      });
      if (!response.ok) {
        const errorText = yield response.text();
        console.error("[Move to TMS API] Error response:", errorText);
        return returnError6(errorText);
      }
      const successText = yield response.text();
      const successMessage = extractSuccessMessage(successText);
      toast7.success(successMessage);
      return response.status === 200 || response.status === 201 || response.status === 204;
    } catch (error) {
      console.error("[Move to TMS API] Exception:", error);
      return returnError6();
    }
  });
}
function extractSuccessMessage(successText) {
  var _a, _b;
  const fallbackMessage = "Ticket movido a TMS correctamente.";
  if (!(successText == null ? void 0 : successText.trim()))
    return fallbackMessage;
  try {
    const parsed = JSON.parse(successText);
    const message = (_b = (_a = parsed.mensaje) != null ? _a : parsed.detail) != null ? _b : parsed.message;
    if (typeof message === "string" && message.trim())
      return message;
  } catch (e) {
  }
  return fallbackMessage;
}
function extractErrorMessage(errorText) {
  var _a, _b, _c;
  if (!errorText)
    return "Ha ocurrido un error al mover el ticket a TMS.";
  try {
    const parsed = JSON.parse(errorText);
    const detail = (_c = (_b = (_a = parsed.mensaje) != null ? _a : parsed.detail) != null ? _b : parsed.message) != null ? _c : parsed.error;
    if (typeof detail === "string" && detail.trim())
      return detail;
    if (Array.isArray(detail) && typeof detail[0] === "string")
      return detail[0];
  } catch (e) {
  }
  return errorText.trim() || "Ha ocurrido un error al mover el ticket a TMS.";
}
function returnError6(errorText) {
  toast7.error(extractErrorMessage(errorText));
  return false;
}

// src/business/tickets/api/request-missing-info-api.ts
import { toast as toast8 } from "sonner";
function requestMissingInfoApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, ticketId) {
    try {
      const baseURL = `${apiBase}/api/copilot/ticket/${ticketId}/missing-info/`;
      const response = yield fetch(baseURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) {
        return returnError7();
      }
      const data = yield response.json();
      return data.response;
    } catch (error) {
      return returnError7();
    }
  });
}
function returnError7() {
  toast8.error("Ha ocurrido un error al generar la solicitud de datos.");
  return "";
}

// src/business/tickets/hooks/use-ticket-quote-validation.ts
import { useMemo } from "react";
var ALLOWED_STATES_FOR_QUOTE_CREATION = [
  "DRAFT" /* DRAFT */,
  "PENDING" /* PENDING */,
  "REJECTED" /* REJECTED */
];
var ALLOWED_STATES_FOR_TICKET_EDITING = [
  "DRAFT" /* DRAFT */,
  "PENDING" /* PENDING */,
  "REJECTED" /* REJECTED */,
  "ACCEPTED" /* ACCEPTED */
];
function hasAiPricingRequisites(ticket) {
  if (!ticket) {
    return false;
  }
  const hasPickupAddress = Boolean(
    ticket.orderData.pickup.zipcode && ticket.orderData.pickup.zipcode.trim() !== "" && ticket.orderData.pickup.country && ticket.orderData.pickup.country.trim() !== ""
  );
  const hasPickupDate = Boolean(ticket.orderData.pickup.formattedDateTime);
  const hasDropoffAddress = Boolean(
    ticket.orderData.dropoff.zipcode && ticket.orderData.dropoff.zipcode.trim() !== "" && ticket.orderData.dropoff.country && ticket.orderData.dropoff.country.trim() !== ""
  );
  const hasDropoffDate = Boolean(ticket.orderData.dropoff.formattedDateTime);
  const hasNumberOfPallets = Boolean(
    ticket.orderData.cargo.numberOfPallets && Number(ticket.orderData.cargo.numberOfPallets) > 0
  );
  const hasVehicleType = Boolean(
    ticket.orderData.vehicleType && ticket.orderData.vehicleType.trim() !== ""
  );
  const hasCargoType = Boolean(
    ticket.orderData.cargo.cargoType && ticket.orderData.cargo.cargoType.trim() !== ""
  );
  const hasGoodsType = Boolean(ticket.orderData.cargo.goodsType);
  const hasVarietyId = Boolean(ticket.orderData.cargo.varietyId);
  const allRequisitesMet = hasPickupAddress && hasPickupDate && hasDropoffAddress && hasDropoffDate && hasNumberOfPallets && hasVehicleType && hasCargoType && hasGoodsType && hasVarietyId;
  return allRequisitesMet;
}
function isTicketEditable(ticket) {
  if (!ticket) {
    return false;
  }
  const isAllowed = ALLOWED_STATES_FOR_TICKET_EDITING.includes(ticket.state);
  return isAllowed;
}
function isTicketInQuoteEditableState(ticket) {
  if (!ticket) {
    return false;
  }
  const isAllowed = ALLOWED_STATES_FOR_QUOTE_CREATION.includes(ticket.state);
  return isAllowed;
}
function shouldCreateOrUpdateQuote(ticket, aiPriceValidation) {
  var _a, _b;
  if (!ticket) {
    return false;
  }
  const isInAllowedState = isTicketInQuoteEditableState(ticket);
  const hasPrice = Boolean((_a = ticket.quote) == null ? void 0 : _a.price.amount);
  const requisitesMet = (_b = aiPriceValidation == null ? void 0 : aiPriceValidation.isValid) != null ? _b : hasAiPricingRequisites(ticket);
  const shouldCreate = isInAllowedState && hasPrice && requisitesMet;
  return shouldCreate;
}
function useTicketQuoteValidation(ticket, aiPriceValidation) {
  return useMemo(() => {
    const validation = {
      canEdit: isTicketEditable(ticket),
      canEditQuote: isTicketInQuoteEditableState(ticket),
      shouldCreateQuote: shouldCreateOrUpdateQuote(ticket, aiPriceValidation),
      allowedStates: ALLOWED_STATES_FOR_QUOTE_CREATION
    };
    return validation;
  }, [ticket, aiPriceValidation]);
}

// src/business/tickets/hooks/set-ticket-hook.ts
function useSetTicketHook() {
  const config2 = useConfigHook();
  function setTicket(ticket, oldTicket) {
    return __async(this, null, function* () {
      var _a;
      yield setTicketApi(config2, ticket, oldTicket);
      if (shouldCreateOrUpdateQuote(ticket)) {
        let aiPricing = null;
        if ((_a = ticket.quote) == null ? void 0 : _a.price) {
          try {
            aiPricing = yield getTicketAiPriceApi(config2, ticket);
          } catch (error) {
            console.error("Error getting ticket AI price:", error);
          }
        }
        yield setTicketPriceApi(config2, ticket, aiPricing);
      }
      return true;
    });
  }
  function setTicketStatus(ticket, state) {
    return __async(this, null, function* () {
      yield setTicketStatusApi(config2, ticket, state);
      return true;
    });
  }
  function generateTicketConfirmation(ticket) {
    return __async(this, null, function* () {
      const confirmationString = yield generateTicketConfirmationApi(config2, ticket);
      return confirmationString;
    });
  }
  function sendTicketMessage(conversation, message) {
    return __async(this, null, function* () {
      yield sendTicketMessageApi(config2, conversation, message);
      return true;
    });
  }
  function requestMissingInfo(ticketId) {
    return __async(this, null, function* () {
      const message = yield requestMissingInfoApi(config2, ticketId);
      return message;
    });
  }
  function moveTicketToTms(ticket) {
    return __async(this, null, function* () {
      const success = yield moveTicketToTmsApi(config2, ticket);
      return success;
    });
  }
  return {
    setTicket,
    setTicketStatus,
    generateTicketConfirmation,
    sendTicketMessage,
    requestMissingInfo,
    moveTicketToTms
  };
}

// src/translations/alianza-translations-provider.tsx
import React, { createContext as createContext2, useContext as useContext2 } from "react";
var AlianzaTranslationsContext = createContext2(null);
function AlianzaTranslationsProvider({
  translations,
  children
}) {
  return /* @__PURE__ */ React.createElement(AlianzaTranslationsContext.Provider, { value: translations }, children);
}
function useAlianzaTranslations() {
  const translations = useContext2(AlianzaTranslationsContext);
  if (!translations) {
    throw new Error("useAlianzaTranslations must be used within an AlianzaTranslationsProvider");
  }
  return translations;
}

// src/business/tickets/hooks/use-ticket-ai-price-validation.ts
import { useMemo as useMemo2 } from "react";
function useTicketAiPriceValidation(ticket) {
  const shouldShow = useMemo2(() => {
    if (!ticket)
      return false;
    return [
      "PENDING" /* PENDING */,
      "DRAFT" /* DRAFT */,
      "QUOTE_SENT" /* QUOTESENT */,
      "REJECTED" /* REJECTED */
    ].includes(ticket.state);
  }, [ticket]);
  const fieldValidations = useMemo2(() => {
    if (!ticket) {
      return {
        isPickupAddressMissing: false,
        isPickupDateMissing: false,
        isDropoffAddressMissing: false,
        isDropoffDateMissing: false,
        isNumberPalletsMissing: false,
        isVehicleTypeMissing: false,
        isCargoTypeMissing: false,
        isGoodsTypeMissing: false,
        isVarietyIdMissing: false
      };
    }
    const isPickupAddressMissing = !checkAddressInfo(
      ticket.orderData.pickup.zipcode,
      ticket.orderData.pickup.country
    );
    const isPickupDateMissing = !checkDate(ticket.orderData.pickup.formattedDateTime);
    const isDropoffAddressMissing = !checkAddressInfo(
      ticket.orderData.dropoff.zipcode,
      ticket.orderData.dropoff.country
    );
    const isDropoffDateMissing = !checkDate(ticket.orderData.dropoff.formattedDateTime);
    const isNumberPalletsMissing = !checkNumberOfPallets(ticket.orderData.cargo.numberOfPallets);
    const isVehicleTypeMissing = !checkVehicleType(ticket.orderData.vehicleType);
    const isCargoTypeMissing = !checkCargoType(ticket.orderData.cargo.cargoType);
    const isGoodsTypeMissing = !checkIdentifier(ticket.orderData.cargo.goodsType);
    const isVarietyIdMissing = !checkIdentifier(ticket.orderData.cargo.varietyId);
    return {
      isPickupAddressMissing,
      isPickupDateMissing,
      isDropoffAddressMissing,
      isDropoffDateMissing,
      isNumberPalletsMissing,
      isVehicleTypeMissing,
      isCargoTypeMissing,
      isGoodsTypeMissing,
      isVarietyIdMissing
    };
  }, [ticket]);
  const { requiredFieldsCount, validFieldsCount } = useMemo2(() => {
    const totalRequired = 9;
    let missingCount = 0;
    if (fieldValidations.isPickupAddressMissing)
      missingCount++;
    if (fieldValidations.isPickupDateMissing)
      missingCount++;
    if (fieldValidations.isDropoffAddressMissing)
      missingCount++;
    if (fieldValidations.isDropoffDateMissing)
      missingCount++;
    if (fieldValidations.isNumberPalletsMissing)
      missingCount++;
    if (fieldValidations.isVehicleTypeMissing)
      missingCount++;
    if (fieldValidations.isCargoTypeMissing)
      missingCount++;
    if (fieldValidations.isGoodsTypeMissing)
      missingCount++;
    if (fieldValidations.isVarietyIdMissing)
      missingCount++;
    return {
      requiredFieldsCount: totalRequired,
      validFieldsCount: totalRequired - missingCount
    };
  }, [fieldValidations]);
  const isValid = useMemo2(() => {
    if (!ticket)
      return false;
    const validStates = [
      "PENDING" /* PENDING */,
      "DRAFT" /* DRAFT */,
      "QUOTE_SENT" /* QUOTESENT */,
      "REJECTED" /* REJECTED */,
      "ACCEPTED" /* ACCEPTED */
    ];
    return validStates.includes(ticket.state) && !fieldValidations.isPickupAddressMissing && !fieldValidations.isPickupDateMissing && !fieldValidations.isDropoffAddressMissing && !fieldValidations.isDropoffDateMissing && !fieldValidations.isNumberPalletsMissing && !fieldValidations.isVehicleTypeMissing && !fieldValidations.isCargoTypeMissing && !fieldValidations.isGoodsTypeMissing && !fieldValidations.isVarietyIdMissing;
  }, [ticket, fieldValidations]);
  return {
    shouldShow,
    isValid,
    requiredFieldsCount,
    validFieldsCount,
    fieldValidations
  };
}
function checkAddressInfo(zipcode, country) {
  return Boolean(
    zipcode && zipcode.trim() !== "-" && zipcode.trim() !== "" && country && country.trim() !== "-" && country.trim() !== ""
  );
}
function checkDate(date) {
  return Boolean(date && date.trim() !== "-" && date.trim() !== "");
}
function checkNumberOfPallets(numberOfPallets) {
  if (!numberOfPallets)
    return false;
  if (typeof numberOfPallets === "string") {
    return numberOfPallets.trim() !== "-" && numberOfPallets.trim() !== "";
  }
  if (typeof numberOfPallets === "number") {
    return numberOfPallets > 0;
  }
  return false;
}
function checkVehicleType(vehicleType) {
  return Boolean(vehicleType && vehicleType.trim() !== "-" && vehicleType.trim() !== "");
}
function checkCargoType(cargoType) {
  return Boolean(cargoType && cargoType.trim() !== "-" && cargoType.trim() !== "");
}
function checkIdentifier(value) {
  return typeof value === "number" && value > 0;
}

// src/business/tickets/hooks/use-ticket-expedient-validation.ts
import { useMemo as useMemo3 } from "react";
function useTicketExpedientValidation(ticket) {
  const shouldShow = useMemo3(() => {
    var _a;
    if (!ticket)
      return false;
    return ticket.state === "ACCEPTED" /* ACCEPTED */ && Boolean((_a = ticket.quote) == null ? void 0 : _a.price.amount);
  }, [ticket]);
  const fieldValidations = useMemo3(() => {
    if (!ticket) {
      return {
        isShipperIdMissing: false,
        isPickupAddressMissing: false,
        isPickupCompanyNameMissing: false,
        isPickupTimeFromMissing: false,
        isPickupTimeToMissing: false,
        isPickupTimeMissing: false,
        isDropoffAddressMissing: false,
        isDropoffCompanyNameMissing: false,
        isDropoffTimeFromMissing: false,
        isDropoffTimeToMissing: false,
        isDropoffTimeMissing: false,
        isCargoWeightMissing: false,
        isGoodsTypeMissing: false,
        isVarietyIdMissing: false
      };
    }
    const isShipperIdMissing = !checkStringField(ticket.shipperData.companyId);
    const isPickupAddressMissing = !checkStringField(ticket.orderData.pickup.address);
    const isPickupCompanyNameMissing = !checkStringField(ticket.orderData.pickup.contact);
    const isPickupTimeFromMissing = !checkStringField(ticket.orderData.pickup.timeFrom);
    const isPickupTimeToMissing = !checkStringField(ticket.orderData.pickup.timeTo);
    const isPickupTimeMissing = isPickupTimeFromMissing || isPickupTimeToMissing;
    const isDropoffAddressMissing = !checkStringField(ticket.orderData.dropoff.address);
    const isDropoffCompanyNameMissing = !checkStringField(ticket.orderData.dropoff.contact);
    const isDropoffTimeFromMissing = !checkStringField(ticket.orderData.dropoff.timeFrom);
    const isDropoffTimeToMissing = !checkStringField(ticket.orderData.dropoff.timeTo);
    const isDropoffTimeMissing = isDropoffTimeFromMissing || isDropoffTimeToMissing;
    const isCargoWeightMissing = !checkWeight(ticket.orderData.cargo.weight);
    const isGoodsTypeMissing = !ticket.orderData.cargo.goodsType;
    const isVarietyIdMissing = !ticket.orderData.cargo.varietyId;
    return {
      isShipperIdMissing,
      isPickupAddressMissing,
      isPickupCompanyNameMissing,
      isPickupTimeFromMissing,
      isPickupTimeToMissing,
      isPickupTimeMissing,
      isDropoffAddressMissing,
      isDropoffCompanyNameMissing,
      isDropoffTimeFromMissing,
      isDropoffTimeToMissing,
      isDropoffTimeMissing,
      isCargoWeightMissing,
      isGoodsTypeMissing,
      isVarietyIdMissing
    };
  }, [ticket]);
  const { requiredFieldsCount, validFieldsCount } = useMemo3(() => {
    const totalRequired = 10;
    let missingCount = 0;
    if (fieldValidations.isShipperIdMissing)
      missingCount++;
    if (fieldValidations.isPickupAddressMissing)
      missingCount++;
    if (fieldValidations.isPickupCompanyNameMissing)
      missingCount++;
    if (fieldValidations.isPickupTimeMissing)
      missingCount++;
    if (fieldValidations.isDropoffAddressMissing)
      missingCount++;
    if (fieldValidations.isDropoffCompanyNameMissing)
      missingCount++;
    if (fieldValidations.isDropoffTimeMissing)
      missingCount++;
    if (fieldValidations.isCargoWeightMissing)
      missingCount++;
    if (fieldValidations.isGoodsTypeMissing)
      missingCount++;
    if (fieldValidations.isVarietyIdMissing)
      missingCount++;
    return {
      requiredFieldsCount: totalRequired,
      validFieldsCount: totalRequired - missingCount
    };
  }, [fieldValidations]);
  const isValid = useMemo3(() => {
    var _a;
    if (!ticket)
      return false;
    return ticket.state === "ACCEPTED" /* ACCEPTED */ && Boolean((_a = ticket.quote) == null ? void 0 : _a.price.amount) && !fieldValidations.isShipperIdMissing && !fieldValidations.isPickupAddressMissing && !fieldValidations.isPickupCompanyNameMissing && !fieldValidations.isPickupTimeFromMissing && !fieldValidations.isPickupTimeToMissing && !fieldValidations.isDropoffAddressMissing && !fieldValidations.isDropoffCompanyNameMissing && !fieldValidations.isDropoffTimeFromMissing && !fieldValidations.isDropoffTimeToMissing && !fieldValidations.isCargoWeightMissing && !fieldValidations.isGoodsTypeMissing && !fieldValidations.isVarietyIdMissing;
  }, [ticket, fieldValidations]);
  return {
    shouldShow,
    isValid,
    requiredFieldsCount,
    validFieldsCount,
    fieldValidations
  };
}
function checkStringField(value) {
  return Boolean(value && value.trim() !== "" && value.trim() !== "-");
}
function checkWeight(weight) {
  if (!weight)
    return false;
  if (typeof weight === "string") {
    return weight.trim() !== "-" && weight.trim() !== "";
  }
  if (typeof weight === "number") {
    return weight > 0;
  }
  return false;
}

// src/business/tickets/hooks/use-ticket-dynamic-action.ts
import { useMemo as useMemo4 } from "react";
function useTicketDynamicAction(ticket, aiPriceValidation, expedientValidation) {
  const translations = useAlianzaTranslations();
  return useMemo4(() => {
    var _a;
    if (!ticket) {
      return { type: null, label: "", enabled: false };
    }
    const hasPrice = Boolean((_a = ticket.quote) == null ? void 0 : _a.price.amount);
    const isQuoteSent = ticket.state === "QUOTE_SENT" /* QUOTESENT */;
    const isRejected = ticket.state === "REJECTED" /* REJECTED */;
    const isAccepted = ticket.state === "ACCEPTED" /* ACCEPTED */;
    const isPendingOrDraft = ["PENDING" /* PENDING */, "DRAFT" /* DRAFT */].includes(ticket.state);
    const canGenerateQuote = isPendingOrDraft || isQuoteSent || isRejected;
    if (isAccepted && !expedientValidation.isValid) {
      return {
        type: "request_missing_info",
        label: translations.chat.requestMissingInfoForExpedient,
        enabled: true
      };
    }
    if (canGenerateQuote && hasPrice) {
      return {
        type: "generate_quote",
        label: translations.chat.generateQuote,
        enabled: true
      };
    }
    if (isPendingOrDraft && !aiPriceValidation.isValid) {
      return {
        type: "request_missing_info",
        label: translations.chat.requestMissingInfoForPrice,
        enabled: true
      };
    }
    return { type: null, label: "", enabled: false };
  }, [ticket, aiPriceValidation, expedientValidation, translations]);
}

// src/business/tickets/utils/parse-ai-price-errors.ts
function parseAiPriceErrors(errorData) {
  try {
    const parsed = JSON.parse(errorData);
    if (!parsed || typeof parsed !== "object" || !("errors" in parsed) || !Array.isArray(parsed.errors)) {
      return [errorData];
    }
    const errorResponse = parsed;
    const details = [];
    for (const error of errorResponse.errors) {
      if (error.detail) {
        details.push(error.detail);
      }
    }
    return details.length > 0 ? details : [errorData];
  } catch (e) {
    return [errorData];
  }
}

// src/pages/ticket/components/summary/summary-component.tsx
import {
  ButtonComponent,
  DateInputComponent,
  FlexComponent as FlexComponent2,
  Input,
  SelectWithInternalSearchInputComponent,
  SemaphoreInputComponent,
  TextComponent
} from "@ontruck/fe-ui";
import React3, { useMemo as useMemo6, useState } from "react";
import styled4 from "styled-components";
import moment4 from "moment";
import { cloneDeep as cloneDeep2 } from "lodash";
import {
  CircleCheckNoBackgroundIcon,
  CircleDashIcon,
  IconComponent as IconComponent2,
  iconNames as iconNames3
} from "@ontruck/fe-icons";

// src/business/tickets/constants/ekon-merchandise-options.ts
var GOODS_TYPE_OPTIONS = [
  {
    value: "4",
    label: "CAJAS DE PL\xC1STICO / PLASTIC CASES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "20",
    label: "CARNES FRESCAS REFRIGERADAS / FRESH MEAT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "21",
    label: "PESCADOS FRESCOS REFRIGERADOS  / FRESH REFRIGERATED FISH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "30",
    label: "HELADO / ICE CREAM",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "32",
    label: "PLANTAS VIVAS Y FLORES FRESCAS CON TEMP / LIVE PLANTS AND FRESH FLOWERS WITH TEMPERATURE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "35",
    label: "HIELO / ICE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "37",
    label: "VIDRIO PLANO, MARMOL U OTRAS PIEDRAS / FLAT GLASS, MARBLE OR OTHERS STONES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "38",
    label: "PLACAS SOLARES Y/O ACCESORIOS Y/O SIMILARES / SOLAR PANELS AND/OR ACCESORIES AND/OR SIMILAR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "39",
    label: "ROLLOS DE TELA / ROLL OF FABRIC",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "40",
    label: "PRODUCTO FARMAC\xC9UTICO REFRIGERADO / PHARMACEUTICAL PRODUCTS REFRIGERATED",
    varieties: [
      {
        value: "1",
        label: "PROD.  FARM. REFRIGERADO"
      }
    ]
  },
  {
    value: "43",
    label: "ALBARICOQUE / APRICOT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "44",
    label: "CEREZA / CHERRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "45",
    label: "CIRUELA / PLUM",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "47",
    label: "FRESA / STRAWBERRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "48",
    label: "FRAMBUESA / RASPBERRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "49",
    label: "GRANADA / GRENADA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "50",
    label: "HIGO / FIG",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "51",
    label: "CAQUIS / PERSIMMON",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "52",
    label: "MANZANA / APPLE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "53",
    label: "MELOCOT\xD3N / PEACH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "54",
    label: "MEMBRILLO / QUINCE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "55",
    label: "MORA / ARREARS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "56",
    label: "NECTARINA / NECTARINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "57",
    label: "NISPERO / MEDLAR TREE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "58",
    label: "PERAS / PEARS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "59",
    label: "SETAS / MUSHROOMS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "60",
    label: "UVA / GRAPE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "62",
    label: "BERENJENA / EGGPLANT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "63",
    label: "COCO / COCONUT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "64",
    label: "GUAYABA / GUAVA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "65",
    label: "GUANABANA / SOURSOP",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "66",
    label: "LIMA / LIME",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "67",
    label: "MANGO / MANGO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "68",
    label: "MARACUYA / PASSION FRUIT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "70",
    label: "MEL\xD3N / MELON",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CANTALOUP"
      }
    ]
  },
  {
    value: "71",
    label: "PAPAYA / PAPAYA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "72",
    label: "PI\xD1A / PINEAPPLE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "73",
    label: "PL\xC1TANOS / BANANA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "PLATANO MACHO"
      }
    ]
  },
  {
    value: "74",
    label: "POMELO / GRAPEFRUIT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "75",
    label: "SANDIA / WATERMELON",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "76",
    label: "TOMATE / TOMATO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN TEMPERATURA"
      }
    ]
  },
  {
    value: "77",
    label: "AR\xC1NDANOS / BLUEBERRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "78",
    label: "CLEMENTINAS / TANGERINES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "79",
    label: "LICHI / LYCHEE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "80",
    label: "LIM\xD3N / LEMON",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "81",
    label: "MANDARINA / TANGERINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "82",
    label: "NARANJA / ORANGE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "83",
    label: "TAMARILLO / TOMATO TREE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "84",
    label: "HIGO CHUMBO / PRICKLY PEAR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "85",
    label: "CALABAC\xCDN / ZUCCHINI",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "86",
    label: "CHIRIMOYA / CUSTARD APPLE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "87",
    label: "JUDIA VERDE / GREEN BEAN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "88",
    label: "PIMIENTO / PEPPER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "89",
    label: "CALABAZA / PUMPKIN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "90",
    label: "JENGIBRE / GINGER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "92",
    label: "PEPINO / CUCUMBER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "93",
    label: "ALCACHOFA / ARTICHOKE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "94",
    label: "CHICORIA / CHICORY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "95",
    label: "ENDIVIA / ENDIVE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "96",
    label: "ENELDO / DILL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "97",
    label: "ESCAROLA / ENDIVE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "98",
    label: "ESPARRAGO / ASPARAGUS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "99",
    label: "ESPINACA / SPINACH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "100",
    label: "GUISANTES / GREEN PEAS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "101",
    label: "HABAS / BROAD BEANS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "103",
    label: "HINOJO / FENNEL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "104",
    label: "LECHUGA / LETTUCE / ICEBERG",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "105",
    label: "MA\xCDZ / CORN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "106",
    label: "PEREJIL / PARSLEY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "107",
    label: "PUERRO / LEEK",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "108",
    label: "REMOLACHA / BEET",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN REFRIGERACION"
      }
    ]
  },
  {
    value: "109",
    label: "RUIBARBO / RHUBARB",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "110",
    label: "SALSIF\xCD / SALSIFY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "112",
    label: "TIRABEQUE / SNOW PEAS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "113",
    label: "ZANAHORIA / CARROT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "114",
    label: "APIO / CELERY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "115",
    label: "APIO NABO / CELERIAC",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "116",
    label: "BROCOLI / BROCCOLI",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "117",
    label: "CEBOLLINO / CHIVE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "118",
    label: "COL / CABBAGE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "120",
    label: "COLIFLOR / CAULIFLOWER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "121",
    label: "NABO / TURNIP",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "122",
    label: "R\xC1BANO / RADISH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "123",
    label: "ROMANESCO / ROMANESE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "124",
    label: "BONIATO / BONIATE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "125",
    label: "PATATA / POTATO",
    varieties: [
      {
        value: "1",
        label: "refrigerada"
      },
      {
        value: "2",
        label: "no refrigerada"
      },
      {
        value: "3",
        label: "congelada"
      }
    ]
  },
  {
    value: "126",
    label: "AJO / GARLIC",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "127",
    label: "CEBOLLA / ONION",
    varieties: [
      {
        value: "1",
        label: "refrigerada"
      },
      {
        value: "2",
        label: "no refrigerada"
      }
    ]
  },
  {
    value: "128",
    label: "YUCA / YUCCA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "133",
    label: "CEREALES / CEREALS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "135",
    label: "HUEVOS FRESCOS / FRESH EGGS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "136",
    label: "PESCADO CONGELADO / FROZEN FISH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "137",
    label: "CACAHUETES / PEANUTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "138",
    label: "SOJA / SOY",
    varieties: [
      {
        value: "1",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "139",
    label: "LECHE / MILK",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADA"
      },
      {
        value: "3",
        label: "BEBIDA VEGETAL / PLANT-BASED DRINK"
      }
    ]
  },
  {
    value: "140",
    label: "MOSTAZA / MUSTARD",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "141",
    label: "GRANOS DE SESAMO / SESAME SEED",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "142",
    label: "ALTRAMUZ / LUPINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "143",
    label: "MOLUSCOS / MOLLUSK",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "144",
    label: "ALMENDRAS / ALMONDS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "145",
    label: "AVELLANAS / HAZELNUTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "146",
    label: "NUECES / NUTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "147",
    label: "ANACARDOS / CASHEW",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "148",
    label: "PECANAS / PECAN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "149",
    label: "CASTA\xD1AS DE PAR\xC1 / BRAZIL NUT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "150",
    label: "PISTACHOS / PISTACHIOS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "151",
    label: "MACADAMIAS / MACADAMIA NUT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "152",
    label: "ARROZ / RICE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "154",
    label: "TRIGO / WHEAT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "155",
    label: "CEBADA / CEBADA",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "156",
    label: "SORGO / SORGHUM",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "157",
    label: "MIJO / MILLET",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "158",
    label: "AVENA / OAT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "159",
    label: "ESPELTA / SPELT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "160",
    label: "TRITICALE / TRITICALE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "161",
    label: "FONIO / FONIO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "162",
    label: "MANTEQUILLA FRESCA / FRESH BUTTER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "163",
    label: "MANTEQUILLA CONGELADA / FROZEN BUTTER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "164",
    label: "MARGARINA / MARGARINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "165",
    label: "QUESOS / CHEESE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "166",
    label: "AGUACATE / AVOCADO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN TEMPERATURA"
      }
    ]
  },
  {
    value: "170",
    label: "PULPA DE NARANJA / ORANGE PULP",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "171",
    label: "EQUIPAMIENTO INDUSTRIAL / INDUSTRIAL EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "172",
    label: "MATERIAL OFICINA, ESCOLAR / OFFICE EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "173",
    label: "PAQUETERIA / PACKAGE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "174",
    label: "BEBIDAS NO ALCOHOLICAS / SOFT DRINKS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "175",
    label: "AGUA MINERAL / MINERAL WATER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "176",
    label: "MUEBLES / FURNITURE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "177",
    label: "COSM\xC9TICOS / COSMETICS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "178",
    label: "ENVASES VACIOS / EMPTY CONTAINERS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "179",
    label: "CALZADO / FOOTWEAR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "180",
    label: "TEXTIL / TEXTILE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "181",
    label: "PAPEL / PAPER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "182",
    label: "TOSTADAS / TOASTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "184",
    label: "MADERA / WOOD",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "185",
    label: "PL\xC1STICO / PLASTIC",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "186",
    label: "EQUIPOS ELECTR\xD3NICOS / ELECTRONIC EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "187",
    label: "KIWI FRUTA / KIWI FRUIT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "188",
    label: "CHOCOLATE / CHOCOLATE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "189",
    label: "SAL / SALT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "190",
    label: "PRODUCTOS QU\xCDMICOS NO ADR / CHEMICAL SUBSTANCES NO ADR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "191",
    label: "PRODUCTO QU\xCDMICO ADR / CHEMICAL SUBSTANCES ADR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "192",
    label: "POLIEXPAN - EPS (POLIESTIRENO EXPANDIDO ) / EXPANDED POLYSTYRENES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "193",
    label: "ZUMO CONCENTRADO / CONCENTRATED JUICE",
    varieties: [
      {
        value: "1",
        label: "general"
      },
      {
        value: "2",
        label: "congelado"
      },
      {
        value: "3",
        label: "sin temperatura"
      }
    ]
  },
  {
    value: "194",
    label: "MOSTO / GRAPE JUICE",
    varieties: [
      {
        value: "1",
        label: "general"
      }
    ]
  },
  {
    value: "196",
    label: "PLANTAS VIVAS Y FLORES FRESCAS / LIVE PLANTS AND FRESH FLOWERS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "TEMPERATURA"
      }
    ]
  },
  {
    value: "197",
    label: "CARAMELO / CARAMEL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "198",
    label: "TRIPAS NATURALES / NATURAL CASINGS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "200",
    label: "CONSERVAS / PRESERVES",
    varieties: [
      {
        value: "1",
        label: "general"
      }
    ]
  },
  {
    value: "201",
    label: "P.F. SIN TEMP / PHARMACEUTICAL PRODUCTS WITHOUT TEMP",
    varieties: [
      {
        value: "1",
        label: "general"
      }
    ]
  },
  {
    value: "202",
    label: "YOGURES / YOGURT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "203",
    label: "PRODUCTOS DE LIMPIEZA / CLEANING PRODUCTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "206",
    label: "LACTOSA / LACTOSE",
    varieties: [
      {
        value: "1",
        label: "PALETIZADA"
      }
    ]
  },
  {
    value: "207",
    label: "CART\xD3N / PAPERBOARD",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "208",
    label: "COLCHONES / MATTRESSES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "209",
    label: "CARTAS / LETTER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "210",
    label: "FRUTAS Y VERDURAS / FRUITS AND VEGETABLES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "211",
    label: "TAPAS Y TAPONES / CAPS AND STUDS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "212",
    label: "VINO / WINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "213",
    label: "MATERIALES DE LA CONSTRUCCI\xD3N / BUILDING MATERIALS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "214",
    label: "ALMOHADAS / PILLOWS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "215",
    label: "ALIMENTO PARA ANIMALES / ANIMAL FEED",
    varieties: [
      {
        value: "1",
        label: "Con Temperatura"
      },
      {
        value: "2",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "216",
    label: "ROPA / CLOTHES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "217",
    label: "NEUM\xC1TICOS / TYRES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "218",
    label: "GRUPAJE / PART LOADS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "219",
    label: "PRODUCTOS DE HOSTELERIA / HOSPITALITY INDUSTRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "220",
    label: "REVESTIMIENTOS CER\xC1MICOS / CERAMIC COATING",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "222",
    label: "C\xC9SPED / GRASS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN REFRIGERACION"
      }
    ]
  },
  {
    value: "223",
    label: "BICICLETAS / BICYCLES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "224",
    label: "JUGUETES / TOYS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "225",
    label: "PRODUCTOS L\xC1CTEOS / DAIRY PRODUCTS",
    varieties: [
      {
        value: "1",
        label: "L\xE1cteos refrigerados"
      }
    ]
  },
  {
    value: "226",
    label: "EMBUTIDOS / CURED MEATS",
    varieties: [
      {
        value: "1",
        label: "EMBUTIDOS REFRIGERADOS"
      }
    ]
  },
  {
    value: "227",
    label: "PUR\xC9 DE FRUTA / FRUIT PUREE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      },
      {
        value: "3",
        label: "CONGELADO"
      }
    ]
  },
  {
    value: "228",
    label: "CACAO EN GRANOS / COCOA BEANS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "229",
    label: "BOLLER\xCDA / PASTR\xCDES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN TEMP"
      }
    ]
  },
  {
    value: "230",
    label: "GOLOSINAS / CANDY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "SIN TEMPERATURA"
      }
    ]
  },
  {
    value: "231",
    label: "PARAGUAYOS / FLAT PEACH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "232",
    label: "COBRE / COPPER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "233",
    label: "ELECTRODOM\xC9STICOS / APPLIANCES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "234",
    label: "CERVEZA / BEER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "235",
    label: "ABONO / COMPOST",
    varieties: [
      {
        value: "1",
        label: "ABONO / COMPOST"
      }
    ]
  },
  {
    value: "236",
    label: "BOBINA DE PAPEL / PAPER REEL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "237",
    label: "ALGARROBA / CAROB",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "238",
    label: "PVC GRANULADO EN BIG BAG PALETIZADO / PVC GRANULATED IN BIG BAG PALLETIZED",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "239",
    label: "PAPELOTE / WORTHLESS DOCUMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "240",
    label: "GALLETAS / BISCUITS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "241",
    label: "PIEZAS MET\xC1LICAS / METAL COMPONENTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "243",
    label: "EQUIPAMIENTO PARA TRENES / TRAIN EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "244",
    label: "PIEZAS DE VEH\xCDCULO / VEHICLE PARTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "245",
    label: "BIG BAG",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "247",
    label: "PEGAMENTO / GLUE",
    varieties: [
      {
        value: "1",
        label: "Con temperatura"
      },
      {
        value: "2",
        label: "General"
      }
    ]
  },
  {
    value: "248",
    label: "SUPERMERCADO BITEMPERATURA / BI-TEMPERATURE SUPERMARKET",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "249",
    label: "PIELES PALETIZADAS / PALLETIZED FURS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "251",
    label: "LACTEOS SIN TEMPERATURA CONTROLADA / DAIRY PRODUCTS WITHOUT CONTROLLED TERMPERATURE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "252",
    label: "BALAS DE LINO / FLAX SHELLS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "253",
    label: "BARRAS MET\xC1LICAS / METAL RODS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "254",
    label: "PASTELERIA / PASTRY PRODUCTS",
    varieties: [
      {
        value: "1",
        label: "refrigerada"
      },
      {
        value: "2",
        label: "sin refrigerar"
      }
    ]
  },
  {
    value: "255",
    label: "BIDONES DE ACEITE Y PROCESADOS /  OIL DRUMS AND PROCESSED",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "256",
    label: "DOCUMENTACION / DOCUMENTATION",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "259",
    label: "DESGUACE COCHES / SCRAPPING CARS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "260",
    label: "TIERRA VIVERO / LAND FOR NURSERY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "261",
    label: "CHIRIVIA / PARSNIP",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "262",
    label: "EMBALAJES ALIMENTACI\xD3N / FOOD PACKAGING",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "263",
    label: "BOBINA DE COBRE / COPPER COIL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "264",
    label: "BOBINA DE ALUMINIO / ALUMINIUM COIL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "265",
    label: "ACEITE DE OLIVA / OLIVE OIL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "266",
    label: "ADR - MERCANCIA PELIGROSA / ADR - DANGEROUS MERCHANDISE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADA"
      }
    ]
  },
  {
    value: "267",
    label: "CARGA A\xC9REA / AIR CARGO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "268",
    label: "ESTUFAS / STOVES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "269",
    label: "PA\xD1ALES / DIAPERS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "270",
    label: "MEDICAMENTOS / MEDICINES",
    varieties: [
      {
        value: "1",
        label: "CON TEMP"
      }
    ]
  },
  {
    value: "272",
    label: "LUBRICANTES / LUBRICANTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "273",
    label: "FERTILIZANTE / FERTILLIZER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "274",
    label: "LACTEOS CON TEMPERATURA / DAIRY PRODUCTS WITH CONTROLLED TEMPERATURE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "275",
    label: "PRODUCTO FARMACEUTICO NO REFRIGERADO / PHERMACEUTICAL PRODUCTS NO REFRIGERATED",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "276",
    label: "D\xC1TIL / DATE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "277",
    label: "HIERBAS AROM\xC1TICAS / AROMATIC PLANTS",
    varieties: [
      {
        value: "1",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "278",
    label: "ESPECIAS / SPICES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "279",
    label: "HUEVOS PARA INDUSTRIA / EGGS FOR INDUSTRY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "280",
    label: "PRODUCTOS DE VIDRIO / GLASS PRODUCTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "282",
    label: "FIBRA DE CARBONO / CARBON FIBRE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CONGELADA"
      },
      {
        value: "3",
        label: "CONGELADA II"
      },
      {
        value: "4",
        label: "REFRIGERADA"
      }
    ]
  },
  {
    value: "284",
    label: "C\xC1PSULAS DE CAF\xC9 / COFFE CAPSULES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "285",
    label: "CHAMPI\xD1ONES / MUSHROOMS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "286",
    label: "PASTA / PASTA",
    varieties: [
      {
        value: "1",
        label: "REFRIGERADO"
      },
      {
        value: "2",
        label: "SIN TEMPERATURA"
      }
    ]
  },
  {
    value: "287",
    label: "PINTURA FRESCA / FRESH PAINT",
    varieties: [
      {
        value: "1",
        label: "SIN REFRIGERAR"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "289",
    label: "MOBILIARIO DE BA\xD1OS / BATHROOM EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "290",
    label: "ENSERES Y DECORACI\xD3N / FURNISHINGS AND DECORATION",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "Refrigerado"
      }
    ]
  },
  {
    value: "291",
    label: "MOBILIARIO Y ENSERES HOSPITALARIOS / HOSPITAL FURNITURE AND SUPPLIES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "292",
    label: "FOLLETOS DE PUBLICIDAD / FLAYERS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "293",
    label: "BOBINAS DE CABLE / CABLE COIL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "294",
    label: "HERRAMIENTAS / TOOLS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "295",
    label: "MAQUINARIA FARMAC\xC9UTICA / PHARMACEUTICAL MACHINERY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "296",
    label: "ADITIVOS ALIMENTARIOS / FOOD ADDITIVES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "297",
    label: "ABASTECIMIENTO ALIMENTARIO DE SUPERMERCADO / SUPERMARKET FOOD SUPPLY",
    varieties: [
      {
        value: "1",
        label: "NO REFRIGERADO"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "298",
    label: "PAN CONGELADO / FROZEN BREAD",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "299",
    label: "ART\xCDCULOS VARIOS PARA SUPERMERCADO / DIFFERENT ITEMS FOR SUPERMARKET",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "300",
    label: "EQUIPO PARA POZOS PETROL\xCDFEROS / OILWEEL EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "301",
    label: "BOLSAS / POUCHES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "302",
    label: "PALETS / PALLETS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "303",
    label: "VERDURA CONGELADA / FROZEN VEGETABLES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "304",
    label: "ALOE VERA / ALOE VERA (NO ALIMENTACI\xD3N)",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "305",
    label: "SOPORTES MET\xC1LICOS PARA ALMACENAR Y TRANSPORTAR ELEMENTOS CALIENTES / HEAT RESTSTANT CASTINGS AND ALLOYS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "306",
    label: "TEJAS / ROOF TILES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "307",
    label: "CAF\xC9S HELADOS / FROZEN COFFE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "308",
    label: "NEVERAS / FRIDGE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "309",
    label: "SOPAS / SOUPS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "310",
    label: "FUNDAS PARA TEL\xC9FONOS M\xD3VILES / MOBILE PHONE CASES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "311",
    label: "CARROS DE SUPERMERCADO / SHOPPING CARTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "312",
    label: "TORNILLOS / SCREWS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "313",
    label: "ALMID\xD3N / STARCH",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "314",
    label: "DETERGENTE / DETERGENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "315",
    label: "FILTROS INDUSTRIALES / INDUSTRIAL FILTERS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "316",
    label: "EQUIPOS DE ELEVACI\xD3N / LIFTING EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "317",
    label: "HARINA / FLOUR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "318",
    label: "AUTOMOCI\xD3N / AUTOMOTIVE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "319",
    label: "BAMB\xDA / BAMBOO",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "Sin temperatura"
      }
    ]
  },
  {
    value: "320",
    label: "FRUTOS SECOS VARIADOS / DIFFERENT DRY FRUITS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "321",
    label: "SEMILLAS / SEEDS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "322",
    label: "MENSAJER\xCDA Y CORRESPONDENCIA / MESSAGING AND CORRESPONDENCE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "323",
    label: "MATERIAL Y EQUIPAMIENTO DE PISCINA / SWIMMING POOL MATERIAL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "324",
    label: "EQUIPOS DE ILUMINACI\xD3N SOBRE PALETS / LIGHTING EQUIPMENT ON PALLETS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "325",
    label: "PARTES DE MAQUINAS / MACHINERY PARTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "326",
    label: "GR\xC1NULOS DE COLOR PARA FABRICACI\xD3N DE TELA ASF\xC1LTICA / COLOR GRANULAR FOR MANUFACTURING ASPHALT FABRIC",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "327",
    label: "GELATINA / GELATIN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "328",
    label: "RADIADORES Y CALDERAS / RADIATORS AND HEATING APPLIANCES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "329",
    label: "BACALAO SALADO / SALTED COD",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "330",
    label: "ABASTECIMIENTO ALIMENTARIO DE SUPERMERCADO TEMPERATURA CONTROLADA / SUPERMARKET FOOD SUPPLY TEMP CONTROL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "331",
    label: "ARMAMENTO INERTE / INERT ARMAMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "332",
    label: "VIRUTA GRANULADA / GRANULATED CHIP",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "333",
    label: "L\xCDQUIDO PARA LENTILLAS / LIQUID FOR LENSES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "334",
    label: "CRISTAL PALETIZADO / PALLETIZED GLASS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "335",
    label: "SURIMI CONGELADO / FROZEN SURIMI",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "336",
    label: "SALSAS / SOUCES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "337",
    label: "ABASTECIMIENTO ALIMENTARIO DE SUPERMERCADO CONGELADO / SUPERMARKET FOOD SUPPLY FROZEN",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "338",
    label: "REFRACTARIOS / REFRACTORIES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "339",
    label: "AZUCAR / SUGAR",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "340",
    label: "ESTANTER\xCDAS MET\xC1LICAS / METALIC SHELVES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "341",
    label: "POLVO DE CACAO / COCOA POWDER",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "342",
    label: "PERFILES DE ALUMINIO / ALUMINIUM PROFILES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "343",
    label: "MENAJE DE COCINA / KITCHENWARE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "344",
    label: "CABINAS EL\xC9CTRICAS / TRANSFORMER CABINS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "345",
    label: "MAQUINARIA DE PROCESAMIENTO / PROCESSING MACHINERY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "346",
    label: "CARNES CONGELADAS / FROZEN MEAT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "350",
    label: "CHARCUTERIA / CURED MEATS",
    varieties: [
      {
        value: "1",
        label: "CON TEMPERATURA"
      }
    ]
  },
  {
    value: "352",
    label: "PANADER\xCDA / BAKERY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADA"
      }
    ]
  },
  {
    value: "353",
    label: "INFUSIONES / INFUSIONS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "354",
    label: "PLATERINA / FLAT NECTARINE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "355",
    label: "POLICARBONATO / POLYCARBONATE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "359",
    label: "MATERIALES COMPUESTOS / COMPOSITE MATERIALS",
    varieties: [
      {
        value: "1",
        label: "CONGELADO"
      },
      {
        value: "2",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "360",
    label: "CONCENTRADO DE TOMATE / TOMATO CONCENTRATE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "361",
    label: "SILICONA / SILICONE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "362",
    label: "BOBINA DE ACERO / STEEL COIL",
    varieties: [
      {
        value: "1",
        label: "general"
      }
    ]
  },
  {
    value: "363",
    label: "BLOQUES DE PAJA / STRAW BALES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "364",
    label: "HOJAS DE TABACO SIN PROCESAR / RAW TOBACCO LEAVES",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "365",
    label: "MIEL / HONEY",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "366",
    label: "PIEZAS VEH\xCDCULOS MILITARES / MILITARY VEHICLE\xA0PARTS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "367",
    label: "MATERIAL PARA ESPECT\xC1CULOS / SHOW EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "368",
    label: "PEL\xCDCULA FOTOGR\xC1FICA / PHOTO FILM",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADA"
      }
    ]
  },
  {
    value: "369",
    label: "CAMAS EL\xC1STICAS / ELASTIC BEDS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "370",
    label: "MOBILIARIO JARDINER\xCDA / GARDEN EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "371",
    label: "SUPLEMENTOS ALIMENTICIOS: VITAMINAS, PROTE\xCDNAS, ETC. / FOOD SUPPLEMENTS: VITAMINS, PROTEINS, ETC.",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      },
      {
        value: "2",
        label: "REFRIGERADO"
      }
    ]
  },
  {
    value: "374",
    label: "GEL HIDROALCOH\xD3LICO / HYDROALCOHOLIC GEL",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "375",
    label: "GAS COMPRIMIDO / COMPRESSED GAS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "378",
    label: "ACEITES PARA ALIMENTACION / FOOD OIL",
    varieties: [
      {
        value: "1",
        label: "REFRIGERADO"
      },
      {
        value: "2",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "379",
    label: "EXPOSITORES Y STANDS / EXHIBITORS AND STANDS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "380",
    label: "CAF\xC9 / COFFEE",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "391",
    label: "MATERIAL DE FONTANER\xCDA Y CLIMATIZACI\xD3N / PLUMBING AND HVAC MATERIALS",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  },
  {
    value: "393",
    label: "EQUIPAMIENTO DEPORTIVO/ SPORTS EQUIPMENT",
    varieties: [
      {
        value: "1",
        label: "GENERAL"
      }
    ]
  }
];

// src/business/tickets/hooks/use-visible-draft-suggestions.ts
import { useMemo as useMemo5 } from "react";
function useVisibleDraftSuggestions(ticket) {
  return useMemo5(() => {
    var _a;
    if (!((_a = ticket == null ? void 0 : ticket.conversation) == null ? void 0 : _a.draftSuggestions)) {
      return {
        hasVisibleSuggestions: false,
        visibleSuggestionsCount: 0,
        filteredSuggestions: null
      };
    }
    const currentState = ticket.state;
    const stateAllowsSuggestions = currentState !== "CANCELLED" /* CANCELLED */ && currentState !== "REJECTED" /* REJECTED */ && currentState !== "DONE" /* DONE */;
    if (!stateAllowsSuggestions) {
      return {
        hasVisibleSuggestions: false,
        visibleSuggestionsCount: 0,
        filteredSuggestions: null
      };
    }
    let visibleCount = 0;
    function countVisibleSuggestions(obj) {
      Object.values(obj).forEach((value) => {
        if (value !== void 0 && value !== null) {
          if (typeof value === "object" && "aiStorageDataKey" in value) {
            const suggestion = value;
            if (suggestion.activated) {
              visibleCount++;
            }
          } else if (typeof value === "object") {
            countVisibleSuggestions(value);
          }
        }
      });
    }
    countVisibleSuggestions(ticket.conversation.draftSuggestions);
    return {
      hasVisibleSuggestions: visibleCount > 0,
      visibleSuggestionsCount: visibleCount,
      filteredSuggestions: visibleCount > 0 ? ticket.conversation.draftSuggestions : null
    };
  }, [ticket]);
}

// src/translations/ticket-state-labels.ts
function getTicketStateLabel(state, translations) {
  const stateLabels = {
    ["REJECTED" /* REJECTED */]: translations.ticketStates.rejected,
    ["PENDING" /* PENDING */]: translations.ticketStates.pending,
    ["QUOTE_SENT" /* QUOTESENT */]: translations.ticketStates.quoteSent,
    ["ACCEPTED" /* ACCEPTED */]: translations.ticketStates.accepted,
    ["DRAFT" /* DRAFT */]: translations.ticketStates.draft,
    ["CANCELLED" /* CANCELLED */]: translations.ticketStates.cancelled,
    ["MISSINGFIELDS" /* MISSINGFIELDS */]: translations.ticketStates.missingFields,
    ["DONE" /* DONE */]: translations.ticketStates.done
  };
  return stateLabels[state] || state;
}

// src/translations/get-ticket-icon-name.ts
import { iconNames } from "@ontruck/fe-icons";
function getTicketIconName(state) {
  const stateLabels = {
    ["DRAFT" /* DRAFT */]: iconNames.circleDash,
    ["PENDING" /* PENDING */]: iconNames.circleDash,
    ["QUOTE_SENT" /* QUOTESENT */]: iconNames.circleClock,
    ["ACCEPTED" /* ACCEPTED */]: iconNames.circleCheckNoBackground,
    ["REJECTED" /* REJECTED */]: iconNames.circleForbidden,
    ["CANCELLED" /* CANCELLED */]: iconNames.circleForbidden,
    ["MISSINGFIELDS" /* MISSINGFIELDS */]: iconNames.circleDash,
    ["DONE" /* DONE */]: iconNames.circleCheckNoBackground
  };
  return stateLabels[state] || iconNames.circleDash;
}

// src/pages/ticket/components/summary/component/field-container-component.tsx
import React2 from "react";
import styled3 from "styled-components";
import { IconComponent, iconNames as iconNames2 } from "@ontruck/fe-icons";
import { BallComponent, FlexComponent } from "@ontruck/fe-ui";

// src/pages/ticket/components/summary/component/summary-info-value-component.tsx
import styled from "styled-components";
var SummaryInfoValueComponent = styled.div`
  font-size: var(--otk-theme-font-size-m);
  ${({ showBold }) => showBold && `
    font-weight: 700;
  `}
  ${({ highlight }) => highlight && `
    color: var(--otk-theme-color-blue-500);
    display: flex;
    align-items: flex-start;
    font-size: var(--otk-theme-font-size-s);
    gap: 3px;
  `}
  ${({ aiWarning }) => aiWarning && `
    text-decoration: line-through;
    // text-decoration-color: var(--otk-theme-color-grey-600);
    color: var(--otk-theme-color-red-500);
  `}
`;

// src/pages/ticket/components/summary/component/field-no-suggestion-container-component.tsx
import styled2 from "styled-components";
var FieldNoSuggestionContainer = styled2.div`
  padding: 10px 10px 10px 15px;
  box-sizing: content-box;
  border-bottom: ${({ ignoreBorder }) => ignoreBorder ? "none" : "1px solid var(--otk-theme-color-grey-200)"};
  padding-bottom: ${({ ignoreMarginBottom }) => ignoreMarginBottom ? "0px" : "10px"};
  ${({ ignoreLateralPadding }) => ignoreLateralPadding && `padding-left: 0px;
    padding-right: 0px;`}
`;

// src/pages/ticket/components/summary/component/field-container-component.tsx
var AiMainContainer = styled3.div`
  box-sizing: content-box;
  border-bottom: ${({ ignoreBorder }) => ignoreBorder ? "none" : "1px solid var(--otk-theme-color-grey-200)"};
`;
var ChangeSuggestionContainer = styled3.div`
  background-color: var(--otk-theme-color-blue-200);
  border-left: 6px solid var(--otk-theme-color-blue-500);
  padding: 8px 10px 8px 13px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-bottom: 10px;
  ${({ ignoreMarginBottom }) => ignoreMarginBottom && `
    margin-bottom: 3px;
  `}
`;
var AiSuggestionContainer = styled3.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;
var AiActionButtonsContainer = styled3.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  min-width: 60px;
`;
var AiActionButton = styled3.button`
  display: flex;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 6px;
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  border: none;
  outline: none;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var MissingFieldValueContainer = styled3(FlexComponent)`
  align-items: center;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
`;
var InfoValue = styled3.div`
  font-size: 13.5px;
  ${({ showBold }) => showBold && `
    font-weight: 700;
  `}
  ${({ highlight }) => highlight && `
    color: var(--otk-theme-color-blue-500);
    display: flex;
    align-items: center;
    font-size: var(--otk-theme-font-size-s);
    gap: 3px;
  `}
  ${({ aiWarning }) => aiWarning && `
    text-decoration: line-through;
    color: #778fa9;
  `}
  height: 40px;
  line-height: 40px;
  ${({ isTextArea }) => isTextArea && `
    height: 120px;
  `}
`;
var InfoLabel = styled3.div`
  font-size: 13.5px;
  color: var(--otk-theme-color-grey-600);
  margin-bottom: 6px;
  font-weight: 500;
  ${({ lateralPadding }) => lateralPadding && `
    padding: 0px 15px;
  `}
  ${({ paddingTop }) => paddingTop && `
    padding-top: 10px;
  `}
`;
function FieldContainerComponent({
  EditComponent,
  ticketEditing,
  isLoading,
  ticket,
  label,
  onAiSuggestionClick,
  draftSuggestionValue,
  draftSuggestionDisplayValue,
  ignoreBorder = false,
  ignoreMarginBottom = false,
  ignoreLateralPadding = false,
  ticketValue,
  refreshData,
  style,
  isTextArea,
  isRequiredForAIPrice,
  isRequiredForExpedient
}) {
  const visibleSuggestions = useVisibleDraftSuggestions(ticket);
  const shouldShowMissingFieldIndicator = !visibleSuggestions.hasVisibleSuggestions && (isRequiredForAIPrice || isRequiredForExpedient);
  const { handleAiTicketRejectionChange } = useTicketUtils();
  function cancelAiSuggestion() {
    if (!(draftSuggestionValue == null ? void 0 : draftSuggestionValue.aiSuggestion)) {
      return;
    }
    handleAiTicketRejectionChange(
      ticket.id,
      draftSuggestionValue.aiStorageDataKey,
      draftSuggestionValue.aiSuggestion,
      ticket.state
    );
    void refreshData();
  }
  return !ticketEditing && (draftSuggestionValue == null ? void 0 : draftSuggestionValue.activated) && ticket.state !== "CANCELLED" /* CANCELLED */ && ticket.state !== "REJECTED" /* REJECTED */ && ticket.state !== "DONE" /* DONE */ ? /* @__PURE__ */ React2.createElement(AiMainContainer, { ignoreBorder, style }, label ? /* @__PURE__ */ React2.createElement(InfoLabel, { lateralPadding: !ignoreLateralPadding, paddingTop: true }, label) : void 0, /* @__PURE__ */ React2.createElement(
    ChangeSuggestionContainer,
    {
      ignoreMarginBottom,
      ignorePaddingBottom: ignoreBorder
    },
    /* @__PURE__ */ React2.createElement(AiSuggestionContainer, null, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(SummaryInfoValueComponent, { highlight: true, showBold: true }, draftSuggestionDisplayValue != null ? draftSuggestionDisplayValue : draftSuggestionValue.aiSuggestion), /* @__PURE__ */ React2.createElement(InfoValue, { aiWarning: true }, ticketValue ? ticketValue : "-")), /* @__PURE__ */ React2.createElement(AiActionButtonsContainer, null, /* @__PURE__ */ React2.createElement(
      AiActionButton,
      {
        backgroundColor: "#c2d5ff",
        disabled: isLoading,
        onClick: cancelAiSuggestion
      },
      /* @__PURE__ */ React2.createElement(
        IconComponent,
        {
          color: "var(--otk-theme-color-blue-500)",
          name: iconNames2.close,
          sizeInPixels: 12
        }
      )
    ), /* @__PURE__ */ React2.createElement(
      AiActionButton,
      {
        backgroundColor: "var(--otk-theme-color-blue-500)",
        disabled: isLoading,
        onClick: () => {
          void (onAiSuggestionClick == null ? void 0 : onAiSuggestionClick(draftSuggestionValue.aiSuggestion, true));
        }
      },
      /* @__PURE__ */ React2.createElement(
        IconComponent,
        {
          color: "var(--otk-theme-color-white)",
          name: iconNames2.check,
          sizeInPixels: 28
        }
      )
    )))
  )) : /* @__PURE__ */ React2.createElement(
    FieldNoSuggestionContainer,
    {
      ignoreBorder,
      ignoreLateralPadding,
      ignoreMarginBottom,
      style
    },
    label ? /* @__PURE__ */ React2.createElement(InfoLabel, null, label) : void 0,
    ticketEditing ? EditComponent : /* @__PURE__ */ React2.createElement(MissingFieldValueContainer, null, shouldShowMissingFieldIndicator ? /* @__PURE__ */ React2.createElement(BallComponent, { backgroundColor: TicketColorStates["DRAFT" /* DRAFT */], size: "10px" }) : null, /* @__PURE__ */ React2.createElement(InfoValue, { isTextArea }, ticketValue ? ticketValue : "-"))
  );
}

// src/pages/ticket/components/summary/summary-component.tsx
var Container = styled4.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: transparent;
  width: 60%;
  height: 100%;
  position: relative;
  overflow-y: hidden;
  gap: 20px;
  @media (max-width: 900px) {
    width: 100%;
  }
`;
var RequestContainer = styled4.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;
var RequestHeader = styled4.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 2%;
  background-color: var(--otk-theme-color-grey-100);
  height: 55px;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
var RequestContent = styled4.div`
  padding: 0px 0px 24px 0px;
  overflow-y: auto;
  flex-grow: 1;
  background-color: white;
  border-bottom-left-radius: ${({ hasBorderRadius }) => hasBorderRadius ? "10px" : "0px"};
  border-bottom-right-radius: ${({ hasBorderRadius }) => hasBorderRadius ? "10px" : "0px"};
`;
var RequestFooter = styled4.div`
  background-color: var(--otk-theme-color-grey-700);
  height: ${({ height }) => height};
  flex-shrink: 0;
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid transparent;
`;
var RequestToolbar = styled4.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 20px;
  height: 100%;
`;
var QuoteContainer = styled4.div`
  background-color: var(--otk-theme-color-grey-200);
  background-color: transparent;
  display: flex;
  flex-direction: column;
  height: ${({ height }) => height};
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 10px;
`;
var QuoteHeader = styled4.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 2%;
  background-color: var(--otk-theme-color-grey-100);
  height: 55px;
  overflow: hidden;
`;
var Title = styled4.div`
  font-weight: 500;
  font-size: 14px;
  color: var(--otk-theme-color-grey-700);
`;
var MainButton = styled4.button`
  background-color: var(--otk-theme-color-blue-500);
  color: var(--otk-theme-color-white);
  border: none;
  outline: none;
  border-radius: 5px;
  height: 38px;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: var(--otk-theme-color-blue-500);
    color: var(--otk-theme-color-white);
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var SecondaryButton = styled4.button`
  background-color: var(--otk-theme-color-blue-200);
  color: var(--otk-theme-color-blue-500);
  border: none;
  outline: none;
  border-radius: 5px;
  height: 38px;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: var(--otk-theme-color-blue-200);
    color: var(--otk-theme-color-blue-500);
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var GridContainer = styled4.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 5px;
  gap: 0px 24px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
var QuoteToolbar = styled4.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background-color: var(--otk-theme-color-white);
  padding: 0px 20px;
  height: 100%;
`;
var CancelButton = styled4(ButtonComponent)`
  background-color: var(--otk-theme-color-white);
  color: var(--otk-theme-color-grey-600);
  border: 1px solid var(--otk-theme-color-grey-200);
  width: auto;
  display: inline-block;
  border-radius: 8px;
  height: 38px;
  padding: 12px 28px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    color: var(--otk-theme-color-grey-600);
    background-color: var(--otk-theme-color-white);
    border: 1px solid var(--otk-theme-color-grey-200);
    opacity: 0.8;
  }
`;
var IconButton = styled4.button`
  background-color: var(--otk-theme-color-white);
  color: var(--otk-theme-color-blue-500);
  border: 1px solid var(--otk-theme-color-blue-500);
  cursor: pointer;
  border-radius: 5px;
  height: 38px;
  width: 120px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var TextAreaObservations = styled4.textarea`
  resize: none;
  height: 120px;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--otk-theme-color-grey-300);
  border-radius: 4px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: var(--otk-theme-color-blue-500);
  }
`;
var AddressContainer = styled4.div`
  border-bottom: 1px solid var(--otk-theme-color-grey-200);
  ${({ gridColumn }) => gridColumn && `grid-column: ${gridColumn};
    display: flex;
    gap: 10px;
    `}
`;
var PendingChangesCounter = styled4.div`
  height: 24px;
  width: 24px;
  padding: 5px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background-color: var(--otk-theme-color-blue-200);
  color: var(--otk-theme-color-blue-500);
`;
var RecalculateAIPriceButton = styled4.button`
  width: 28px;
  height: 28px;
  background-color: #c2d5ff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var LabelWithIconContainerComponent = styled4.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 8px;
  border-radius: 16px;
  background-color: var(--otk-theme-color-grey-200);
  color: var(--otk-theme-color-grey-700);
  height: 28px;
`;
var LabelWithIconContainerIconContainerComponent = styled4.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 28px;
  height: 28px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var SplitLabelWithIconContainerComponent = styled4.div`
  display: flex;
  align-items: center;
  gap: 0px;
`;
var SplitLabelWithIconLeftComponent = styled4(LabelWithIconContainerComponent)`
  background-color: var(--otk-theme-color-grey-300);
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0;
  padding-right: 6px;
  height: 20px;
`;
var SplitLabelWithIconRightComponent = styled4(LabelWithIconContainerComponent)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0;
  height: 20px;
`;
var SplitLabelWithIconRightComponentIconContainer = styled4(
  LabelWithIconContainerIconContainerComponent
)`
  height: 20px;
  width: 20px;
`;
var AiPriceErrorNote = styled4.div`
  background-color: #fef2f2;
  border: 1px solid #ef4444;
  border-radius: 6px;
  padding: 0px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  color: #991b1b;
  height: 32px;
  flex-shrink: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
var RequiredFieldWrapper = styled4.div`
  width: 100%;
  border: ${({ showBorder }) => showBorder ? "2px solid var(--otk-theme-color-warning-800, #fcb605)" : "none"};
  border-radius: ${({ showBorder }) => showBorder ? "4px" : "0"};
  background-color: transparent;
  padding: ${({ showBorder }) => showBorder ? "2px" : "0"};
`;
var REQUEST_FOOTER_HEIGHT = "60px";
var QUOTE_HEIGHT = "140px";
function SummaryComponent({
  changeTicketState,
  handleUpdateTicket,
  refreshData,
  ticket,
  isLoading,
  setIsLoading,
  aiPrice,
  aiPriceErrors,
  loadingAiPrice,
  onRecalculateAIPrice,
  aiPriceValidation,
  expedientValidation,
  openRejectQuoteModal
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La;
  const { handleAiTicketRejectionChange } = useTicketUtils();
  const [ticketEditing, setTicketEditing] = useState(null);
  const translations = useAlianzaTranslations();
  const quoteValidation = useTicketQuoteValidation(ticket, aiPriceValidation);
  const visibleSuggestions = useVisibleDraftSuggestions(ticket);
  function changeTicketStateLocal(state) {
    return __async(this, null, function* () {
      setTicketEditing(null);
      yield changeTicketState(state);
    });
  }
  function handleSaveChanges() {
    return __async(this, null, function* () {
      if (!ticketEditing) {
        return;
      }
      yield handleUpdateTicket(ticketEditing);
      setTicketEditing(null);
    });
  }
  function handleStartEditing() {
    setTicketEditing(cloneDeep2(ticket));
  }
  function getTicketIsLoadingOrError(isAiSuggestion) {
    return isLoading || !ticketEditing && !isAiSuggestion;
  }
  function handleTicketChangeAction(newTicket, isAiSuggestion) {
    return __async(this, null, function* () {
      if (isAiSuggestion) {
        yield handleUpdateTicket(newTicket);
      } else {
        setTicketEditing(newTicket);
      }
    });
  }
  function handleChangePickupAddress(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.pickup.address = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangePickupCity(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.pickup.city = value;
    setTicketEditing(newTicket);
  }
  function handleChangePickupZipcode(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.pickup.zipcode = value;
    setTicketEditing(newTicket);
  }
  function handleChangePickupCountry(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.pickup.country = value;
    setTicketEditing(newTicket);
  }
  function handleChangeDropoffAddress(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(!ticketEditing ? ticket : ticketEditing);
      newTicket.orderData.dropoff.address = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeDropoffCity(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.dropoff.city = value;
    setTicketEditing(newTicket);
  }
  function handleChangeDropoffZipcode(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.dropoff.zipcode = value;
    setTicketEditing(newTicket);
  }
  function handleChangeDropoffCountry(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.dropoff.country = value;
    setTicketEditing(newTicket);
  }
  function handleChangeDate(value, key) {
    const date = value ? moment4(value) : "";
    const newTicket = cloneDeep2(ticketEditing);
    if (!newTicket)
      return;
    newTicket.orderData[key].date = date ? date.format("YYYY-MM-DD") : "";
    newTicket.orderData[key].dateFormatted = date ? date.format("DD/MM/YYYY") : "";
    if (date) {
      newTicket.orderData[key].formattedDateTime = ticketFormatDateTime(
        date.format("YYYY-MM-DD"),
        newTicket.orderData[key].timeFrom,
        newTicket.orderData[key].timeTo
      );
    }
    setTicketEditing(newTicket);
  }
  function handleChangePrice(value) {
    const newTicket = cloneDeep2(ticketEditing);
    if (!newTicket)
      return;
    if (!newTicket.quote) {
      newTicket.quote = {
        id: 0,
        price: {
          amount: 0,
          currency: "EUR",
          formatted: "0 \u20AC"
        }
      };
    }
    newTicket.quote.price.amount = value ? value : "";
    setTicketEditing(newTicket);
  }
  function cancelEditing() {
    if (isLoading) {
      return;
    }
    setTicketEditing(null);
  }
  function handleChangePickupTimeFrom(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.pickup.timeFrom = value != null ? value : "";
    newTicket.orderData.pickup.formattedDateTime = ticketFormatDateTime(
      newTicket.orderData.pickup.date,
      value != null ? value : "",
      newTicket.orderData.pickup.timeTo
    );
    setTicketEditing(newTicket);
  }
  function handleChangePickupTimeTo(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.pickup.timeTo = value != null ? value : "";
    newTicket.orderData.pickup.formattedDateTime = ticketFormatDateTime(
      newTicket.orderData.pickup.date,
      newTicket.orderData.pickup.timeFrom,
      value != null ? value : ""
    );
    setTicketEditing(newTicket);
  }
  function handleChangeDropoffTimeFrom(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.dropoff.timeFrom = value != null ? value : "";
    newTicket.orderData.dropoff.formattedDateTime = ticketFormatDateTime(
      newTicket.orderData.dropoff.date,
      value != null ? value : "",
      newTicket.orderData.dropoff.timeTo
    );
    setTicketEditing(newTicket);
  }
  function handleChangeDropoffTimeTo(value) {
    if (isLoading || !ticketEditing) {
      return;
    }
    const newTicket = cloneDeep2(ticketEditing);
    newTicket.orderData.dropoff.timeTo = value != null ? value : "";
    newTicket.orderData.dropoff.formattedDateTime = ticketFormatDateTime(
      newTicket.orderData.dropoff.date,
      newTicket.orderData.dropoff.timeFrom,
      value != null ? value : ""
    );
    setTicketEditing(newTicket);
  }
  function handleChangeCargoNumberOfPallets(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.numberOfPallets = value ? Number(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeCargoType(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.cargoType = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeGoodsType(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      var _a2, _b2;
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      const selectedGoodsType = value !== void 0 && value !== null ? Number(value) : null;
      newTicket.orderData.cargo.goodsType = selectedGoodsType;
      if (selectedGoodsType === null) {
        newTicket.orderData.cargo.varietyId = null;
      } else {
        const firstVarietyOption = (_b2 = (_a2 = GOODS_TYPE_OPTIONS.find(
          (option) => option.value === String(selectedGoodsType)
        )) == null ? void 0 : _a2.varieties) == null ? void 0 : _b2[0];
        newTicket.orderData.cargo.varietyId = firstVarietyOption ? Number(firstVarietyOption.value) : null;
      }
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeVariety(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.varietyId = value !== void 0 && value !== null ? Number(value) : null;
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeVehicleType(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.vehicleType = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeCargoWeight(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.weight = value ? Number(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeCargoLinearMeters(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.linearMeters = value ? Number(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeCargoVolume(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.cargo.volume = value ? Number(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeAiPickupCountry(value, isAiSuggestion = true) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
      if (getTicketIsLoadingOrError(isAiSuggestion) || !value) {
        return;
      }
      const newTicket = cloneDeep2(ticket);
      if ((_d2 = (_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftTicket) == null ? void 0 : _b2.orderData) == null ? void 0 : _c2.pickup) == null ? void 0 : _d2.country) {
        newTicket.orderData.pickup.country = ticket.conversation.draftTicket.orderData.pickup.country;
      }
      if ((_h2 = (_g2 = (_f2 = (_e2 = ticket.conversation) == null ? void 0 : _e2.draftTicket) == null ? void 0 : _f2.orderData) == null ? void 0 : _g2.pickup) == null ? void 0 : _h2.city) {
        newTicket.orderData.pickup.city = ticket.conversation.draftTicket.orderData.pickup.city;
      }
      if ((_l2 = (_k2 = (_j2 = (_i2 = ticket.conversation) == null ? void 0 : _i2.draftTicket) == null ? void 0 : _j2.orderData) == null ? void 0 : _k2.pickup) == null ? void 0 : _l2.zipcode) {
        newTicket.orderData.pickup.zipcode = ticket.conversation.draftTicket.orderData.pickup.zipcode;
      }
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeAiDropoffCountry(value, isAiSuggestion = true) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
      if (getTicketIsLoadingOrError(isAiSuggestion) || !value) {
        return;
      }
      const newTicket = cloneDeep2(ticket);
      if ((_d2 = (_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftTicket) == null ? void 0 : _b2.orderData) == null ? void 0 : _c2.dropoff) == null ? void 0 : _d2.country) {
        newTicket.orderData.dropoff.country = ticket.conversation.draftTicket.orderData.dropoff.country;
      }
      if ((_h2 = (_g2 = (_f2 = (_e2 = ticket.conversation) == null ? void 0 : _e2.draftTicket) == null ? void 0 : _f2.orderData) == null ? void 0 : _g2.dropoff) == null ? void 0 : _h2.city) {
        newTicket.orderData.dropoff.city = ticket.conversation.draftTicket.orderData.dropoff.city;
      }
      if ((_l2 = (_k2 = (_j2 = (_i2 = ticket.conversation) == null ? void 0 : _i2.draftTicket) == null ? void 0 : _j2.orderData) == null ? void 0 : _k2.dropoff) == null ? void 0 : _l2.zipcode) {
        newTicket.orderData.dropoff.zipcode = ticket.conversation.draftTicket.orderData.dropoff.zipcode;
      }
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeAiPickupDateTime(value, isAiSuggestion = true) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
      if (getTicketIsLoadingOrError(isAiSuggestion) || !value) {
        return;
      }
      const newTicket = cloneDeep2(ticket);
      if ((_d2 = (_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftTicket) == null ? void 0 : _b2.orderData) == null ? void 0 : _c2.pickup) == null ? void 0 : _d2.date) {
        newTicket.orderData.pickup.date = ticket.conversation.draftTicket.orderData.pickup.date;
      }
      if ((_h2 = (_g2 = (_f2 = (_e2 = ticket.conversation) == null ? void 0 : _e2.draftTicket) == null ? void 0 : _f2.orderData) == null ? void 0 : _g2.pickup) == null ? void 0 : _h2.timeFrom) {
        newTicket.orderData.pickup.timeFrom = ticket.conversation.draftTicket.orderData.pickup.timeFrom;
      }
      if ((_l2 = (_k2 = (_j2 = (_i2 = ticket.conversation) == null ? void 0 : _i2.draftTicket) == null ? void 0 : _j2.orderData) == null ? void 0 : _k2.pickup) == null ? void 0 : _l2.timeTo) {
        newTicket.orderData.pickup.timeTo = ticket.conversation.draftTicket.orderData.pickup.timeTo;
      }
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeAiDropoffDateTime(value, isAiSuggestion = true) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
      if (getTicketIsLoadingOrError(isAiSuggestion) || !value) {
        return;
      }
      const newTicket = cloneDeep2(ticket);
      if ((_d2 = (_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftTicket) == null ? void 0 : _b2.orderData) == null ? void 0 : _c2.dropoff) == null ? void 0 : _d2.date) {
        newTicket.orderData.dropoff.date = ticket.conversation.draftTicket.orderData.dropoff.date;
      }
      if ((_h2 = (_g2 = (_f2 = (_e2 = ticket.conversation) == null ? void 0 : _e2.draftTicket) == null ? void 0 : _f2.orderData) == null ? void 0 : _g2.dropoff) == null ? void 0 : _h2.timeFrom) {
        newTicket.orderData.dropoff.timeFrom = ticket.conversation.draftTicket.orderData.dropoff.timeFrom;
      }
      if ((_l2 = (_k2 = (_j2 = (_i2 = ticket.conversation) == null ? void 0 : _i2.draftTicket) == null ? void 0 : _j2.orderData) == null ? void 0 : _k2.dropoff) == null ? void 0 : _l2.timeTo) {
        newTicket.orderData.dropoff.timeTo = ticket.conversation.draftTicket.orderData.dropoff.timeTo;
      }
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangePickupObservations(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.pickup.observations = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeDropoffObservations(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.dropoff.observations = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataCompanyId(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.companyId = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataCompanyName(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.companyName = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataLanguage(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.language = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataContactName(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.contactName = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataEmail(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.email = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeShipperDataPhone(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.shipperData.phone = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeComplementaryInfoExternalReference(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.complementaryInfo.customerInternalReference = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangePickupContact(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.pickup.contact = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleChangeDropoffContact(value, isAiSuggestion = false) {
    return __async(this, null, function* () {
      if (getTicketIsLoadingOrError(isAiSuggestion)) {
        return;
      }
      const newTicket = cloneDeep2(ticketEditing ? ticketEditing : ticket);
      newTicket.orderData.dropoff.contact = value ? String(value) : "";
      yield handleTicketChangeAction(newTicket, isAiSuggestion);
    });
  }
  function handleAcceptAllChanges() {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2;
      if (!((_a2 = ticket.conversation) == null ? void 0 : _a2.draftSuggestions) || !ticket.conversation.draftTicket || getTicketIsLoadingOrError(true)) {
        return;
      }
      const newTicket = cloneDeep2(ticket);
      handleAcceptFullAddress(
        (_b2 = ticket.conversation.draftTicket.orderData) == null ? void 0 : _b2.pickup,
        ticket.conversation.draftSuggestions.pickup,
        newTicket.orderData.pickup
      );
      handleAcceptFullAddress(
        (_c2 = ticket.conversation.draftTicket.orderData) == null ? void 0 : _c2.dropoff,
        ticket.conversation.draftSuggestions.dropoff,
        newTicket.orderData.dropoff
      );
      handleAcceptFullCargo(
        (_d2 = ticket.conversation.draftTicket.orderData) == null ? void 0 : _d2.cargo,
        ticket.conversation.draftSuggestions,
        newTicket.orderData.cargo
      );
      handleAcceptFullShipperData(
        ticket.conversation.draftTicket.shipperData,
        ticket.conversation.draftSuggestions,
        newTicket.shipperData
      );
      if (((_e2 = ticket.conversation.draftTicket.orderData) == null ? void 0 : _e2.vehicleType) && ((_f2 = ticket.conversation.draftSuggestions.vehicleType) == null ? void 0 : _f2.activated)) {
        newTicket.orderData.vehicleType = ticket.conversation.draftTicket.orderData.vehicleType;
      }
      if (((_h2 = (_g2 = ticket.conversation.draftTicket.orderData) == null ? void 0 : _g2.complementaryInfo) == null ? void 0 : _h2.customerInternalReference) && ((_i2 = ticket.conversation.draftSuggestions.complementaryInfoExternalReference) == null ? void 0 : _i2.activated)) {
        newTicket.orderData.complementaryInfo.customerInternalReference = ticket.conversation.draftTicket.orderData.complementaryInfo.customerInternalReference;
      }
      yield handleTicketChangeAction(newTicket, true);
    });
  }
  function handleAcceptFullShipperData(draftTicketShipperData, suggestions, ticketShipperData) {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    if (!draftTicketShipperData || !suggestions) {
      return;
    }
    if (draftTicketShipperData.companyId && ((_a2 = suggestions.shipperDataId) == null ? void 0 : _a2.activated)) {
      ticketShipperData.companyId = draftTicketShipperData.companyId;
    }
    if (draftTicketShipperData.companyName && ((_b2 = suggestions.shipperDataCompanyName) == null ? void 0 : _b2.activated)) {
      ticketShipperData.companyName = draftTicketShipperData.companyName;
    }
    if (draftTicketShipperData.language && ((_c2 = suggestions.shipperDataLanguage) == null ? void 0 : _c2.activated)) {
      ticketShipperData.language = draftTicketShipperData.language;
    }
    if (draftTicketShipperData.contactName && ((_d2 = suggestions.shipperDataContactName) == null ? void 0 : _d2.activated)) {
      ticketShipperData.contactName = draftTicketShipperData.contactName;
    }
    if (draftTicketShipperData.email && ((_e2 = suggestions.shipperDataEmail) == null ? void 0 : _e2.activated)) {
      ticketShipperData.email = draftTicketShipperData.email;
    }
    if (draftTicketShipperData.phone && ((_f2 = suggestions.shipperDataPhone) == null ? void 0 : _f2.activated)) {
      ticketShipperData.phone = draftTicketShipperData.phone;
    }
  }
  function handleAcceptFullCargo(draftTicketCargo, suggestions, ticketCargo) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2;
    if (!draftTicketCargo || !suggestions) {
      return;
    }
    if (draftTicketCargo.numberOfPallets && ((_a2 = suggestions.numberOfPallets) == null ? void 0 : _a2.activated)) {
      ticketCargo.numberOfPallets = draftTicketCargo.numberOfPallets;
    }
    if (draftTicketCargo.cargoType && ((_b2 = suggestions.cargoType) == null ? void 0 : _b2.activated)) {
      ticketCargo.cargoType = draftTicketCargo.cargoType;
    }
    const hasGoodsTypeSuggestion = Boolean(
      draftTicketCargo.goodsType !== null && draftTicketCargo.goodsType !== void 0 && ((_c2 = suggestions.goodsType) == null ? void 0 : _c2.activated)
    );
    const hasVarietySuggestion = Boolean(
      draftTicketCargo.varietyId !== null && draftTicketCargo.varietyId !== void 0 && ((_d2 = suggestions.varietyId) == null ? void 0 : _d2.activated)
    );
    const suggestedGoodsType = draftTicketCargo.goodsType !== null && draftTicketCargo.goodsType !== void 0 ? draftTicketCargo.goodsType : null;
    const suggestedVarietyId = draftTicketCargo.varietyId !== null && draftTicketCargo.varietyId !== void 0 ? draftTicketCargo.varietyId : null;
    if (hasGoodsTypeSuggestion && suggestedGoodsType !== null) {
      ticketCargo.goodsType = suggestedGoodsType;
    }
    if (hasVarietySuggestion && suggestedVarietyId !== null) {
      ticketCargo.varietyId = suggestedVarietyId;
    }
    if (hasGoodsTypeSuggestion && !hasVarietySuggestion && suggestedGoodsType !== null) {
      const firstVarietyOption = (_f2 = (_e2 = GOODS_TYPE_OPTIONS.find(
        (option) => option.value === String(suggestedGoodsType)
      )) == null ? void 0 : _e2.varieties) == null ? void 0 : _f2[0];
      ticketCargo.varietyId = firstVarietyOption ? Number(firstVarietyOption.value) : null;
    }
    if (draftTicketCargo.weight && ((_g2 = suggestions.weight) == null ? void 0 : _g2.activated)) {
      ticketCargo.weight = draftTicketCargo.weight;
    }
    if (draftTicketCargo.linearMeters && ((_h2 = suggestions.linearMeters) == null ? void 0 : _h2.activated)) {
      ticketCargo.linearMeters = draftTicketCargo.linearMeters;
    }
    if (draftTicketCargo.volume && ((_i2 = suggestions.volume) == null ? void 0 : _i2.activated)) {
      ticketCargo.volume = draftTicketCargo.volume;
    }
  }
  function handleAcceptFullAddress(draftTicketAddress, addressSuggestion, ticketAddress) {
    var _a2, _b2, _c2, _d2, _e2;
    if (!draftTicketAddress || !addressSuggestion) {
      return;
    }
    if (draftTicketAddress.address && ((_a2 = addressSuggestion.address) == null ? void 0 : _a2.activated)) {
      ticketAddress.address = draftTicketAddress.address;
    }
    if (draftTicketAddress.observations && ((_b2 = addressSuggestion.observations) == null ? void 0 : _b2.activated)) {
      ticketAddress.observations = draftTicketAddress.observations;
    }
    if (draftTicketAddress.contact && ((_c2 = addressSuggestion.contact) == null ? void 0 : _c2.activated)) {
      ticketAddress.contact = draftTicketAddress.contact;
    }
    if ((_d2 = addressSuggestion.addressInfo) == null ? void 0 : _d2.activated) {
      if (draftTicketAddress.country) {
        ticketAddress.country = draftTicketAddress.country;
      }
      if (draftTicketAddress.city) {
        ticketAddress.city = draftTicketAddress.city;
      }
      if (draftTicketAddress.zipcode) {
        ticketAddress.zipcode = draftTicketAddress.zipcode;
      }
    }
    if ((_e2 = addressSuggestion.formattedDateTime) == null ? void 0 : _e2.activated) {
      if (draftTicketAddress.date) {
        ticketAddress.date = draftTicketAddress.date;
      }
      if (draftTicketAddress.timeFrom) {
        ticketAddress.timeFrom = draftTicketAddress.timeFrom;
      }
      if (draftTicketAddress.timeTo) {
        ticketAddress.timeTo = draftTicketAddress.timeTo;
      }
    }
  }
  function calculateNumberOfDraftSuggestions(draftSuggestions) {
    if (!draftSuggestions) {
      return 0;
    }
    let count = 0;
    function countProperties(obj) {
      Object.values(obj).forEach((value) => {
        if (value !== void 0 && value !== null) {
          if (typeof value === "object" && "aiStorageDataKey" in value) {
            count++;
          } else if (typeof value === "object") {
            countProperties(value);
          }
        }
      });
    }
    countProperties(draftSuggestions);
    return count;
  }
  const numberOfDraftSuggestions = calculateNumberOfDraftSuggestions(
    (_a = ticket.conversation) == null ? void 0 : _a.draftSuggestions
  );
  function handleRejectAllChanges() {
    return __async(this, null, function* () {
      var _a2;
      if (!((_a2 = ticket.conversation) == null ? void 0 : _a2.draftSuggestions)) {
        return;
      }
      setIsLoading(true);
      Object.entries(ticket.conversation.draftSuggestions).forEach(([_, suggestion]) => {
        if (suggestion) {
          processRejectionChange(suggestion);
        }
      });
      yield refreshData();
    });
  }
  function processRejectionChange(suggestion) {
    if (!suggestion) {
      return;
    }
    if ("aiStorageDataKey" in suggestion) {
      const draftSuggestion = suggestion;
      handleAiTicketRejectionChange(
        ticket.id,
        draftSuggestion.aiStorageDataKey,
        draftSuggestion.aiSuggestion,
        ticket.state
      );
    } else {
      const draftSuggestionAddress = suggestion;
      processRejectionChange(draftSuggestionAddress.address);
      processRejectionChange(draftSuggestionAddress.formattedDateTime);
      processRejectionChange(draftSuggestionAddress.observations);
      processRejectionChange(draftSuggestionAddress.addressInfo);
      processRejectionChange(draftSuggestionAddress.contact);
    }
  }
  const showRequestFooter = ticketEditing || numberOfDraftSuggestions > 0;
  const isTicketMissingFieldsForAIPrice = !validateTicketIsReadyForAiPrice(ticket);
  const ticketStateForAiPrice = ["PENDING" /* PENDING */, "DRAFT" /* DRAFT */].includes(ticket.state) && isTicketMissingFieldsForAIPrice ? "MISSINGFIELDS" /* MISSINGFIELDS */ : ticket.state;
  const isPickupAddressMissingInfoForAIPrice = useMemo6(() => {
    const zipcode = ticket.orderData.pickup.zipcode;
    const country = ticket.orderData.pickup.country;
    return !zipcode || zipcode.trim() === "-" || zipcode.trim() === "" || !country || country.trim() === "-" || country.trim() === "";
  }, [ticket.orderData.pickup.zipcode, ticket.orderData.pickup.country]);
  const isPickupDateMissingInfoForAIPrice = useMemo6(() => {
    const date = ticket.orderData.pickup.formattedDateTime;
    return !date || date.trim() === "-" || date.trim() === "";
  }, [ticket.orderData.pickup.formattedDateTime]);
  const isDropoffAddressMissingInfoForAIPrice = useMemo6(() => {
    const zipcode = ticket.orderData.dropoff.zipcode;
    const country = ticket.orderData.dropoff.country;
    return !zipcode || zipcode.trim() === "-" || zipcode.trim() === "" || !country || country.trim() === "-" || country.trim() === "";
  }, [ticket.orderData.dropoff.zipcode, ticket.orderData.dropoff.country]);
  const isDropoffDateMissingInfoForAIPrice = useMemo6(() => {
    const date = ticket.orderData.dropoff.formattedDateTime;
    return !date || date.trim() === "-" || date.trim() === "";
  }, [ticket.orderData.dropoff.formattedDateTime]);
  const isNumberPalletsMissingInfoForAIPrice = useMemo6(() => {
    const numberOfPallets = ticket.orderData.cargo.numberOfPallets;
    if (!numberOfPallets) {
      return true;
    }
    if (typeof numberOfPallets === "string") {
      return numberOfPallets.trim() === "-" || numberOfPallets.trim() === "";
    }
    if (typeof numberOfPallets === "number") {
      return numberOfPallets <= 0;
    }
  }, [ticket.orderData.cargo.numberOfPallets]);
  const isVehicleTypeMissingInfoForAIPrice = useMemo6(() => {
    const vehicleType = ticket.orderData.vehicleType;
    return !vehicleType || vehicleType.trim() === "-" || vehicleType.trim() === "";
  }, [ticket.orderData.vehicleType]);
  const isCargoTypeMissingInfoForAIPrice = useMemo6(() => {
    const cargoType = ticket.orderData.cargo.cargoType;
    return !cargoType || cargoType.trim() === "-" || cargoType.trim() === "";
  }, [ticket.orderData.cargo.cargoType]);
  const isGoodsTypeMissingForExpedient = useMemo6(() => {
    return !ticket.orderData.cargo.goodsType;
  }, [ticket.orderData.cargo.goodsType]);
  const isVarietyMissingForExpedient = useMemo6(() => {
    return !ticket.orderData.cargo.varietyId;
  }, [ticket.orderData.cargo.varietyId]);
  const isGoodsTypeMissingInfoForAIPrice = useMemo6(() => {
    return !ticket.orderData.cargo.goodsType;
  }, [ticket.orderData.cargo.goodsType]);
  const isVarietyMissingInfoForAIPrice = useMemo6(() => {
    return !ticket.orderData.cargo.varietyId;
  }, [ticket.orderData.cargo.varietyId]);
  const goodsTypeValue = ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.goodsType;
  const varietyOptions = goodsTypeValue !== null && goodsTypeValue !== void 0 ? (_c = (_b = GOODS_TYPE_OPTIONS.find((option) => option.value === String(goodsTypeValue))) == null ? void 0 : _b.varieties) != null ? _c : [] : [];
  const goodsTypeSuggestionLabel = ((_f = (_e = (_d = ticket.conversation) == null ? void 0 : _d.draftSuggestions) == null ? void 0 : _e.goodsType) == null ? void 0 : _f.aiSuggestion) !== null && ((_i = (_h = (_g = ticket.conversation) == null ? void 0 : _g.draftSuggestions) == null ? void 0 : _h.goodsType) == null ? void 0 : _i.aiSuggestion) !== void 0 ? (_j = GOODS_TYPE_OPTIONS.find(
    (option) => {
      var _a2, _b2, _c2;
      return option.value === String((_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftSuggestions) == null ? void 0 : _b2.goodsType) == null ? void 0 : _c2.aiSuggestion);
    }
  )) == null ? void 0 : _j.label : void 0;
  const goodsTypeForVarietySuggestion = (_n = (_m = (_l = (_k = ticket.conversation) == null ? void 0 : _k.draftSuggestions) == null ? void 0 : _l.goodsType) == null ? void 0 : _m.aiSuggestion) != null ? _n : ticket.orderData.cargo.goodsType;
  const varietySuggestionLabel = ((_q = (_p = (_o = ticket.conversation) == null ? void 0 : _o.draftSuggestions) == null ? void 0 : _p.varietyId) == null ? void 0 : _q.aiSuggestion) !== null && ((_t = (_s = (_r = ticket.conversation) == null ? void 0 : _r.draftSuggestions) == null ? void 0 : _s.varietyId) == null ? void 0 : _t.aiSuggestion) !== void 0 && goodsTypeForVarietySuggestion !== null && goodsTypeForVarietySuggestion !== void 0 ? (_w = (_v = (_u = GOODS_TYPE_OPTIONS.find(
    (option) => option.value === String(goodsTypeForVarietySuggestion)
  )) == null ? void 0 : _u.varieties) == null ? void 0 : _v.find(
    (option) => {
      var _a2, _b2, _c2;
      return option.value === String((_c2 = (_b2 = (_a2 = ticket.conversation) == null ? void 0 : _a2.draftSuggestions) == null ? void 0 : _b2.varietyId) == null ? void 0 : _c2.aiSuggestion);
    }
  )) == null ? void 0 : _w.label : void 0;
  return /* @__PURE__ */ React3.createElement(Container, null, /* @__PURE__ */ React3.createElement(RequestContainer, null, /* @__PURE__ */ React3.createElement(RequestHeader, null, /* @__PURE__ */ React3.createElement(
    FlexComponent2,
    {
      alignItems: "center",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React3.createElement(Title, null, translations.ticket.detailsTitle),
    /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "8px" }, aiPriceValidation.shouldShow ? /* @__PURE__ */ React3.createElement(SplitLabelWithIconContainerComponent, null, /* @__PURE__ */ React3.createElement(SplitLabelWithIconLeftComponent, null, translations.ticket.summary.requiredForPrice), /* @__PURE__ */ React3.createElement(SplitLabelWithIconRightComponent, null, aiPriceValidation.validFieldsCount, " / ", aiPriceValidation.requiredFieldsCount, /* @__PURE__ */ React3.createElement(SplitLabelWithIconRightComponentIconContainer, { backgroundColor: "transparent" }, !aiPriceValidation.isValid ? /* @__PURE__ */ React3.createElement(
      CircleDashIcon,
      {
        color: TicketColorStates["MISSINGFIELDS" /* MISSINGFIELDS */],
        sizeInPixels: 16
      }
    ) : /* @__PURE__ */ React3.createElement(
      CircleCheckNoBackgroundIcon,
      {
        color: TicketColorStates["ACCEPTED" /* ACCEPTED */],
        sizeInPixels: 16
      }
    )))) : null, expedientValidation.shouldShow ? /* @__PURE__ */ React3.createElement(SplitLabelWithIconContainerComponent, null, /* @__PURE__ */ React3.createElement(SplitLabelWithIconLeftComponent, null, translations.ticket.summary.requiredForExpedient), /* @__PURE__ */ React3.createElement(SplitLabelWithIconRightComponent, null, expedientValidation.validFieldsCount, " /", " ", expedientValidation.requiredFieldsCount, /* @__PURE__ */ React3.createElement(SplitLabelWithIconRightComponentIconContainer, { backgroundColor: "transparent" }, !expedientValidation.isValid ? /* @__PURE__ */ React3.createElement(
      CircleDashIcon,
      {
        color: TicketColorStates["MISSINGFIELDS" /* MISSINGFIELDS */],
        sizeInPixels: 16
      }
    ) : /* @__PURE__ */ React3.createElement(
      CircleCheckNoBackgroundIcon,
      {
        color: TicketColorStates["ACCEPTED" /* ACCEPTED */],
        sizeInPixels: 16
      }
    )))) : null)
  ), /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px" }, /* @__PURE__ */ React3.createElement(
    MainButton,
    {
      disabled: isLoading || ticket.state === "CANCELLED" /* CANCELLED */ || !quoteValidation.canEdit || visibleSuggestions.hasVisibleSuggestions || Boolean(ticketEditing),
      onClick: handleStartEditing
    },
    translations.ticket.editDetails
  ))), /* @__PURE__ */ React3.createElement(RequestContent, { hasBorderRadius: !showRequestFooter }, /* @__PURE__ */ React3.createElement(GridContainer, null, /* @__PURE__ */ React3.createElement(AddressContainer, { gridColumn: "1 / 3" }, /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && expedientValidation.shouldShow ? expedientValidation.fieldValidations.isShipperIdMissing : false
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangeShipperDataCompanyId(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.id,
            name: "shipperDataCompanyId",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.shipperData.companyId
          }
        )
      ),
      draftSuggestionValue: (_y = (_x = ticket.conversation) == null ? void 0 : _x.draftSuggestions) == null ? void 0 : _y.shipperDataId,
      ignoreBorder: true,
      isLoading,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isShipperIdMissing : false,
      label: translations.ticket.summary.clientId,
      onAiSuggestionClick: handleChangeShipperDataCompanyId,
      refreshData,
      style: { width: "140px" },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.companyId
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeComplementaryInfoExternalReference(
              e.target.value
            );
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.clientReference,
          name: "shipperDataCompanyReference",
          type: "text",
          value: (ticketEditing == null ? void 0 : ticketEditing.orderData.complementaryInfo.customerInternalReference) || ""
        }
      ),
      draftSuggestionValue: (_A = (_z = ticket.conversation) == null ? void 0 : _z.draftSuggestions) == null ? void 0 : _A.complementaryInfoExternalReference,
      ignoreBorder: true,
      ignoreLateralPadding: true,
      isLoading,
      label: translations.ticket.summary.clientReference,
      onAiSuggestionClick: handleChangeComplementaryInfoExternalReference,
      refreshData,
      style: { width: "165px" },
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.complementaryInfo.customerInternalReference
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeShipperDataLanguage(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.language,
          name: "shipperDataLanguage",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.shipperData.language
        }
      ),
      draftSuggestionValue: (_C = (_B = ticket.conversation) == null ? void 0 : _B.draftSuggestions) == null ? void 0 : _C.shipperDataLanguage,
      ignoreBorder: true,
      ignoreLateralPadding: true,
      isLoading,
      label: translations.ticket.language,
      onAiSuggestionClick: handleChangeShipperDataLanguage,
      refreshData,
      style: { width: "140px" },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.language
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeShipperDataCompanyName(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.companyName,
          name: "shipperDataCompanyName",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.shipperData.companyName
        }
      ),
      draftSuggestionValue: (_E = (_D = ticket.conversation) == null ? void 0 : _D.draftSuggestions) == null ? void 0 : _E.shipperDataCompanyName,
      ignoreBorder: true,
      ignoreLateralPadding: true,
      isLoading,
      label: translations.ticket.summary.clientName,
      onAiSuggestionClick: handleChangeShipperDataCompanyName,
      refreshData,
      style: { flexGrow: 1 },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.companyName
    }
  )), /* @__PURE__ */ React3.createElement(AddressContainer, { gridColumn: "1 / 3" }, /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeShipperDataContactName(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.contactName,
          name: "shipperDataContactName",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.shipperData.contactName
        }
      ),
      draftSuggestionValue: (_G = (_F = ticket.conversation) == null ? void 0 : _F.draftSuggestions) == null ? void 0 : _G.shipperDataContactName,
      ignoreBorder: true,
      isLoading,
      label: translations.ticket.summary.contactName,
      onAiSuggestionClick: handleChangeShipperDataContactName,
      refreshData,
      style: { width: "100%" },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.contactName
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeShipperDataEmail(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.email,
          name: "shipperDataEmail",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.shipperData.email
        }
      ),
      draftSuggestionValue: (_I = (_H = ticket.conversation) == null ? void 0 : _H.draftSuggestions) == null ? void 0 : _I.shipperDataEmail,
      ignoreBorder: true,
      ignoreLateralPadding: true,
      isLoading,
      label: translations.ticket.summary.email,
      onAiSuggestionClick: handleChangeShipperDataEmail,
      refreshData,
      style: { width: "100%" },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.email
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            void handleChangeShipperDataPhone(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.phone,
          name: "shipperDataPhone",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.shipperData.phone
        }
      ),
      draftSuggestionValue: (_K = (_J = ticket.conversation) == null ? void 0 : _J.draftSuggestions) == null ? void 0 : _K.shipperDataPhone,
      ignoreBorder: true,
      ignoreLateralPadding: true,
      isLoading,
      label: translations.ticket.summary.phone,
      onAiSuggestionClick: handleChangeShipperDataPhone,
      refreshData,
      style: { width: "100%" },
      ticket,
      ticketEditing,
      ticketValue: ticket.shipperData.phone
    }
  )), /* @__PURE__ */ React3.createElement(AddressContainer, null, /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && expedientValidation.shouldShow ? expedientValidation.fieldValidations.isPickupCompanyNameMissing : false
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangePickupContact(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.originContact,
            name: "pickupContact",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.contact
          }
        )
      ),
      draftSuggestionValue: (_N = (_M = (_L = ticket.conversation) == null ? void 0 : _L.draftSuggestions) == null ? void 0 : _M.pickup) == null ? void 0 : _N.contact,
      ignoreBorder: true,
      ignoreMarginBottom: true,
      isLoading,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isPickupCompanyNameMissing : false,
      label: translations.ticket.summary.originContact,
      onAiSuggestionClick: handleChangePickupContact,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.pickup.contact
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && expedientValidation.shouldShow ? expedientValidation.fieldValidations.isPickupAddressMissing : false
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangePickupAddress(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.address,
            name: "pickupAddress",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.address
          }
        )
      ),
      draftSuggestionValue: (_Q = (_P = (_O = ticket.conversation) == null ? void 0 : _O.draftSuggestions) == null ? void 0 : _P.pickup) == null ? void 0 : _Q.address,
      ignoreBorder: true,
      ignoreMarginBottom: true,
      isLoading,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isPickupAddressMissing : false,
      label: translations.ticket.summary.originAddress,
      onAiSuggestionClick: handleChangePickupAddress,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.pickup.address
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            handleChangePickupCity(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.city,
          name: "pickupCity",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.city,
          width: "50%"
        }
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isPickupAddressMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              handleChangePickupZipcode(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.zipCode,
            name: "pickupZipcode",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.zipcode
          }
        )
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isPickupAddressMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              handleChangePickupCountry(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.country,
            name: "pickupCountry",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.country
          }
        )
      )),
      draftSuggestionValue: (_T = (_S = (_R = ticket.conversation) == null ? void 0 : _R.draftSuggestions) == null ? void 0 : _S.pickup) == null ? void 0 : _T.addressInfo,
      ignoreBorder: true,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isPickupAddressMissingInfoForAIPrice : false,
      onAiSuggestionClick: handleChangeAiPickupCountry,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.pickup.addressInfoFormatted
    }
  )), /* @__PURE__ */ React3.createElement(AddressContainer, null, /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && expedientValidation.shouldShow ? expedientValidation.fieldValidations.isDropoffCompanyNameMissing : false
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangeDropoffContact(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.destinationContact,
            name: "dropoffContact",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.contact
          }
        )
      ),
      draftSuggestionValue: (_W = (_V = (_U = ticket.conversation) == null ? void 0 : _U.draftSuggestions) == null ? void 0 : _V.dropoff) == null ? void 0 : _W.contact,
      ignoreBorder: true,
      ignoreMarginBottom: true,
      isLoading,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isDropoffCompanyNameMissing : false,
      label: translations.ticket.summary.destinationContact,
      onAiSuggestionClick: handleChangeDropoffContact,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.dropoff.contact
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && expedientValidation.shouldShow ? expedientValidation.fieldValidations.isDropoffAddressMissing : false
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangeDropoffAddress(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.address,
            name: "dropoffAddress",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.address
          }
        )
      ),
      draftSuggestionValue: (_Z = (_Y = (_X = ticket.conversation) == null ? void 0 : _X.draftSuggestions) == null ? void 0 : _Y.dropoff) == null ? void 0 : _Z.address,
      ignoreBorder: true,
      ignoreMarginBottom: true,
      isLoading,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isDropoffAddressMissing : false,
      label: translations.ticket.summary.destinationAddress,
      onAiSuggestionClick: handleChangeDropoffAddress,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.dropoff.address
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeEvent: (e) => {
            handleChangeDropoffCity(e.target.value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.city,
          name: "dropoffCity",
          type: "text",
          value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.city,
          width: "50%"
        }
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isDropoffAddressMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              handleChangeDropoffZipcode(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.zipCode,
            name: "dropoffZipcode",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.zipcode
          }
        )
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isDropoffAddressMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              handleChangeDropoffCountry(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.country,
            name: "dropoffCountry",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.country
          }
        )
      )),
      draftSuggestionValue: (_aa = (_$ = (__ = ticket.conversation) == null ? void 0 : __.draftSuggestions) == null ? void 0 : _$.dropoff) == null ? void 0 : _aa.addressInfo,
      ignoreBorder: true,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isDropoffAddressMissingInfoForAIPrice : false,
      onAiSuggestionClick: handleChangeAiDropoffCountry,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.dropoff.addressInfoFormatted
    }
  )), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && aiPriceValidation.shouldShow ? isPickupDateMissingInfoForAIPrice : false
        },
        /* @__PURE__ */ React3.createElement("div", { style: { width: "100%" } }, /* @__PURE__ */ React3.createElement(
          DateInputComponent,
          {
            handleChangeValue: (name, value) => {
              handleChangeDate(value, "pickup");
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.date,
            name: "pickupDate",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.dateFormatted
          }
        ))
      ), /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "5px", width: "100%" }, /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && (aiPriceValidation.shouldShow && isPickupDateMissingInfoForAIPrice || expedientValidation.shouldShow && expedientValidation.fieldValidations.isPickupTimeFromMissing)
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              handleChangePickupTimeFrom(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.from,
            name: "pickupTime",
            type: "time",
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.timeFrom) || void 0
          }
        )
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && (aiPriceValidation.shouldShow && isPickupDateMissingInfoForAIPrice || expedientValidation.shouldShow && expedientValidation.fieldValidations.isPickupTimeToMissing)
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              handleChangePickupTimeTo(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.to,
            name: "pickupTime",
            type: "time",
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.timeTo) || void 0
          }
        )
      ))),
      draftSuggestionValue: (_da = (_ca = (_ba = ticket.conversation) == null ? void 0 : _ba.draftSuggestions) == null ? void 0 : _ca.pickup) == null ? void 0 : _da.formattedDateTime,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isPickupDateMissingInfoForAIPrice : false,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isPickupTimeFromMissing || expedientValidation.fieldValidations.isPickupTimeToMissing : false,
      label: translations.ticket.summary.pickupDate,
      onAiSuggestionClick: handleChangeAiPickupDateTime,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.pickup.formattedDateTime
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && aiPriceValidation.shouldShow ? isDropoffDateMissingInfoForAIPrice : false
        },
        /* @__PURE__ */ React3.createElement("div", { style: { width: "100%" } }, /* @__PURE__ */ React3.createElement(
          DateInputComponent,
          {
            handleChangeValue: (name, value) => {
              handleChangeDate(value, "dropoff");
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.date,
            name: "dropoffDate",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.dateFormatted
          }
        ))
      ), /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "5px", width: "100%" }, /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && (aiPriceValidation.shouldShow && isDropoffDateMissingInfoForAIPrice || expedientValidation.shouldShow && expedientValidation.fieldValidations.isDropoffTimeFromMissing)
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              handleChangeDropoffTimeFrom(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.from,
            name: "dropoffTime",
            type: "time",
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.timeFrom) || void 0
          }
        )
      ), /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(ticketEditing) && (aiPriceValidation.shouldShow && isDropoffDateMissingInfoForAIPrice || expedientValidation.shouldShow && expedientValidation.fieldValidations.isDropoffTimeToMissing)
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              handleChangeDropoffTimeTo(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.to,
            name: "dropoffTime",
            type: "time",
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.timeTo) || void 0
          }
        )
      ))),
      draftSuggestionValue: (_ga = (_fa = (_ea = ticket.conversation) == null ? void 0 : _ea.draftSuggestions) == null ? void 0 : _fa.dropoff) == null ? void 0 : _ga.formattedDateTime,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isDropoffDateMissingInfoForAIPrice : false,
      isRequiredForExpedient: expedientValidation.shouldShow ? expedientValidation.fieldValidations.isDropoffTimeFromMissing || expedientValidation.fieldValidations.isDropoffTimeToMissing : false,
      label: translations.ticket.summary.deliveryDate,
      onAiSuggestionClick: handleChangeAiDropoffDateTime,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.dropoff.formattedDateTime
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isNumberPalletsMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              void handleChangeCargoNumberOfPallets(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.numberOfPallets,
            name: "cargoType",
            type: "number",
            value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.numberOfPallets)
          }
        )
      ),
      draftSuggestionValue: (_ia = (_ha = ticket.conversation) == null ? void 0 : _ha.draftSuggestions) == null ? void 0 : _ia.numberOfPallets,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isNumberPalletsMissingInfoForAIPrice : false,
      label: translations.ticket.summary.numberOfPallets,
      onAiSuggestionClick: handleChangeCargoNumberOfPallets,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.cargo.numberOfPallets
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isCargoTypeMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangeCargoType(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.cargoType,
            name: "cargoType",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.cargoType
          }
        )
      ),
      draftSuggestionValue: (_ka = (_ja = ticket.conversation) == null ? void 0 : _ja.draftSuggestions) == null ? void 0 : _ka.cargoType,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isCargoTypeMissingInfoForAIPrice : false,
      label: translations.ticket.summary.cargoType,
      onAiSuggestionClick: handleChangeCargoType,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.cargo.cargoType
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isGoodsTypeMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          SelectWithInternalSearchInputComponent,
          {
            handleChangeValue: (_name, value) => {
              void handleChangeGoodsType(value);
            },
            isClearable: true,
            isDisabled: isLoading,
            label: translations.ticket.summary.goodsType,
            name: "goodsType",
            options: GOODS_TYPE_OPTIONS,
            portal: true,
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.goodsType) !== null && (ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.goodsType) !== void 0 ? String(ticketEditing.orderData.cargo.goodsType) : void 0
          }
        )
      ),
      draftSuggestionValue: (_ma = (_la = ticket.conversation) == null ? void 0 : _la.draftSuggestions) == null ? void 0 : _ma.goodsType,
      draftSuggestionDisplayValue: goodsTypeSuggestionLabel,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isGoodsTypeMissingInfoForAIPrice : false,
      isRequiredForExpedient: expedientValidation.shouldShow ? isGoodsTypeMissingForExpedient : false,
      label: translations.ticket.summary.goodsType,
      onAiSuggestionClick: handleChangeGoodsType,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: (_oa = (_na = GOODS_TYPE_OPTIONS.find((o) => o.value === String(ticket.orderData.cargo.goodsType))) == null ? void 0 : _na.label) != null ? _oa : null
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isVarietyMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          SelectWithInternalSearchInputComponent,
          {
            handleChangeValue: (_name, value) => {
              void handleChangeVariety(value);
            },
            isClearable: true,
            isDisabled: isLoading || !(ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.goodsType),
            label: translations.ticket.summary.variety,
            name: "varietyId",
            options: varietyOptions,
            portal: true,
            value: (ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.varietyId) !== null && (ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.varietyId) !== void 0 ? String(ticketEditing.orderData.cargo.varietyId) : void 0
          }
        )
      ),
      draftSuggestionValue: (_qa = (_pa = ticket.conversation) == null ? void 0 : _pa.draftSuggestions) == null ? void 0 : _qa.varietyId,
      draftSuggestionDisplayValue: varietySuggestionLabel,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isVarietyMissingInfoForAIPrice : false,
      isRequiredForExpedient: expedientValidation.shouldShow ? isVarietyMissingForExpedient : false,
      label: translations.ticket.summary.variety,
      onAiSuggestionClick: handleChangeVariety,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: (_ua = (_ta = (_sa = ticket.orderData.cargo.goodsType ? (_ra = GOODS_TYPE_OPTIONS.find(
        (option) => option.value === String(ticket.orderData.cargo.goodsType)
      )) == null ? void 0 : _ra.varieties : void 0) == null ? void 0 : _sa.find((o) => o.value === String(ticket.orderData.cargo.varietyId))) == null ? void 0 : _ta.label) != null ? _ua : null
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && aiPriceValidation.shouldShow && isVehicleTypeMissingInfoForAIPrice
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeEvent: (e) => {
              void handleChangeVehicleType(e.target.value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.vehicleType,
            name: "cargoType",
            type: "text",
            value: ticketEditing == null ? void 0 : ticketEditing.orderData.vehicleType
          }
        )
      ),
      draftSuggestionValue: (_wa = (_va = ticket.conversation) == null ? void 0 : _va.draftSuggestions) == null ? void 0 : _wa.vehicleType,
      isLoading,
      isRequiredForAIPrice: aiPriceValidation.shouldShow ? isVehicleTypeMissingInfoForAIPrice : false,
      label: translations.ticket.summary.vehicleType,
      onAiSuggestionClick: handleChangeVehicleType,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.vehicleType
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        RequiredFieldWrapper,
        {
          showBorder: Boolean(
            ticketEditing && Boolean(expedientValidation.shouldShow) && expedientValidation.fieldValidations.isCargoWeightMissing
          )
        },
        /* @__PURE__ */ React3.createElement(
          Input,
          {
            handleChangeValue: (name, value) => {
              void handleChangeCargoWeight(value);
            },
            isDisabled: isLoading,
            label: translations.ticket.summary.weight,
            name: "cargoType",
            type: "number",
            value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.weight)
          }
        )
      ),
      draftSuggestionValue: (_ya = (_xa = ticket.conversation) == null ? void 0 : _xa.draftSuggestions) == null ? void 0 : _ya.weight,
      isLoading,
      isRequiredForExpedient: Boolean(
        Boolean(expedientValidation.shouldShow) && Boolean(expedientValidation.fieldValidations.isCargoWeightMissing)
      ),
      label: translations.ticket.summary.weight,
      onAiSuggestionClick: handleChangeCargoWeight,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.cargo.weight
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeValue: (name, value) => {
            void handleChangeCargoLinearMeters(value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.linearMeters,
          name: "cargoType",
          type: "number",
          value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.linearMeters)
        }
      ),
      draftSuggestionValue: (_Aa = (_za = ticket.conversation) == null ? void 0 : _za.draftSuggestions) == null ? void 0 : _Aa.linearMeters,
      isLoading,
      label: translations.ticket.summary.linearMeters,
      onAiSuggestionClick: handleChangeCargoLinearMeters,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.cargo.linearMeters
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        Input,
        {
          handleChangeValue: (name, value) => {
            void handleChangeCargoVolume(value);
          },
          isDisabled: isLoading,
          label: translations.ticket.summary.volume,
          name: "cargoType",
          type: "number",
          value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.cargo.volume)
        }
      ),
      draftSuggestionValue: (_Ca = (_Ba = ticket.conversation) == null ? void 0 : _Ba.draftSuggestions) == null ? void 0 : _Ca.volume,
      isLoading,
      label: translations.ticket.summary.volume,
      onAiSuggestionClick: handleChangeCargoVolume,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.cargo.volume
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        TextAreaObservations,
        {
          disabled: isLoading,
          name: "observationsPickup",
          onChange: (e) => {
            void handleChangePickupObservations(e.target.value);
          },
          value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.pickup.observations)
        }
      ),
      draftSuggestionValue: (_Fa = (_Ea = (_Da = ticket.conversation) == null ? void 0 : _Da.draftSuggestions) == null ? void 0 : _Ea.pickup) == null ? void 0 : _Fa.observations,
      ignoreBorder: true,
      isLoading,
      isTextArea: true,
      label: translations.ticket.pickupObservations,
      onAiSuggestionClick: handleChangePickupObservations,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.pickup.observations
    }
  ), /* @__PURE__ */ React3.createElement(
    FieldContainerComponent,
    {
      EditComponent: /* @__PURE__ */ React3.createElement(
        TextAreaObservations,
        {
          disabled: isLoading,
          name: "observationsPickup",
          onChange: (e) => {
            void handleChangeDropoffObservations(e.target.value);
          },
          value: String(ticketEditing == null ? void 0 : ticketEditing.orderData.dropoff.observations)
        }
      ),
      draftSuggestionValue: (_Ia = (_Ha = (_Ga = ticket.conversation) == null ? void 0 : _Ga.draftSuggestions) == null ? void 0 : _Ha.dropoff) == null ? void 0 : _Ia.observations,
      ignoreBorder: true,
      isLoading,
      isTextArea: true,
      label: translations.ticket.dropoffObservations,
      onAiSuggestionClick: handleChangeDropoffObservations,
      refreshData,
      ticket,
      ticketEditing,
      ticketValue: ticket.orderData.dropoff.observations
    }
  ))), ticketEditing || numberOfDraftSuggestions > 0 ? /* @__PURE__ */ React3.createElement(RequestFooter, { height: REQUEST_FOOTER_HEIGHT }, /* @__PURE__ */ React3.createElement(RequestToolbar, null, Boolean(!ticketEditing) && /* @__PURE__ */ React3.createElement(React3.Fragment, null, !ticketEditing && numberOfDraftSuggestions > 0 && (((_Ja = ticket.conversation) == null ? void 0 : _Ja.draftSuggestions) && ticket.state !== "CANCELLED" /* CANCELLED */ && ticket.state !== "REJECTED" /* REJECTED */ ? /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px" }, /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "5px" }, /* @__PURE__ */ React3.createElement(PendingChangesCounter, null, numberOfDraftSuggestions), /* @__PURE__ */ React3.createElement(
    TextComponent,
    {
      color: "var(--otk-theme-color-blue-200);",
      fontSize: "12px",
      fontWeight: "500"
    },
    translations.ticket.pendingChangesMessage
  ))), /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "15px" }, /* @__PURE__ */ React3.createElement(
    SecondaryButton,
    {
      disabled: isLoading,
      onClick: () => {
        void handleRejectAllChanges();
      }
    },
    /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "5px" }, /* @__PURE__ */ React3.createElement(
      IconComponent2,
      {
        color: "var(--otk-theme-color-blue-500)",
        name: iconNames3.close,
        sizeInPixels: 12
      }
    ), translations.ticket.rejectAll)
  ), /* @__PURE__ */ React3.createElement(
    MainButton,
    {
      disabled: isLoading,
      onClick: () => {
        void handleAcceptAllChanges();
      }
    },
    /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "5px" }, /* @__PURE__ */ React3.createElement(
      IconComponent2,
      {
        color: "var(--otk-theme-color-white)",
        name: iconNames3.check,
        sizeInPixels: 20
      }
    ), translations.ticket.acceptAll)
  ))) : null)), Boolean(ticketEditing || numberOfDraftSuggestions === 0) && /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(CancelButton, { disabled: isLoading, onClick: cancelEditing }, translations.ticket.cancel)), /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, ticket.quote && ticket.state === "QUOTE_SENT" /* QUOTESENT */ ? /* @__PURE__ */ React3.createElement(FlexComponent2, { gap: "10px" }, /* @__PURE__ */ React3.createElement(
    IconButton,
    {
      disabled: isLoading,
      onClick: () => {
        void openRejectQuoteModal();
      },
      title: `${translations.ticket.reject} ${ticket.id}`
    },
    translations.ticket.reject,
    "XX"
  ), /* @__PURE__ */ React3.createElement(
    IconButton,
    {
      disabled: isLoading,
      onClick: () => {
        void changeTicketStateLocal("ACCEPTED" /* ACCEPTED */);
      },
      title: `${translations.ticket.accept} ${ticket.id}`
    },
    translations.ticket.accept,
    "XXX"
  )) : void 0, /* @__PURE__ */ React3.createElement(
    MainButton,
    {
      disabled: isLoading,
      onClick: () => {
        void handleSaveChanges();
      }
    },
    translations.ticket.saveChanges
  ))))) : null), /* @__PURE__ */ React3.createElement(QuoteContainer, { height: QUOTE_HEIGHT }, /* @__PURE__ */ React3.createElement(QuoteHeader, null, /* @__PURE__ */ React3.createElement(
    FlexComponent2,
    {
      alignItems: "center",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React3.createElement(Title, null, translations.ticket.quoteDetailsTitle),
    aiPriceErrors.length > 0 ? /* @__PURE__ */ React3.createElement(AiPriceErrorNote, null, /* @__PURE__ */ React3.createElement(
      IconComponent2,
      {
        color: "#ef4444",
        name: iconNames3.circleExclamation,
        sizeInPixels: 16
      }
    ), /* @__PURE__ */ React3.createElement("div", null, aiPriceErrors.map((error) => /* @__PURE__ */ React3.createElement("div", { key: error, style: { fontSize: "11px" } }, error)))) : null
  ), /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px" }, /* @__PURE__ */ React3.createElement(LabelWithIconContainerComponent, null, getTicketStateLabel(ticketStateForAiPrice, translations), /* @__PURE__ */ React3.createElement(
    LabelWithIconContainerIconContainerComponent,
    {
      backgroundColor: TicketColorStates[ticketStateForAiPrice]
    },
    /* @__PURE__ */ React3.createElement(
      IconComponent2,
      {
        color: "white",
        name: getTicketIconName(ticketStateForAiPrice),
        sizeInPixels: 16
      }
    )
  )))), /* @__PURE__ */ React3.createElement(QuoteToolbar, null, /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", flexDirection: "row", gap: "5px", justifyContent: "center" }, /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", flexDirection: "row", gap: "5px" }, /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px" }, /* @__PURE__ */ React3.createElement(
    SemaphoreInputComponent,
    {
      isLoading: loadingAiPrice,
      label: translations.ticket.summary.suggestedAiPrice,
      labelFontSize: "10px",
      level: aiPrice == null ? void 0 : aiPrice.classification,
      value: (aiPrice == null ? void 0 : aiPrice.price.amount) ? String(aiPrice.price.formatted_amount) : "",
      width: "150px"
    }
  ), aiPrice ? /* @__PURE__ */ React3.createElement(
    RecalculateAIPriceButton,
    {
      disabled: loadingAiPrice,
      onClick: () => void onRecalculateAIPrice()
    },
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement("g", { clipPath: "url(#clip0_5971_5327)" }, /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M11.8887 11.882C12.6048 11.1684 13.1099 10.271 13.3484 9.28862C13.5868 8.30623 13.5493 7.27708 13.24 6.31465C13.1728 6.10425 13.192 5.87577 13.2933 5.67948C13.3945 5.48319 13.5696 5.33517 13.78 5.26798C13.9904 5.2008 14.2189 5.21994 14.4152 5.32121C14.6115 5.42248 14.7595 5.59758 14.8267 5.80798C15.2417 7.10517 15.2786 8.49376 14.9329 9.81113C14.5873 11.1285 13.8735 12.3201 12.875 13.2464C11.8766 14.1728 10.6349 14.7954 9.29533 15.0415C7.95578 15.2876 6.57384 15.1469 5.31136 14.636C5.27591 14.6217 5.23662 14.6202 5.20016 14.6316C5.1637 14.643 5.13232 14.6667 5.11136 14.6987L4.49669 15.632C4.42429 15.7424 4.32073 15.8288 4.19913 15.8803C4.07754 15.9318 3.94339 15.946 3.81371 15.9212C3.68402 15.8963 3.56464 15.8335 3.47069 15.7407C3.37675 15.648 3.31248 15.5294 3.28603 15.4L2.68069 12.462C2.67151 12.4181 2.66682 12.3735 2.66669 12.3287C2.66681 12.1751 2.71995 12.0263 2.81713 11.9073C2.9143 11.7884 3.04955 11.7067 3.20002 11.676L6.13736 11.0667C6.26647 11.0401 6.40055 11.0524 6.52267 11.102C6.64479 11.1516 6.74946 11.2363 6.82344 11.3454C6.89743 11.4545 6.93742 11.5831 6.93835 11.7149C6.93929 11.8467 6.90113 11.9759 6.82869 12.086L6.24136 12.9787C6.22717 13.0002 6.21815 13.0247 6.21502 13.0502C6.2119 13.0758 6.21474 13.1018 6.22333 13.126C6.23192 13.1503 6.24603 13.1723 6.26454 13.1902C6.28305 13.2081 6.30547 13.2215 6.33002 13.2293C7.29117 13.5347 8.31766 13.5705 9.29777 13.333C10.2779 13.0954 11.174 12.5935 11.8887 11.882Z",
          fill: "#2563EB"
        }
      ), /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12.112 0.0780048C12.2419 0.100125 12.3623 0.16025 12.4581 0.250785C12.5538 0.34132 12.6206 0.458203 12.65 0.586671L13.3166 3.512C13.3364 3.59746 13.3391 3.68596 13.3245 3.77246C13.31 3.85895 13.2786 3.94172 13.232 4.01604C13.1854 4.09035 13.1246 4.15475 13.0531 4.20553C12.9816 4.25632 12.9008 4.2925 12.8153 4.312L9.89064 4.97867C9.7621 5.00797 9.62776 4.99851 9.5046 4.95147C9.38144 4.90443 9.27499 4.82193 9.19871 4.71439C9.12243 4.60686 9.07975 4.47913 9.07606 4.34734C9.07237 4.21556 9.10783 4.08564 9.17797 3.974L9.78197 3.012C9.79598 2.99081 9.8049 2.96666 9.80802 2.94145C9.81114 2.91624 9.80839 2.89064 9.79997 2.86667C9.7912 2.84274 9.7771 2.82112 9.75873 2.80345C9.74037 2.78578 9.71822 2.77252 9.69397 2.76467C8.73579 2.45409 7.7107 2.41264 6.73057 2.64485C5.75043 2.87705 4.8529 3.37398 4.13589 4.08143C3.41888 4.78888 2.90995 5.67966 2.66461 6.65659C2.41927 7.63352 2.44695 8.65907 2.74464 9.62134C2.78023 9.72676 2.79434 9.83825 2.78615 9.94922C2.77796 10.0602 2.74762 10.1684 2.69694 10.2675C2.64625 10.3665 2.57624 10.4544 2.49103 10.526C2.40583 10.5975 2.30715 10.6513 2.20083 10.6841C2.09451 10.7169 1.98269 10.7281 1.87197 10.717C1.76125 10.7059 1.65388 10.6728 1.55618 10.6195C1.45849 10.5663 1.37245 10.494 1.30314 10.4069C1.23383 10.3199 1.18266 10.2198 1.15264 10.1127C0.75259 8.81916 0.727143 7.43879 1.07925 6.13142C1.43135 4.82404 2.1466 3.64316 3.14216 2.72552C4.13772 1.80788 5.37287 1.19103 6.70454 0.946416C8.03622 0.701797 9.40995 0.839418 10.6666 1.34334C10.7025 1.35724 10.7421 1.35819 10.7786 1.34602C10.8152 1.33385 10.8463 1.30932 10.8666 1.27667L11.4306 0.379338C11.5013 0.266994 11.6039 0.178303 11.7253 0.124619C11.8467 0.0709362 11.9813 0.0547056 12.112 0.0780048Z",
          fill: "#2563EB"
        }
      )),
      /* @__PURE__ */ React3.createElement("defs", null, /* @__PURE__ */ React3.createElement("clipPath", { id: "clip0_5971_5327" }, /* @__PURE__ */ React3.createElement(
        "rect",
        {
          fill: "white",
          height: "16",
          transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 16 16)",
          width: "16"
        }
      )))
    )
  ) : null))), /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px", height: "60px" }, /* @__PURE__ */ React3.createElement("div", null, ticketEditing ? /* @__PURE__ */ React3.createElement(
    Input,
    {
      handleChangeValue: (name, value) => {
        handleChangePrice(value);
      },
      isDisabled: isLoading,
      label: translations.ticket.summary.fixedPrice,
      name: "price",
      type: "number",
      value: ((_Ka = ticketEditing.quote) == null ? void 0 : _Ka.price.amount) ? String(ticketEditing.quote.price.amount) : "",
      width: "150px"
    }
  ) : /* @__PURE__ */ React3.createElement(
    Input,
    {
      handleChangeValue: (name, value) => {
        handleChangePrice(value);
      },
      isDisabled: true,
      label: translations.ticket.summary.fixedPrice,
      name: "price",
      type: "text",
      value: ((_La = ticket.quote) == null ? void 0 : _La.price.amount) ? String(ticket.quote.price.formatted) : "",
      width: "150px"
    }
  )), ticket.quote && ticket.state === "QUOTE_SENT" /* QUOTESENT */ ? /* @__PURE__ */ React3.createElement(FlexComponent2, { alignItems: "center", gap: "10px" }, /* @__PURE__ */ React3.createElement(
    IconButton,
    {
      disabled: isLoading,
      onClick: () => {
        void openRejectQuoteModal();
      },
      title: translations.ticket.reject
    },
    translations.ticket.reject
  ), /* @__PURE__ */ React3.createElement(
    IconButton,
    {
      disabled: isLoading,
      onClick: () => {
        void changeTicketStateLocal("ACCEPTED" /* ACCEPTED */);
      },
      title: translations.ticket.accept
    },
    translations.ticket.accept
  )) : void 0))));
}

// src/pages/ticket/components/chat/chat-component.tsx
import React5, { useEffect, useRef } from "react";
import styled6 from "styled-components";
import { FlexComponent as FlexComponent3, TextComponent as TextComponent2 } from "@ontruck/fe-ui";
import { CircleCheckNoBackgroundIcon as CircleCheckNoBackgroundIcon2, IconComponent as IconComponent3, iconNames as iconNames4 } from "@ontruck/fe-icons";

// src/pages/ticket/components/chat/components/message-component.tsx
import React4 from "react";
import styled5 from "styled-components";
import { getReadableDate } from "@ontruck/fe-core";
var Message = styled5.div`
  margin-bottom: 12px;
  max-width: 80%;
  align-self: ${(props) => props.role === "user" ? "flex-end" : "flex-start"};
  background-color: ${(props) => props.role === "user" ? "var(--otk-theme-color-blue-500)" : "var(--otk-theme-color-white)"};
  color: ${(props) => props.role === "user" ? "var(--otk-theme-color-white)" : "var(--otk-theme-color-grey-900)"};
  padding: 10px 14px;
  border-radius: 10px;
  margin-left: ${(props) => props.role === "user" ? "auto" : "0"};
  border: 1px solid var(--otk-theme-color-grey-200);
`;
var MessageHeader = styled5.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;
var MessageName = styled5.div`
  font-size: 13.5px;
  font-weight: 600;
  margin-bottom: 8px;
  color: ${(props) => props.role === "user" ? "var(--otk-theme-color-white)" : "var(--otk-theme-color-grey-800)"};
`;
var MessageContent = styled5.div`
  white-space: pre-line;
  font-size: 13.5px;
  color: ${(props) => props.role === "user" ? "var(--otk-theme-color-white)" : "var(--otk-theme-color-grey-900)"};
`;
var AttachmentsContainer = styled5.div`
  margin-top: 8px;
`;
var AttachmentItem = styled5.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  padding: 6px 8px;
  border-radius: 6px;
  background-color: ${(props) => props.role === "user" ? "rgba(255, 255, 255, 0.1)" : "var(--otk-theme-color-grey-100)"};
  border: 1px solid
    ${(props) => props.role === "user" ? "rgba(255, 255, 255, 0.2)" : "var(--otk-theme-color-grey-200)"};
`;
var AttachmentLink = styled5.a`
  color: ${(props) => props.role === "user" ? "var(--otk-theme-color-white)" : "var(--otk-theme-color-blue-500)"};
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  flex: 1;

  &:hover {
    text-decoration: underline;
  }
`;
var AttachmentSize = styled5.span`
  font-size: 11px;
  color: ${(props) => props.role === "user" ? "rgba(255, 255, 255, 0.7)" : "var(--otk-theme-color-grey-600)"};
  margin-left: 8px;
`;
var MessageInfo = styled5.div`
  border-top: 1px solid var(--otk-theme-color-grey-200);
  padding-top: 8px;
  margin-top: 8px;
`;
var formatFileSize = (bytes) => {
  if (bytes === 0)
    return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
function MessageComponent({
  message,
  role,
  name,
  attachments = [],
  createdAt,
  identifier
}) {
  const createdAtHumanReadable = getReadableDate(createdAt, "en");
  const translations = useAlianzaTranslations();
  return /* @__PURE__ */ React4.createElement(Message, { role }, /* @__PURE__ */ React4.createElement(MessageHeader, null, /* @__PURE__ */ React4.createElement(MessageName, { role }, name)), /* @__PURE__ */ React4.createElement(MessageContent, { role }, message), attachments.length > 0 && /* @__PURE__ */ React4.createElement(AttachmentsContainer, null, attachments.map((attachment) => /* @__PURE__ */ React4.createElement(AttachmentItem, { key: attachment.id, role }, /* @__PURE__ */ React4.createElement(
    AttachmentLink,
    {
      href: attachment.fileUrl,
      rel: "noopener noreferrer",
      role,
      target: "_blank"
    },
    "\u{1F4CE} ",
    attachment.filename
  ), /* @__PURE__ */ React4.createElement(AttachmentSize, { role }, formatFileSize(attachment.size))))), /* @__PURE__ */ React4.createElement(MessageInfo, null, translations.chat.from, ": ", identifier, " - ", createdAtHumanReadable));
}

// src/pages/ticket/components/chat/chat-component.tsx
var Container2 = styled6.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 40%;
  min-width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background-color: var(--otk-theme-color-white);
  overflow-y: hidden;
  @media (max-width: 900px) {
    width: 100%;
    min-width: 100%;
    margin-bottom: 20px;
  }
`;
var Header = styled6.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: var(--otk-theme-color-blue-500);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  color: var(--otk-theme-color-white);
  height: 55px;
`;
var Body = styled6.div`
  flex: 1;
  padding: 16px;
  border-left: 1px solid var(--otk-theme-color-grey-200);
  border-right: 1px solid var(--otk-theme-color-grey-200);
  overflow-y: auto;
  background-color: var(--otk-theme-color-white);
`;
var Footer = styled6.div`
  position: relative;
  padding: 16px;
  border: 1px solid var(--otk-theme-color-grey-200);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: var(--otk-theme-color-grey-100);
`;
var MessageInputContainer = styled6.div`
  position: relative;
  height: 200px;
  width: 100%;
`;
var MessageInput = styled6.textarea`
  resize: none;
  height: 200px;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--otk-theme-color-grey-300);
  border-radius: 4px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: var(--otk-theme-color-blue-500);
  }
`;
var SendButton = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--otk-theme-color-blue-500);
  color: white;
  border: none;
  font-size: 13.5px;
  border-radius: 5px;
  height: 40px;
  font-weight: 900;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var PendingSuggestionsContainer = styled6.div`
  border: 1px solid var(--otk-theme-color-grey-300);
  background-color: var(--grey200);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 8px;
`;
var MessageInputSkeleton = styled6.div`
  width: 100%;
  height: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
var SkeletonLine = styled6.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "16px"};

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
var RegenerateMessageButton = styled6.button`
  width: 28px;
  height: 28px;
  background-color: #c2d5ff;
  position: absolute;
  right: 15px;
  top: 10px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var DynamicActionButton = styled6.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px 6px 6px;
  gap: 6px;
  width: 195px;
  height: 28px;
  background: var(--otk-theme-color-blue-500);
  border-radius: 16px;
  border: none;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--otk-theme-color-white);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var AlertContainer = styled6.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 6px;
  background: #feddae;
  border-radius: 4px;
  height: 32px;
  align-self: stretch;
  margin-top: 8px;
  color: var(--accent900);
`;
function ChatComponent({
  ticket,
  isLoading,
  message,
  setMessage,
  onSendMessage,
  onRegenerateMessage,
  dynamicAction,
  onDynamicActionClick,
  isAiGeneratedMessage
}) {
  var _a, _b, _c, _d;
  const messageBodyRef = useRef(null);
  const translations = useAlianzaTranslations();
  const visibleSuggestions = useVisibleDraftSuggestions(ticket);
  const hasExpirationReminderSent = (_a = ticket.quote) == null ? void 0 : _a.expirationReminderSent;
  useEffect(() => {
    if (messageBodyRef.current) {
      messageBodyRef.current.scrollTop = messageBodyRef.current.scrollHeight;
    }
  }, [messageBodyRef, (_b = ticket.conversation) == null ? void 0 : _b.messages]);
  function handleInputChange(e) {
    setMessage(e.target.value ? e.target.value : "");
  }
  const hasDraftSuggestions = visibleSuggestions.hasVisibleSuggestions;
  const isMovedToTms = ticket.state === "DONE" /* DONE */;
  const isSendButtonDisabled = isLoading || !message || hasDraftSuggestions || isMovedToTms;
  const isDynamicActionDisabled = isLoading || hasDraftSuggestions || !dynamicAction.enabled || isMovedToTms;
  return /* @__PURE__ */ React5.createElement(Container2, null, /* @__PURE__ */ React5.createElement(Header, null, translations.chat.conversationWithClient, ": ", (_c = ticket.conversation) == null ? void 0 : _c.subject), /* @__PURE__ */ React5.createElement(Body, { ref: messageBodyRef }, /* @__PURE__ */ React5.createElement(FlexComponent3, { flexDirection: "column", gap: "12px" }, (_d = ticket.conversation) == null ? void 0 : _d.messages.map((messageRow) => /* @__PURE__ */ React5.createElement(
    MessageComponent,
    {
      attachments: messageRow.attachments,
      createdAt: messageRow.createdAt,
      identifier: messageRow.author.identifier,
      key: `message-${messageRow.id}`,
      message: messageRow.content,
      name: messageRow.author.name,
      role: messageRow.author.role
    }
  )), dynamicAction.enabled && !hasDraftSuggestions && !isLoading ? /* @__PURE__ */ React5.createElement(FlexComponent3, { justifyContent: "flex-start", margin: "8px 0 0 0" }, /* @__PURE__ */ React5.createElement(
    DynamicActionButton,
    {
      disabled: isDynamicActionDisabled,
      onClick: () => void onDynamicActionClick()
    },
    /* @__PURE__ */ React5.createElement(
      CircleCheckNoBackgroundIcon2,
      {
        color: "var(--otk-theme-color-white)",
        sizeInPixels: 16
      }
    ),
    dynamicAction.label
  )) : null)), /* @__PURE__ */ React5.createElement(Footer, null, /* @__PURE__ */ React5.createElement(MessageInputContainer, null, hasDraftSuggestions ? /* @__PURE__ */ React5.createElement(PendingSuggestionsContainer, null, /* @__PURE__ */ React5.createElement(TextComponent2, { fontSize: "16px" }, translations.chat.pendingConfirmation)) : null, isMovedToTms ? /* @__PURE__ */ React5.createElement(PendingSuggestionsContainer, null, /* @__PURE__ */ React5.createElement(TextComponent2, { fontSize: "16px" })) : null, !hasDraftSuggestions && !isMovedToTms && isLoading ? /* @__PURE__ */ React5.createElement(PendingSuggestionsContainer, null, /* @__PURE__ */ React5.createElement(MessageInputSkeleton, null, /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px", width: "60%" }), /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px" }), /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px" }), /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px", width: "80%" }), /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px" }), /* @__PURE__ */ React5.createElement(SkeletonLine, { height: "16px", width: "40%" }))) : null, !hasDraftSuggestions && !isLoading && !isMovedToTms && /* @__PURE__ */ React5.createElement(React5.Fragment, null, dynamicAction.enabled && isAiGeneratedMessage ? /* @__PURE__ */ React5.createElement(RegenerateMessageButton, { onClick: () => void onRegenerateMessage() }, /* @__PURE__ */ React5.createElement(
    "svg",
    {
      fill: "none",
      height: "16",
      viewBox: "0 0 16 16",
      width: "16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React5.createElement("g", { clipPath: "url(#clip0_5971_5327)" }, /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M11.8887 11.882C12.6048 11.1684 13.1099 10.271 13.3484 9.28862C13.5868 8.30623 13.5493 7.27708 13.24 6.31465C13.1728 6.10425 13.192 5.87577 13.2933 5.67948C13.3945 5.48319 13.5696 5.33517 13.78 5.26798C13.9904 5.2008 14.2189 5.21994 14.4152 5.32121C14.6115 5.42248 14.7595 5.59758 14.8267 5.80798C15.2417 7.10517 15.2786 8.49376 14.9329 9.81113C14.5873 11.1285 13.8735 12.3201 12.875 13.2464C11.8766 14.1728 10.6349 14.7954 9.29533 15.0415C7.95578 15.2876 6.57384 15.1469 5.31136 14.636C5.27591 14.6217 5.23662 14.6202 5.20016 14.6316C5.1637 14.643 5.13232 14.6667 5.11136 14.6987L4.49669 15.632C4.42429 15.7424 4.32073 15.8288 4.19913 15.8803C4.07754 15.9318 3.94339 15.946 3.81371 15.9212C3.68402 15.8963 3.56464 15.8335 3.47069 15.7407C3.37675 15.648 3.31248 15.5294 3.28603 15.4L2.68069 12.462C2.67151 12.4181 2.66682 12.3735 2.66669 12.3287C2.66681 12.1751 2.71995 12.0263 2.81713 11.9073C2.9143 11.7884 3.04955 11.7067 3.20002 11.676L6.13736 11.0667C6.26647 11.0401 6.40055 11.0524 6.52267 11.102C6.64479 11.1516 6.74946 11.2363 6.82344 11.3454C6.89743 11.4545 6.93742 11.5831 6.93835 11.7149C6.93929 11.8467 6.90113 11.9759 6.82869 12.086L6.24136 12.9787C6.22717 13.0002 6.21815 13.0247 6.21502 13.0502C6.2119 13.0758 6.21474 13.1018 6.22333 13.126C6.23192 13.1503 6.24603 13.1723 6.26454 13.1902C6.28305 13.2081 6.30547 13.2215 6.33002 13.2293C7.29117 13.5347 8.31766 13.5705 9.29777 13.333C10.2779 13.0954 11.174 12.5935 11.8887 11.882Z",
        fill: "#2563EB"
      }
    ), /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M12.112 0.0780048C12.2419 0.100125 12.3623 0.16025 12.4581 0.250785C12.5538 0.34132 12.6206 0.458203 12.65 0.586671L13.3166 3.512C13.3364 3.59746 13.3391 3.68596 13.3245 3.77246C13.31 3.85895 13.2786 3.94172 13.232 4.01604C13.1854 4.09035 13.1246 4.15475 13.0531 4.20553C12.9816 4.25632 12.9008 4.2925 12.8153 4.312L9.89064 4.97867C9.7621 5.00797 9.62776 4.99851 9.5046 4.95147C9.38144 4.90443 9.27499 4.82193 9.19871 4.71439C9.12243 4.60686 9.07975 4.47913 9.07606 4.34734C9.07237 4.21556 9.10783 4.08564 9.17797 3.974L9.78197 3.012C9.79598 2.99081 9.8049 2.96666 9.80802 2.94145C9.81114 2.91624 9.80839 2.89064 9.79997 2.86667C9.7912 2.84274 9.7771 2.82112 9.75873 2.80345C9.74037 2.78578 9.71822 2.77252 9.69397 2.76467C8.73579 2.45409 7.7107 2.41264 6.73057 2.64485C5.75043 2.87705 4.8529 3.37398 4.13589 4.08143C3.41888 4.78888 2.90995 5.67966 2.66461 6.65659C2.41927 7.63352 2.44695 8.65907 2.74464 9.62134C2.78023 9.72676 2.79434 9.83825 2.78615 9.94922C2.77796 10.0602 2.74762 10.1684 2.69694 10.2675C2.64625 10.3665 2.57624 10.4544 2.49103 10.526C2.40583 10.5975 2.30715 10.6513 2.20083 10.6841C2.09451 10.7169 1.98269 10.7281 1.87197 10.717C1.76125 10.7059 1.65388 10.6728 1.55618 10.6195C1.45849 10.5663 1.37245 10.494 1.30314 10.4069C1.23383 10.3199 1.18266 10.2198 1.15264 10.1127C0.75259 8.81916 0.727143 7.43879 1.07925 6.13142C1.43135 4.82404 2.1466 3.64316 3.14216 2.72552C4.13772 1.80788 5.37287 1.19103 6.70454 0.946416C8.03622 0.701797 9.40995 0.839418 10.6666 1.34334C10.7025 1.35724 10.7421 1.35819 10.7786 1.34602C10.8152 1.33385 10.8463 1.30932 10.8666 1.27667L11.4306 0.379338C11.5013 0.266994 11.6039 0.178303 11.7253 0.124619C11.8467 0.0709362 11.9813 0.0547056 12.112 0.0780048Z",
        fill: "#2563EB"
      }
    )),
    /* @__PURE__ */ React5.createElement("defs", null, /* @__PURE__ */ React5.createElement("clipPath", { id: "clip0_5971_5327" }, /* @__PURE__ */ React5.createElement(
      "rect",
      {
        fill: "white",
        height: "16",
        transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 16 16)",
        width: "16"
      }
    )))
  )) : null, /* @__PURE__ */ React5.createElement(
    MessageInput,
    {
      disabled: isLoading,
      onChange: handleInputChange,
      placeholder: translations.chat.writeMessage,
      value: message
    }
  ))), hasExpirationReminderSent ? /* @__PURE__ */ React5.createElement(AlertContainer, null, /* @__PURE__ */ React5.createElement(
    IconComponent3,
    {
      color: "var(--accent900)",
      name: iconNames4.circleExclamation,
      sizeInPixels: 12
    }
  ), /* @__PURE__ */ React5.createElement(TextComponent2, { color: "var(--accent900)", size: "s" }, translations.chat.expirationReminderSent)) : null, /* @__PURE__ */ React5.createElement(FlexComponent3, { gap: "10px", justifyContent: "flex-end", margin: "15px 0 0 0" }, /* @__PURE__ */ React5.createElement(SendButton, { disabled: isSendButtonDisabled, onClick: () => void onSendMessage(message) }, translations.chat.sendEmail))));
}

// src/pages/ticket/components/move-to-tms/move-to-tms-hook.tsx
import React7 from "react";
import { Modal } from "react-async-popup";

// src/pages/ticket/components/move-to-tms/move-to-tms-modal-component.tsx
import React6 from "react";
import { ModalComponent, TextComponent as TextComponent3 } from "@ontruck/fe-ui";

// src/pages/ticket/components/move-to-tms/move-to-tms-modal-hook.tsx
import { useCallback, useState as useState2 } from "react";
function useMoveToTmsModalHook({
  ticket,
  onSuccess,
  onCancel,
  config: config2
}) {
  const [loading, setLoading] = useState2(false);
  const onGoback = useCallback(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const onConfirm = useCallback(() => __async(this, null, function* () {
    setLoading(true);
    if (!ticket) {
      return;
    }
    const success = yield moveTicketToTmsApi(config2, ticket);
    setLoading(false);
    if (success) {
      onSuccess();
      onCancel();
    }
  }), [ticket, config2, onSuccess, onCancel]);
  return {
    loading,
    onGoback,
    onConfirm: () => {
      void onConfirm();
    }
  };
}

// src/pages/ticket/components/move-to-tms/move-to-tms-modal-component.tsx
function MoveToTmsModalComponent({
  ticket,
  onSuccess,
  onCancel,
  translations,
  config: config2
}) {
  const { loading, onConfirm, onGoback } = useMoveToTmsModalHook({
    ticket,
    onSuccess,
    onCancel,
    config: config2
  });
  return /* @__PURE__ */ React6.createElement(
    ModalComponent,
    {
      bodyComponent: /* @__PURE__ */ React6.createElement(TextComponent3, { color: "var(--otk-theme-color-grey-600)", fontSize: "14px" }, translations.warning),
      cancelButtonLabel: translations.goBack,
      confirmButtonLabel: translations.confirm,
      description: translations.title,
      isConfirmLoading: loading,
      isOpen: true,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm: () => {
        onConfirm();
      }
    }
  );
}

// src/pages/ticket/components/move-to-tms/move-to-tms-hook.tsx
var useMoveToTmsHook = ({
  ticket,
  onSuccess,
  translations,
  config: config2
}) => {
  const openMoveToTmsModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal.new({
      content: /* @__PURE__ */ React7.createElement(
        MoveToTmsModalComponent,
        {
          config: config2,
          onCancel: () => void destroy(),
          onSuccess,
          ticket,
          translations
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openMoveToTmsModal
  };
};

// src/pages/ticket/components/cancel-ticket/cancel-ticket-hook.tsx
import React9 from "react";
import { Modal as Modal2 } from "react-async-popup";

// src/pages/ticket/components/cancel-ticket/cancel-ticket-modal-component.tsx
import React8, { useState as useState4 } from "react";
import { FlexComponent as FlexComponent4, Input as Input2, ModalComponent as ModalComponent2 } from "@ontruck/fe-ui";
import styled7 from "styled-components";

// src/pages/ticket/components/cancel-ticket/cancel-ticket-modal-hook.tsx
import { useCallback as useCallback2, useState as useState3 } from "react";
function useCancelTicketModalHook({
  ticket,
  onSuccess,
  onCancel,
  config: config2
}) {
  const [loading, setLoading] = useState3(false);
  const onGoback = useCallback2(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const onConfirm = useCallback2(
    (feedBackDTO) => __async(this, null, function* () {
      setLoading(true);
      if (!ticket) {
        return;
      }
      const success = yield setTicketStatusApi(config2, ticket, "CANCELLED" /* CANCELLED */, feedBackDTO);
      setLoading(false);
      if (success) {
        onSuccess();
        onCancel();
      }
    }),
    [ticket, config2, onSuccess, onCancel]
  );
  return {
    loading,
    onGoback,
    onConfirm: (feedBackDTO) => {
      void onConfirm(feedBackDTO);
    }
  };
}

// src/pages/ticket/components/cancel-ticket/cancel-ticket-modal-component.tsx
var ModalRegularText = styled7.div`
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
var ModalBoldText = styled7.div`
  color: var(--grey700);
  font-feature-settings:
    'clig' off,
    'liga' off;
  align-self: stretch;
  /* 14px/medium */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
`;
var RadioInputsContainer = styled7.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;
var CheckboxInputContainer = styled7.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
var CheckboxLabel = styled7.div`
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
function CancelTicketModalComponent({
  ticket,
  onSuccess,
  onCancel,
  translations,
  config: config2
}) {
  const { loading, onConfirm, onGoback } = useCancelTicketModalHook({
    ticket,
    onSuccess,
    onCancel,
    config: config2
  });
  const availableReasons = {
    NO_FEEDBACK: translations.reasons.NO_FEEDBACK,
    LATE: translations.reasons.LATE,
    ALREADY_COVERED: translations.reasons.ALREADY_COVERED,
    TIMING: translations.reasons.TIMING,
    CONDITIONS: translations.reasons.CONDITIONS,
    EXPENSIVE: translations.reasons.EXPENSIVE,
    OTHER: translations.reasons.OTHER
  };
  const [reason, setReason] = useState4(Object.keys(availableReasons)[0]);
  const [text, setText] = useState4("");
  return /* @__PURE__ */ React8.createElement(
    ModalComponent2,
    {
      bodyComponent: /* @__PURE__ */ React8.createElement(FlexComponent4, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React8.createElement(ModalRegularText, { style: { marginTop: "16px", marginBottom: "4px" } }, translations.reasonPrompt), /* @__PURE__ */ React8.createElement(RadioInputsContainer, null, Object.keys(availableReasons).map((key) => /* @__PURE__ */ React8.createElement(
        CheckboxInputContainer,
        {
          key,
          onClick: () => {
            setReason(key);
          }
        },
        key === reason ? /* @__PURE__ */ React8.createElement(
          "svg",
          {
            fill: "none",
            height: "20",
            viewBox: "0 0 20 20",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React8.createElement("circle", { cx: "10", cy: "10", fill: "#2396DC", r: "10" }),
          /* @__PURE__ */ React8.createElement("circle", { cx: "10", cy: "10", fill: "white", r: "4" })
        ) : /* @__PURE__ */ React8.createElement(
          "svg",
          {
            fill: "none",
            height: "20",
            viewBox: "0 0 20 20",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React8.createElement("circle", { cx: "10", cy: "10", fill: "white", r: "9.5", stroke: "#E2E8EE" })
        ),
        /* @__PURE__ */ React8.createElement(CheckboxLabel, null, availableReasons[key])
      ))), /* @__PURE__ */ React8.createElement(
        Input2,
        {
          handleChangeEvent: (e) => {
            setText(e.target.value);
          },
          label: translations.cancellationDetailsLabel,
          name: "cancellation-details",
          type: "text",
          value: text,
          width: "100%"
        }
      ), /* @__PURE__ */ React8.createElement(ModalBoldText, { style: { marginTop: "16px" } }, translations.cannotBeUndone)),
      cancelButtonLabel: translations.goBack,
      confirmButtonLabel: translations.confirm,
      description: translations.title,
      isConfirmLoading: loading,
      isOpen: true,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm: () => {
        const feedBackDTO = {
          stars: 0,
          reasons: [
            {
              category: reason
            }
          ]
        };
        if (text.trim().length > 0)
          feedBackDTO.text = text;
        onConfirm(feedBackDTO);
      }
    }
  );
}

// src/pages/ticket/components/cancel-ticket/cancel-ticket-hook.tsx
var useCancelTicketHook = ({
  ticket,
  onSuccess,
  translations,
  config: config2
}) => {
  const openCancelTicketModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal2.new({
      content: /* @__PURE__ */ React9.createElement(
        CancelTicketModalComponent,
        {
          config: config2,
          onCancel: () => {
            void destroy();
          },
          onSuccess: () => {
            onSuccess();
          },
          ticket,
          translations
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openCancelTicketModal
  };
};

// src/pages/ticket/components/reject-quote/reject-quote-hook.tsx
import React11 from "react";
import { Modal as Modal3 } from "react-async-popup";

// src/pages/ticket/components/reject-quote/reject-quote-modal-component.tsx
import React10, { useState as useState6 } from "react";
import { FlexComponent as FlexComponent5, Input as Input3, ModalComponent as ModalComponent3 } from "@ontruck/fe-ui";
import styled8 from "styled-components";

// src/pages/ticket/components/reject-quote/reject-quote-modal-hook.tsx
import { useCallback as useCallback3, useState as useState5 } from "react";
function useRejectQuoteModalHook({
  ticket,
  onSuccess,
  onCancel,
  config: config2
}) {
  const [loading, setLoading] = useState5(false);
  const onGoback = useCallback3(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const onConfirm = useCallback3(
    (feedBackDTO) => __async(this, null, function* () {
      setLoading(true);
      if (!ticket) {
        return;
      }
      const success = yield setTicketStatusApi(config2, ticket, "REJECTED" /* REJECTED */, feedBackDTO);
      setLoading(false);
      if (success) {
        onSuccess();
        onCancel();
      }
    }),
    [ticket, config2, onSuccess, onCancel]
  );
  return {
    loading,
    onGoback,
    onConfirm: (feedBackDTO) => {
      void onConfirm(feedBackDTO);
    }
  };
}

// src/pages/ticket/components/reject-quote/reject-quote-modal-component.tsx
var ModalRegularText2 = styled8.div`
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
var ModalBoldText2 = styled8.div`
  color: var(--grey700);
  font-feature-settings:
    'clig' off,
    'liga' off;
  align-self: stretch;
  /* 14px/medium */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
`;
var RadioInputsContainer2 = styled8.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;
var CheckboxInputContainer2 = styled8.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
var CheckboxLabel2 = styled8.div`
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
function RejectQuoteModalComponent({
  ticket,
  onSuccess,
  onCancel,
  translations,
  config: config2
}) {
  const { loading, onConfirm, onGoback } = useRejectQuoteModalHook({
    ticket,
    onSuccess,
    onCancel,
    config: config2
  });
  const availableReasons = {
    NO_FEEDBACK: translations.reasons.NO_FEEDBACK,
    LATE: translations.reasons.LATE,
    ALREADY_COVERED: translations.reasons.ALREADY_COVERED,
    TIMING: translations.reasons.TIMING,
    CONDITIONS: translations.reasons.CONDITIONS,
    EXPENSIVE: translations.reasons.EXPENSIVE,
    OTHER: translations.reasons.OTHER
  };
  const [reason, setReason] = useState6(Object.keys(availableReasons)[0]);
  const [text, setText] = useState6("");
  return /* @__PURE__ */ React10.createElement(
    ModalComponent3,
    {
      bodyComponent: /* @__PURE__ */ React10.createElement(FlexComponent5, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React10.createElement(ModalRegularText2, { style: { marginTop: "16px", marginBottom: "4px" } }, translations.reasonPrompt), /* @__PURE__ */ React10.createElement(RadioInputsContainer2, null, Object.keys(availableReasons).map((key) => /* @__PURE__ */ React10.createElement(
        CheckboxInputContainer2,
        {
          key,
          onClick: () => {
            setReason(key);
          }
        },
        key === reason ? /* @__PURE__ */ React10.createElement(
          "svg",
          {
            fill: "none",
            height: "20",
            viewBox: "0 0 20 20",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React10.createElement("circle", { cx: "10", cy: "10", fill: "#2396DC", r: "10" }),
          /* @__PURE__ */ React10.createElement("circle", { cx: "10", cy: "10", fill: "white", r: "4" })
        ) : /* @__PURE__ */ React10.createElement(
          "svg",
          {
            fill: "none",
            height: "20",
            viewBox: "0 0 20 20",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React10.createElement("circle", { cx: "10", cy: "10", fill: "white", r: "9.5", stroke: "#E2E8EE" })
        ),
        /* @__PURE__ */ React10.createElement(CheckboxLabel2, null, availableReasons[key])
      ))), /* @__PURE__ */ React10.createElement(
        Input3,
        {
          handleChangeEvent: (e) => {
            setText(e.target.value);
          },
          label: translations.rejectionDetailsLabel,
          name: "rejection-details",
          type: "text",
          value: text,
          width: "100%"
        }
      ), /* @__PURE__ */ React10.createElement(ModalBoldText2, { style: { marginTop: "16px" } }, translations.cannotBeUndone)),
      cancelButtonLabel: translations.goBack,
      confirmButtonLabel: translations.confirm,
      description: translations.title,
      isConfirmLoading: loading,
      isOpen: true,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm: () => {
        const feedBackDTO = {
          stars: 0,
          reasons: [
            {
              category: reason
            }
          ]
        };
        if (text.trim().length > 0)
          feedBackDTO.text = text;
        onConfirm(feedBackDTO);
      }
    }
  );
}

// src/pages/ticket/components/reject-quote/reject-quote-hook.tsx
var useRejectQuoteHook = ({
  ticket,
  onSuccess,
  translations,
  config: config2
}) => {
  const openRejectQuoteModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal3.new({
      content: /* @__PURE__ */ React11.createElement(
        RejectQuoteModalComponent,
        {
          config: config2,
          onCancel: () => {
            void destroy();
          },
          onSuccess: () => {
            onSuccess();
          },
          ticket,
          translations
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openRejectQuoteModal
  };
};

// src/pages/ticket/ticket-page.tsx
var CotizationContainer = styled9.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background-color: var(--otk-theme-color-grey-100);
  padding: 0px 0px 0px 2%;
  font-size: 18px;
  min-height: 70px;
  font-weight: 600;
  color: var(--otk-theme-color-grey-600);
  align-items: center;
`;
var CancelButton2 = styled9.button`
  background-color: transparent;
  color: var(--otk-theme-color-blue-500);
  border: none;
  border-left: 1px solid var(--otk-theme-color-grey-200);
  border-right: 1px solid var(--otk-theme-color-grey-200);
  display: inline-block;
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  padding: 0px 14px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
var MoveToTmsButton = styled9.button`
  background-color: transparent;
  color: var(--otk-theme-color-blue-500);
  border: none;
  border-left: 1px solid var(--otk-theme-color-grey-200);
  border-right: 1px solid var(--otk-theme-color-grey-200);
  display: inline-block;
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  padding: 0px 14px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var CloseButton = styled9.button`
  background-color: transparent;
  border: none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: 100%;
  width: 55px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
var CotizacionFlexContainer = styled9.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;
  height: 100%;
  padding: 0px 2% 20px 2%;
  overflow-y: hidden;
  @media (max-width: 900px) {
    display: block;
    overflow-y: auto;
  }
`;
function TicketPage({ ticketId }) {
  var _a, _b;
  const {
    ticket,
    refreshData,
    isLoading: isLoadingTicket
  } = useGetTicketHook({
    ticketId
  });
  const {
    setTicket,
    setTicketStatus,
    generateTicketConfirmation,
    sendTicketMessage,
    requestMissingInfo
  } = useSetTicketHook();
  const [loadingPage, setLoadingPage] = useState7(false);
  const history = useHistory();
  const [message, setMessage] = useState7("");
  const [isAiGeneratedMessage, setIsAiGeneratedMessage] = useState7(false);
  const { getTicketFormattedId } = useTicketUtils();
  const [loadingAiPrice, setLoadingAiPrice] = useState7(false);
  const [aiPrice, setAiPrice] = useState7(null);
  const [aiPriceErrors, setAiPriceErrors] = useState7([]);
  const config2 = useConfigHook();
  const [pageLoaded, setPageLoaded] = useState7(false);
  const translations = useAlianzaTranslations();
  const aiPriceValidation = useTicketAiPriceValidation(ticket);
  const expedientValidation = useTicketExpedientValidation(ticket);
  const dynamicAction = useTicketDynamicAction(ticket, aiPriceValidation, expedientValidation);
  const { openMoveToTmsModal } = useMoveToTmsHook({
    ticket,
    onSuccess: () => {
      void handleRefreshData();
    },
    translations: {
      title: translations.ticket.moveToTmsModal.title,
      warning: translations.ticket.moveToTmsModal.warning,
      goBack: translations.ticket.moveToTmsModal.goBack,
      confirm: translations.ticket.moveToTmsModal.confirm
    },
    config: config2
  });
  const { openCancelTicketModal } = useCancelTicketHook({
    ticket,
    onSuccess: () => {
      void handleRefreshData();
    },
    translations: {
      title: translations.ticket.cancelTicketModal.title,
      warning: translations.ticket.cancelTicketModal.warning,
      goBack: translations.ticket.cancelTicketModal.goBack,
      confirm: translations.ticket.cancelTicketModal.confirm,
      reasonPrompt: translations.ticket.cancelTicketModal.reasonPrompt,
      cancellationDetailsLabel: translations.ticket.cancelTicketModal.cancellationDetailsLabel,
      cannotBeUndone: translations.ticket.cancelTicketModal.cannotBeUndone,
      reasons: {
        OTHER: translations.ticket.cancelTicketModal.reasons.OTHER,
        EXPENSIVE: translations.ticket.cancelTicketModal.reasons.EXPENSIVE,
        CONDITIONS: translations.ticket.cancelTicketModal.reasons.CONDITIONS,
        TIMING: translations.ticket.cancelTicketModal.reasons.TIMING,
        ALREADY_COVERED: translations.ticket.cancelTicketModal.reasons.ALREADY_COVERED,
        LATE: translations.ticket.cancelTicketModal.reasons.LATE,
        NO_FEEDBACK: translations.ticket.cancelTicketModal.reasons.NO_FEEDBACK
      }
    },
    config: config2
  });
  const { openRejectQuoteModal } = useRejectQuoteHook({
    ticket,
    onSuccess: () => {
      void handleRefreshData();
    },
    translations: {
      title: translations.ticket.rejectQuoteModal.title,
      warning: translations.ticket.rejectQuoteModal.warning,
      goBack: translations.ticket.rejectQuoteModal.goBack,
      confirm: translations.ticket.rejectQuoteModal.confirm,
      reasonPrompt: translations.ticket.rejectQuoteModal.reasonPrompt,
      rejectionDetailsLabel: translations.ticket.rejectQuoteModal.rejectionDetailsLabel,
      cannotBeUndone: translations.ticket.rejectQuoteModal.cannotBeUndone,
      reasons: {
        OTHER: translations.ticket.rejectQuoteModal.reasons.OTHER,
        EXPENSIVE: translations.ticket.rejectQuoteModal.reasons.EXPENSIVE,
        CONDITIONS: translations.ticket.rejectQuoteModal.reasons.CONDITIONS,
        TIMING: translations.ticket.rejectQuoteModal.reasons.TIMING,
        ALREADY_COVERED: translations.ticket.rejectQuoteModal.reasons.ALREADY_COVERED,
        LATE: translations.ticket.rejectQuoteModal.reasons.LATE,
        NO_FEEDBACK: translations.ticket.rejectQuoteModal.reasons.NO_FEEDBACK
      }
    },
    config: config2
  });
  useEffect2(() => {
    if (!ticket) {
      return;
    }
    if (pageLoaded) {
      return;
    }
    void handleGetTicketAiPrice();
    markTicketMessageAsViewed(ticket);
    setPageLoaded(true);
  }, [ticket]);
  useEffect2(() => {
    var _a2, _b2;
    if (!pageLoaded || !((_b2 = (_a2 = ticket == null ? void 0 : ticket.quote) == null ? void 0 : _a2.suggestedPrice) == null ? void 0 : _b2.amount)) {
      return;
    }
    void handleGetTicketAiPrice();
  }, [(_b = (_a = ticket == null ? void 0 : ticket.quote) == null ? void 0 : _a.suggestedPrice) == null ? void 0 : _b.amount]);
  function handleGetTicketAiPrice() {
    return __async(this, arguments, function* (newTicket = ticket) {
      var _a2, _b2;
      if (!newTicket) {
        return;
      }
      setLoadingAiPrice(true);
      setAiPriceErrors([]);
      if ((_b2 = (_a2 = newTicket.quote) == null ? void 0 : _a2.suggestedPrice) == null ? void 0 : _b2.amount) {
        setAiPrice({
          price: {
            amount: Number(newTicket.quote.suggestedPrice.amount),
            currency: newTicket.quote.suggestedPrice.currency,
            formatted_amount: newTicket.quote.suggestedPrice.formatted
          },
          classification: newTicket.quote.suggestedPrice.classification
        });
      } else {
        try {
          const res = yield getTicketAiPriceApi(config2, newTicket);
          setAiPrice(res);
          setAiPriceErrors([]);
        } catch (error) {
          let newErrors = ["Unexpected error"];
          if (error instanceof Error) {
            const parsedErrors = parseAiPriceErrors(error.message);
            newErrors = parsedErrors;
          }
          setAiPriceErrors(newErrors);
          setAiPrice(null);
        }
      }
      setLoadingAiPrice(false);
    });
  }
  function handleRecalculateAIPrice() {
    return __async(this, null, function* () {
      if (!ticket) {
        return;
      }
      yield handleGetTicketAiPrice(ticket);
    });
  }
  function handleUpdateTicket(newTicket) {
    return __async(this, null, function* () {
      if (!ticket) {
        return;
      }
      setLoadingPage(true);
      setMessage("");
      yield setTicket(newTicket, ticket);
      yield handleRefreshData(newTicket);
    });
  }
  function changeTicketState(state) {
    return __async(this, null, function* () {
      if (!ticket) {
        return;
      }
      setLoadingPage(true);
      yield setTicketStatus(ticket, state);
      yield handleRefreshData();
    });
  }
  function closeButton() {
    history.push("/copilot");
  }
  function handleDynamicAction() {
    return __async(this, null, function* () {
      if (!ticket) {
        return;
      }
      setLoadingPage(true);
      try {
        if (dynamicAction.type === "request_missing_info") {
          const responseMessage = yield requestMissingInfo(ticket.id);
          setMessage(responseMessage);
          setIsAiGeneratedMessage(true);
        } else if (dynamicAction.type === "generate_quote") {
          const quoteMessage = yield generateTicketConfirmation(ticket);
          setMessage(quoteMessage);
          setIsAiGeneratedMessage(true);
        }
        setTimeout(() => {
          void handleRefreshData();
        }, 1e3);
      } finally {
        setLoadingPage(false);
      }
    });
  }
  function sendMessage() {
    return __async(this, null, function* () {
      if (!(ticket == null ? void 0 : ticket.conversation) || !message.trim()) {
        return;
      }
      setLoadingPage(true);
      yield sendTicketMessage(ticket.conversation, message);
      setMessage("");
      setIsAiGeneratedMessage(false);
      setTimeout(() => {
        void handleRefreshData();
      }, 1e3);
    });
  }
  function handleRefreshData(_newTicket) {
    return __async(this, null, function* () {
      var _a2;
      setLoadingPage(true);
      const refreshedTicket = yield refreshData();
      if (refreshedTicket && !((_a2 = refreshedTicket.quote) == null ? void 0 : _a2.price.amount)) {
        yield handleGetTicketAiPrice(refreshedTicket);
      }
      setLoadingPage(false);
    });
  }
  function handleRegenerateMessage() {
    return __async(this, null, function* () {
      yield handleDynamicAction();
    });
  }
  const hasCompanyName = (ticket == null ? void 0 : ticket.shipperData.companyName) && ticket.shipperData.companyName.trim() !== "";
  const showMoveToTmsButton = (ticket == null ? void 0 : ticket.state) === "ACCEPTED" /* ACCEPTED */ && expedientValidation.isValid;
  return /* @__PURE__ */ React12.createElement(PageLayout, null, ticket ? /* @__PURE__ */ React12.createElement(PageContent, null, /* @__PURE__ */ React12.createElement(CotizationContainer, null, /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(TextComponent4, { color: "var(--otk-theme-color-grey-600)", fontSize: "16px" }, translations.ticket.cotization), /* @__PURE__ */ React12.createElement(
    TextComponent4,
    {
      color: "var(--otk-theme-color-blue-500)",
      fontSize: "18px",
      fontWeight: "600",
      margin: "10px 0px 0px 0px"
    },
    getTicketFormattedId(String(ticket.id)),
    " ",
    hasCompanyName ? `- ${ticket.shipperData.companyName}` : ""
  )), /* @__PURE__ */ React12.createElement(FlexComponent6, { gap: "0px", height: "100%" }, ticket.state !== "CANCELLED" /* CANCELLED */ ? /* @__PURE__ */ React12.createElement(CancelButton2, { disabled: loadingPage, onClick: () => void openCancelTicketModal() }, translations.ticket.cancelCotization) : void 0, showMoveToTmsButton ? /* @__PURE__ */ React12.createElement(MoveToTmsButton, { disabled: loadingPage, onClick: () => void openMoveToTmsModal() }, translations.ticket.moveToTms) : void 0, /* @__PURE__ */ React12.createElement(CloseButton, { disabled: loadingPage, onClick: closeButton }, /* @__PURE__ */ React12.createElement(
    IconComponent4,
    {
      color: "var(--otk-theme-color-blue-500)",
      name: iconNames5.close,
      sizeInPixels: 20
    }
  )))), /* @__PURE__ */ React12.createElement(CotizacionFlexContainer, null, /* @__PURE__ */ React12.createElement(
    ChatComponent,
    {
      dynamicAction,
      isAiGeneratedMessage,
      isLoading: loadingPage || isLoadingTicket,
      message,
      onDynamicActionClick: handleDynamicAction,
      onRegenerateMessage: handleRegenerateMessage,
      onSendMessage: sendMessage,
      setIsAiGeneratedMessage,
      setMessage,
      ticket
    }
  ), /* @__PURE__ */ React12.createElement(
    SummaryComponent,
    {
      aiPrice,
      aiPriceErrors,
      aiPriceValidation,
      changeTicketState,
      expedientValidation,
      handleUpdateTicket,
      isLoading: loadingPage,
      loadingAiPrice,
      onRecalculateAIPrice: handleRecalculateAIPrice,
      openRejectQuoteModal,
      refreshData: handleRefreshData,
      setIsLoading: setLoadingPage,
      ticket
    }
  ))) : void 0, /* @__PURE__ */ React12.createElement(Toaster, { richColors: true }));
}

// src/pages/dashboard/dashboard-page.tsx
import React27, { useEffect as useEffect3, useState as useState9 } from "react";
import { BoxesSpinnerComponent, TablePaginationComponent, PageLayout as PageLayout2 } from "@ontruck/fe-ui";
import styled22 from "styled-components";

// src/business/tickets/hooks/get-tickets-hook.ts
import useSWR2, { mutate as mutate2 } from "swr";
import moment5 from "moment";

// src/business/tickets/api/get-tickets-api.ts
import { toast as toast9 } from "sonner";
function getTicketsApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, filters) {
    var _a;
    try {
      const baseURL = `${apiBase}/v1/price-negotiation/tickets/`;
      const newFilters = __spreadValues({}, filters);
      if ((_a = newFilters.state) == null ? void 0 : _a.length) {
        newFilters.char = JSON.stringify({
          name: "synthetic_state",
          op: "in",
          value: newFilters.state
        });
      }
      delete newFilters.state;
      if (newFilters.search) {
        newFilters.q = JSON.stringify({
          name: "search",
          op: "raw",
          value: newFilters.search
        });
      }
      delete newFilters.search;
      const urlSearchNewFilters = {};
      Object.keys(newFilters).forEach((key) => {
        const value = newFilters[key];
        if (!value) {
          return;
        }
        urlSearchNewFilters[key] = value.toString();
      });
      const queryParams = new URLSearchParams(urlSearchNewFilters);
      let url = `${baseURL}?${queryParams.toString()}`;
      if (!url.endsWith("/")) {
        url = `${url}/`;
      }
      if (url.endsWith("/")) {
        url = url.slice(0, -1);
      }
      const response = yield fetch(url, {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) {
        return returnError8();
      }
      const data = yield response.json();
      return data;
    } catch (error) {
      return returnError8();
    }
  });
}
function returnError8() {
  toast9.error("Ha ocurrido un error al obtener las cotizaciones.");
  return {
    count: 0,
    next: null,
    previous: null,
    results: []
  };
}

// src/business/tickets/mappers/get-tickets-mapper.ts
function getTicketsMapper(ticketDtos) {
  return ticketDtos.map((t) => {
    return ticketMapper(t);
  });
}

// src/business/tickets/hooks/get-tickets-hook.ts
var RELOAD_TICKETS_LIST_INTERVAL_IN_SECONDS = 1e7;
function useGetTicketsHook({ filters }) {
  var _a, _b;
  const key = `copilot/tickets/${JSON.stringify(filters)}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(this, null, function* () {
    return getTicketsApi(config2, filters);
  });
  const { data, error, isLoading } = useSWR2(key, fetcher, {
    refreshInterval: RELOAD_TICKETS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const refreshData = () => __async(this, null, function* () {
    yield mutate2(key);
  });
  const ticketsMapped = data ? getTicketsMapper(data.results) : [];
  const totalTicketsCount = (_a = data == null ? void 0 : data.count) != null ? _a : 0;
  const groupedTickets = [];
  ticketsMapped.forEach((ticket) => {
    const momentDate = moment5(ticket.createdAt);
    const date = momentDate.format("YYYY-MM-DD");
    const monthName = MONTHS_NAMES[momentDate.month()];
    const textDate = `${monthName.abrev} ${momentDate.format("DD/YYYY")}`;
    const ticketDay = groupedTickets.find((t) => t.date === date);
    if (ticketDay) {
      ticketDay.tickets.push(ticket);
    } else {
      groupedTickets.push({ date, textDate, tickets: [ticket] });
    }
  });
  const ordering = filters.ordering || "created_at";
  const isDescending = ordering.startsWith("-");
  const orderField = isDescending ? ordering.substring(1) : ordering;
  groupedTickets.sort((groupA, groupB) => {
    return groupB.date.localeCompare(groupA.date);
  });
  groupedTickets.forEach((group) => {
    group.tickets.sort((a, b) => {
      let aValue;
      let bValue;
      if (orderField === "last_received_message") {
        aValue = b.lastReceivedMessage;
        bValue = a.lastReceivedMessage;
      } else {
        aValue = a.createdAt;
        bValue = b.createdAt;
      }
      const comparison = aValue.localeCompare(bValue);
      if (orderField === "created_at") {
        return isDescending ? -comparison : comparison;
      }
      return isDescending ? comparison : -comparison;
    });
  });
  return {
    refreshData,
    tickets: ticketsMapped,
    isLoading,
    error,
    totalTicketsCount,
    groupedTickets,
    next: data == null ? void 0 : data.next,
    previous: data == null ? void 0 : data.previous,
    count: (_b = data == null ? void 0 : data.count) != null ? _b : 0
  };
}

// src/pages/dashboard/components/table/tickets-table-component.tsx
import React25 from "react";

// src/pages/dashboard/components/table/components/grouped/grouped-header-component.tsx
import React13 from "react";
import { TextComponent as TextComponent5 } from "@ontruck/fe-ui";
import styled10 from "styled-components";
var Container3 = styled10.div`
  padding: var(--otk-theme-space-s);
  background-color: var(--otk-theme-color-white);
  color: var(--otk-theme-color-gray-100);
  border-bottom: var(--primary-top-bar-border);
`;
function GroupedHeaderComponent({
  groupedTicket
}) {
  return /* @__PURE__ */ React13.createElement(Container3, null, /* @__PURE__ */ React13.createElement(TextComponent5, { size: "s" }, groupedTicket.textDate, " (", groupedTicket.tickets.length, " cotizaciones)"));
}

// src/pages/dashboard/components/table/components/table/headers/table-headers-component.tsx
import React22 from "react";
import styled19 from "styled-components";

// src/pages/dashboard/components/table/components/table/columns/shipper-column-component.tsx
import React14 from "react";
import { TextComponent as TextComponent6 } from "@ontruck/fe-ui";
import { useHistory as useHistory2 } from "react-router-dom";

// src/pages/dashboard/components/table/components/table/components/body-column-component.tsx
import styled12, { css as css2 } from "styled-components";

// src/pages/dashboard/components/table/components/table/components/column-component.tsx
import styled11, { css } from "styled-components";
var Column = styled11.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 100px;
  ${(props) => Boolean(props.width) && css`
      flex-basis: ${props.width};
      max-width: ${props.width};
    `}
  ${(props) => Boolean(props.centerContent) && css`
      justify-content: center;
    `}
`;

// src/pages/dashboard/components/table/components/table/components/body-column-component.tsx
var BodyColumn = styled12(Column)`
  padding: ${({ noPadding }) => noPadding ? "0" : `var(--otk-theme-space-s)`};
  flex-direction: column;
  justify-content: center;
  min-height: 70px;
  width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  flex-grow: ${({ flexGrow }) => flexGrow};
  background-color: var(--otk-theme-color-grey-100);
  position: relative;
  ${(props) => Boolean(props.onClick) && css2`
      cursor: pointer;
      &:hover {
        background-color: var(--otk-theme-color-grey-200);
      }
    `}
  ${(props) => Boolean(props.columnBorderLeftColor) && css2`
      border-left: 3px ${props.columnBorderLeftColor} solid;
    `}
    ${(props) => Boolean(props.columnBorderLeftWidth) && css2`
      border-left-width: ${props.columnBorderLeftWidth};
    `}
    ${(props) => Boolean(props.backgroundColor) && css2`
      background-color: ${props.backgroundColor};
    `};
`;

// src/pages/dashboard/components/table/components/table/draft-suggestion-color.ts
var DRAFT_SUGGESTION_COLOR = "var(--otk-theme-color-grey-300)";

// src/pages/dashboard/components/table/components/table/columns/shipper-column-component.tsx
function ShipperColumn({ ticket, widths }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const history = useHistory2();
  const hasCompanyNameSuggestion = (_c = (_b = (_a = ticket.conversation) == null ? void 0 : _a.draftSuggestions) == null ? void 0 : _b.shipperDataCompanyName) == null ? void 0 : _c.aiSuggestion;
  const displayCompanyName = hasCompanyNameSuggestion ? (_f = (_e = (_d = ticket.conversation) == null ? void 0 : _d.draftSuggestions) == null ? void 0 : _e.shipperDataCompanyName) == null ? void 0 : _f.aiSuggestion : ticket.shipperData.companyName;
  const hasCompanyIdSuggestion = (_i = (_h = (_g = ticket.conversation) == null ? void 0 : _g.draftSuggestions) == null ? void 0 : _h.shipperDataId) == null ? void 0 : _i.aiSuggestion;
  const displayCompanyId = hasCompanyIdSuggestion ? (_l = (_k = (_j = ticket.conversation) == null ? void 0 : _j.draftSuggestions) == null ? void 0 : _k.shipperDataId) == null ? void 0 : _l.aiSuggestion : ticket.shipperData.companyId;
  return /* @__PURE__ */ React14.createElement(
    BodyColumn,
    {
      columnBorderLeftColor: "white",
      columnBorderLeftWidth: "2px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      onClick: () => {
        history.push(`/copilot/tickets/${ticket.id}`);
      },
      width: widths.width
    },
    /* @__PURE__ */ React14.createElement(
      TextComponent6,
      {
        color: hasCompanyNameSuggestion ? DRAFT_SUGGESTION_COLOR : "var(--otk-theme-color-grey-700)",
        fontWeight: "medium",
        margin: "0 0 5px 0",
        size: "s",
        truncate: true,
        uppercase: true
      },
      displayCompanyName
    ),
    /* @__PURE__ */ React14.createElement(
      TextComponent6,
      {
        color: hasCompanyIdSuggestion ? DRAFT_SUGGESTION_COLOR : "var(--otk-theme-color-grey-500)",
        fontWeight: "bold",
        margin: "var(--otk-theme-space-xs) 0 0 0",
        size: "xs"
      },
      "REF. ",
      displayCompanyId
    )
  );
}

// src/pages/dashboard/components/table/components/table/columns/ticket-column-component.tsx
import React15 from "react";
import { BallComponent as BallComponent2, FlexComponent as FlexComponent7, TextComponent as TextComponent7 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent5, iconNames as iconNames6 } from "@ontruck/fe-icons";
import styled14 from "styled-components";
import { useHistory as useHistory3 } from "react-router-dom";

// src/pages/dashboard/components/table/components/table/components/blue-text-component.tsx
import styled13 from "styled-components";
var BlueText = styled13.div`
  color: blue;
  font-size: 12px;
  color: var(--accent-color-blue);
  font-weight: 500;
`;

// src/pages/dashboard/components/table/components/table/columns/ticket-column-component.tsx
var CustomBlueText = styled14(BlueText)`
  font-size: 14px;
  font-weight: 500;
`;
var IconWrapper = styled14.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
function TicketColumn({ ticket, widths }) {
  var _a;
  const history = useHistory3();
  const { getTicketFormattedId } = useTicketUtils();
  const translations = useAlianzaTranslations();
  const ticketColor = TicketColorStates[ticket.state] ? TicketColorStates[ticket.state] : "blue";
  const hasExpirationReminderSent = (_a = ticket.quote) == null ? void 0 : _a.expirationReminderSent;
  return /* @__PURE__ */ React15.createElement(
    BodyColumn,
    {
      columnBorderLeftColor: ticketColor,
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      onClick: () => {
        history.push(`/copilot/tickets/${ticket.id}`);
      },
      width: widths.width
    },
    hasExpirationReminderSent ? /* @__PURE__ */ React15.createElement(IconWrapper, null, /* @__PURE__ */ React15.createElement(
      IconComponent5,
      {
        color: "var(--otk-theme-color-blue-600)",
        name: iconNames6.mailReply,
        sizeInPixels: 14
      }
    )) : null,
    /* @__PURE__ */ React15.createElement(CustomBlueText, null, "ID. ", getTicketFormattedId(ticket.id), " "),
    /* @__PURE__ */ React15.createElement(FlexComponent7, { alignItems: "center", gap: "5px", margin: "5px 0 0 0" }, /* @__PURE__ */ React15.createElement(BallComponent2, { backgroundColor: ticketColor }), /* @__PURE__ */ React15.createElement(TextComponent7, { size: "xs", uppercase: true }, getTicketStateLabel(ticket.state, translations)))
  );
}

// src/pages/dashboard/components/table/components/table/columns/locations-column-component.tsx
import React16 from "react";
import { FlexComponent as FlexComponent8, TextComponent as TextComponent8 } from "@ontruck/fe-ui";
import styled15 from "styled-components";
var HalfContainer = styled15.div`
  width: 50%;
`;
function LocationComponent({
  location,
  draftAddress
}) {
  const hasCitySuggestion = (draftAddress == null ? void 0 : draftAddress.city) && draftAddress.city !== location.city;
  const displayCity = hasCitySuggestion ? draftAddress.city : location.city;
  const hasCountrySuggestion = (draftAddress == null ? void 0 : draftAddress.country) && draftAddress.country !== location.country;
  const displayCountry = hasCountrySuggestion ? draftAddress.country : location.country;
  const hasZipcodeSuggestion = (draftAddress == null ? void 0 : draftAddress.zipcode) && draftAddress.zipcode !== location.zipcode;
  const displayZipcode = hasZipcodeSuggestion ? draftAddress.zipcode : location.zipcode;
  const hasFormattedDateTimeSuggestion = (draftAddress == null ? void 0 : draftAddress.formattedDateTime) && draftAddress.formattedDateTime !== location.formattedDateTime;
  const rawFormattedDateTime = hasFormattedDateTimeSuggestion ? draftAddress.formattedDateTime : location.formattedDateTime;
  const displayFormattedDateTime = (rawFormattedDateTime == null ? void 0 : rawFormattedDateTime.endsWith(" -")) ? rawFormattedDateTime.slice(0, -2) : rawFormattedDateTime;
  return /* @__PURE__ */ React16.createElement(HalfContainer, null, /* @__PURE__ */ React16.createElement(
    TextComponent8,
    {
      color: hasCitySuggestion ? DRAFT_SUGGESTION_COLOR : "var(--otk-theme-color-grey-700)",
      fontWeight: "medium",
      margin: "0 0 var(--otk-theme-space-xs) 0",
      size: "s",
      truncate: true,
      uppercase: true
    },
    displayCity
  ), /* @__PURE__ */ React16.createElement(TextComponent8, { color: "var(--otk-theme-color-grey-500)", fontWeight: "bold", size: "xs" }, /* @__PURE__ */ React16.createElement("span", { style: { color: hasCountrySuggestion ? DRAFT_SUGGESTION_COLOR : "inherit" } }, displayCountry), " - ", /* @__PURE__ */ React16.createElement("span", { style: { color: hasZipcodeSuggestion ? DRAFT_SUGGESTION_COLOR : "inherit" } }, displayZipcode)), /* @__PURE__ */ React16.createElement(
    TextComponent8,
    {
      color: hasFormattedDateTimeSuggestion ? DRAFT_SUGGESTION_COLOR : "var(--otk-theme-color-grey-500)",
      margin: "var(--otk-theme-space-xs) 0 0 0",
      size: "xs"
    },
    displayFormattedDateTime
  ));
}
function LocationsColumn({ ticket, widths }) {
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */ React16.createElement(
    BodyColumn,
    {
      backgroundColor: "#FFFFFF",
      columnBorderLeftColor: "var(--otk-theme-color-grey-200)",
      columnBorderLeftWidth: "1px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      width: widths.width
    },
    /* @__PURE__ */ React16.createElement(FlexComponent8, null, /* @__PURE__ */ React16.createElement(
      LocationComponent,
      {
        draftAddress: (_c = (_b = (_a = ticket.conversation) == null ? void 0 : _a.draftTicket) == null ? void 0 : _b.orderData) == null ? void 0 : _c.pickup,
        location: ticket.orderData.pickup
      }
    ), /* @__PURE__ */ React16.createElement(
      LocationComponent,
      {
        draftAddress: (_f = (_e = (_d = ticket.conversation) == null ? void 0 : _d.draftTicket) == null ? void 0 : _e.orderData) == null ? void 0 : _f.dropoff,
        location: ticket.orderData.dropoff
      }
    ))
  );
}

// src/pages/dashboard/components/table/components/table/columns/service-type-column-component.tsx
import React17 from "react";
import { TextComponent as TextComponent9 } from "@ontruck/fe-ui";
import styled16 from "styled-components";
var TextContainer = styled16.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
function ServiceTypeColumn({ ticket, widths }) {
  var _a, _b, _c, _d, _e, _f;
  const hasCargoTypeSuggestion = (_c = (_b = (_a = ticket.conversation) == null ? void 0 : _a.draftSuggestions) == null ? void 0 : _b.cargoType) == null ? void 0 : _c.aiSuggestion;
  const displayCargoType = hasCargoTypeSuggestion ? (_f = (_e = (_d = ticket.conversation) == null ? void 0 : _d.draftSuggestions) == null ? void 0 : _e.cargoType) == null ? void 0 : _f.aiSuggestion : ticket.orderData.cargo.cargoType;
  return /* @__PURE__ */ React17.createElement(
    BodyColumn,
    {
      backgroundColor: "#FFFFFF",
      columnBorderLeftColor: "var(--otk-theme-color-grey-200)",
      columnBorderLeftWidth: "1px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      width: widths.width
    },
    /* @__PURE__ */ React17.createElement(TextContainer, null, /* @__PURE__ */ React17.createElement(
      TextComponent9,
      {
        color: hasCargoTypeSuggestion ? DRAFT_SUGGESTION_COLOR : "var(--otk-theme-color-grey-700)",
        size: "s"
      },
      displayCargoType
    ))
  );
}

// src/pages/dashboard/components/table/components/table/columns/price-column-component.tsx
import React18 from "react";
import styled17 from "styled-components";
var TextContainer2 = styled17.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--otk-theme-color-grey-700);
  font-size: var(--otk-theme-font-size-s);
`;
function PriceColumn({ ticket, widths }) {
  var _a;
  return /* @__PURE__ */ React18.createElement(
    BodyColumn,
    {
      backgroundColor: "#FFFFFF",
      columnBorderLeftColor: "var(--otk-theme-color-grey-200)",
      columnBorderLeftWidth: "1px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      width: widths.width
    },
    /* @__PURE__ */ React18.createElement(TextContainer2, null, ((_a = ticket.quote) == null ? void 0 : _a.price.amount) ? ticket.quote.price.formatted : "")
  );
}

// src/pages/dashboard/components/table/components/table/columns/description-column-component.tsx
import React19 from "react";
import { TextComponent as TextComponent10 } from "@ontruck/fe-ui";
function DescriptionColumn({ ticket, widths }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const translations = useAlianzaTranslations();
  const hasPickupObservationsSuggestion = (_d = (_c = (_b = (_a = ticket.conversation) == null ? void 0 : _a.draftSuggestions) == null ? void 0 : _b.pickup) == null ? void 0 : _c.observations) == null ? void 0 : _d.aiSuggestion;
  const displayPickupObservations = hasPickupObservationsSuggestion ? (_h = (_g = (_f = (_e = ticket.conversation) == null ? void 0 : _e.draftSuggestions) == null ? void 0 : _f.pickup) == null ? void 0 : _g.observations) == null ? void 0 : _h.aiSuggestion : ticket.orderData.pickup.observations;
  const hasDropoffObservationsSuggestion = (_l = (_k = (_j = (_i = ticket.conversation) == null ? void 0 : _i.draftSuggestions) == null ? void 0 : _j.dropoff) == null ? void 0 : _k.observations) == null ? void 0 : _l.aiSuggestion;
  const displayDropoffObservations = hasDropoffObservationsSuggestion ? (_p = (_o = (_n = (_m = ticket.conversation) == null ? void 0 : _m.draftSuggestions) == null ? void 0 : _n.dropoff) == null ? void 0 : _o.observations) == null ? void 0 : _p.aiSuggestion : ticket.orderData.dropoff.observations;
  return /* @__PURE__ */ React19.createElement(
    BodyColumn,
    {
      backgroundColor: "#FFFFFF",
      columnBorderLeftColor: "var(--otk-theme-color-grey-200)",
      columnBorderLeftWidth: "1px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      width: widths.width
    },
    /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(
      TextComponent10,
      {
        color: "var(--otk-theme-color-grey-700)",
        margin: "0 0 var(--otk-theme-space-xs) 0",
        size: "xs"
      },
      /* @__PURE__ */ React19.createElement("strong", { style: { marginRight: "var(--otk-theme-space-xs)" } }, translations.table.load),
      " ",
      /* @__PURE__ */ React19.createElement(
        "span",
        {
          style: { color: hasPickupObservationsSuggestion ? DRAFT_SUGGESTION_COLOR : "inherit" }
        },
        displayPickupObservations
      )
    ), /* @__PURE__ */ React19.createElement(
      TextComponent10,
      {
        color: "var(--otk-theme-color-grey-700)",
        margin: "0 0 var(--otk-theme-space-xs) 0",
        size: "xs"
      },
      /* @__PURE__ */ React19.createElement("strong", { style: { marginRight: "var(--otk-theme-space-xs)" } }, translations.table.unload),
      " ",
      /* @__PURE__ */ React19.createElement(
        "span",
        {
          style: { color: hasDropoffObservationsSuggestion ? DRAFT_SUGGESTION_COLOR : "inherit" }
        },
        displayDropoffObservations
      )
    ))
  );
}

// src/pages/dashboard/components/table/components/table/columns/owner-agent-column-component.tsx
import React20 from "react";
import moment6 from "moment";
import {
  AvatarComponent,
  FlexComponent as FlexComponent9,
  getAvatarBackgroundByUserService,
  getAvatarInitialsByUserService
} from "@ontruck/fe-ui";
import styled18 from "styled-components";
var DateTimeContainer = styled18.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex-grow: 1;
`;
var TimeText = styled18.div`
  color: var(--otk-theme-color-grey-700);
  font-size: var(--otk-theme-font-size-s);
  font-weight: 500;
  line-height: 1.2;
`;
var DateText = styled18.div`
  color: var(--otk-theme-color-grey-600);
  font-size: var(--otk-theme-font-size-xs);
  line-height: 1.2;
`;
var ContentWrapper = styled18(FlexComponent9)`
  width: 100%;
  padding: 8px;
  gap: 8px;
`;
var ContentVerticalSeparator = styled18.div`
  height: 100%;
  width: 2px;
  border: 1px solid var(--white);
`;
function OwnerAgentColumn({ ticket, widths }) {
  const lastReceivedMessageDate = moment6(ticket.lastReceivedMessage);
  const timeFormatted = lastReceivedMessageDate.format("HH:mm");
  const dateFormatted = lastReceivedMessageDate.format("ddd MMM D");
  return /* @__PURE__ */ React20.createElement(
    BodyColumn,
    {
      columnBorderLeftColor: "white",
      columnBorderLeftWidth: "2px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      noPadding: true,
      width: widths.width
    },
    /* @__PURE__ */ React20.createElement(ContentWrapper, { alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ React20.createElement(DateTimeContainer, null, /* @__PURE__ */ React20.createElement(TimeText, null, timeFormatted), /* @__PURE__ */ React20.createElement(DateText, null, dateFormatted)), /* @__PURE__ */ React20.createElement(ContentVerticalSeparator, null), /* @__PURE__ */ React20.createElement(
      AvatarComponent,
      {
        backgroundColor: getAvatarBackgroundByUserService(ticket.createdBy),
        initials: getAvatarInitialsByUserService(ticket.createdBy),
        showBorder: false,
        width: "auto"
      }
    ))
  );
}

// src/pages/dashboard/components/table/components/table/columns/actions-column-component.tsx
import React21 from "react";
import { IconComponent as IconComponent6, iconNames as iconNames7 } from "@ontruck/fe-icons";
import { FlexComponent as FlexComponent10 } from "@ontruck/fe-ui";
function ActionsColumn({ ticket, widths }) {
  var _a;
  return /* @__PURE__ */ React21.createElement(
    BodyColumn,
    {
      columnBorderLeftColor: "white",
      columnBorderLeftWidth: "2px",
      flexGrow: widths.flexGrow,
      minWidth: widths.minWidth,
      noPadding: true,
      width: widths.width
    },
    ((_a = ticket.conversation) == null ? void 0 : _a.pendingMessage) ? /* @__PURE__ */ React21.createElement(FlexComponent10, { alignItems: "center", justifyContent: "center", width: "100%" }, /* @__PURE__ */ React21.createElement(
      IconComponent6,
      {
        color: "var(--otk-theme-color-red-600)",
        name: iconNames7.messageAlert,
        sizeInPixels: 18
      }
    )) : void 0
  );
}

// src/pages/dashboard/components/table/components/table/tickets-table-constants.ts
var TICKETS_TABLE_COLUMN_SIZES = {
  TICKET: {
    minWidth: "110px",
    width: "10%"
  },
  SHIPPER: {
    minWidth: "180px",
    width: "15%"
  },
  LOCATIONS: {
    minWidth: "350px",
    width: "25%",
    flexGrow: 1
  },
  SERVICE: {
    minWidth: "110px",
    width: "10%"
  },
  PRICE: {
    minWidth: "110px",
    width: "10%"
  },
  DESCRIPTION: {
    minWidth: "270px",
    width: "17%",
    flexGrow: 1
  },
  AGENT: {
    minWidth: "60px",
    width: "10%"
  },
  ACTIONS: {
    minWidth: "25px",
    width: "3%"
  }
};
var TICKETS_TABLE_HEADER_COLUMNS = [
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.TICKET,
    textKey: "table.headers.cotization",
    Component: TicketColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.SHIPPER,
    textKey: "table.headers.client",
    Component: ShipperColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.LOCATIONS,
    textKey: "table.headers.location",
    Component: LocationsColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.SERVICE,
    textKey: "table.headers.merchandise",
    centerContent: true,
    Component: ServiceTypeColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.PRICE,
    textKey: "table.headers.price",
    centerContent: true,
    Component: PriceColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.DESCRIPTION,
    textKey: "table.headers.observations",
    centerContent: true,
    Component: DescriptionColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.AGENT,
    textKey: "table.headers.lastUpdate",
    centerContent: true,
    Component: OwnerAgentColumn
  },
  {
    widths: TICKETS_TABLE_COLUMN_SIZES.ACTIONS,
    textKey: "",
    centerContent: true,
    Component: ActionsColumn
  }
];

// src/pages/dashboard/components/table/components/table/headers/table-headers-component.tsx
var Row = styled19.div`
  width: 100%;
  display: flex;
`;
var HeaderRow = styled19(Row)`
  background-color: var(--grey100);
  height: var(--otk-ui-table-summary-height);
  min-width: 100%;
  border-bottom: var(--primary-top-bar-border);
  display: flex;
`;
var HeaderColumn = styled19(Column)`
  padding: var(--otk-theme-space-s);
  align-items: center;
  border-right: var(--otk-ui-table-header-cell-border-right);
  min-width: ${({ minWidth }) => minWidth};
  width: ${({ width }) => width};
  flex-grow: ${({ flexGrow }) => flexGrow};
`;
var HeaderText = styled19.div`
  color: var(--grey500);
  font-size: var(--font-size-s);
  text-transform: uppercase;
`;
function TableHeadersComponent() {
  const translations = useAlianzaTranslations();
  return /* @__PURE__ */ React22.createElement(HeaderRow, null, TICKETS_TABLE_HEADER_COLUMNS.map((column) => /* @__PURE__ */ React22.createElement(
    HeaderColumn,
    {
      centerContent: Boolean(column.centerContent),
      flexGrow: column.widths.flexGrow,
      key: `table-header-${column.textKey}`,
      minWidth: column.widths.minWidth,
      width: column.widths.width
    },
    /* @__PURE__ */ React22.createElement(HeaderText, null, column.textKey === "table.headers.cotization" && translations.table.headers.cotization, column.textKey === "table.headers.client" && translations.table.headers.client, column.textKey === "table.headers.location" && translations.table.headers.location, column.textKey === "table.headers.merchandise" && translations.table.headers.merchandise, column.textKey === "table.headers.price" && translations.table.headers.price, column.textKey === "table.headers.observations" && translations.table.headers.observations, column.textKey === "table.headers.lastUpdate" && translations.table.headers.lastUpdate)
  )));
}

// src/pages/dashboard/components/table/components/table/tickets-grouped-table-component.tsx
import React24 from "react";

// src/pages/dashboard/components/table/components/table/tickets-row-table-component.tsx
import React23 from "react";
import styled20 from "styled-components";
var Container4 = styled20.div`
  min-width: 100%;
  border-bottom: var(--primary-top-bar-border);
  display: flex;
`;
function TicketsRowTableComponent({ ticket }) {
  return /* @__PURE__ */ React23.createElement(Container4, null, TICKETS_TABLE_HEADER_COLUMNS.map(
    (column) => column.Component ? /* @__PURE__ */ React23.createElement(
      column.Component,
      {
        key: `tickets-column-${column.textKey}`,
        ticket,
        widths: column.widths
      }
    ) : void 0
  ));
}

// src/pages/dashboard/components/table/components/table/tickets-grouped-table-component.tsx
function TicketsGroupedTableComponent({
  groupedTicket
}) {
  return /* @__PURE__ */ React24.createElement("div", { style: { overflowX: "visible" } }, groupedTicket.tickets.map((ticket) => /* @__PURE__ */ React24.createElement(TicketsRowTableComponent, { key: `ticket-row-table-${ticket.id}`, ticket })));
}

// src/pages/dashboard/components/table/tickets-table-component.tsx
function TicketsTableComponent({
  groupedTickets
}) {
  return /* @__PURE__ */ React25.createElement("div", { style: { margin: "0 auto" } }, /* @__PURE__ */ React25.createElement(TableHeadersComponent, null), groupedTickets.map((grouped) => /* @__PURE__ */ React25.createElement("div", { key: `grouped-ticket-${grouped.date}` }, /* @__PURE__ */ React25.createElement(GroupedHeaderComponent, { groupedTicket: grouped, key: `grouped-header-${grouped.date}` }), /* @__PURE__ */ React25.createElement(
    TicketsGroupedTableComponent,
    {
      groupedTicket: grouped,
      key: `grouped-ticket-${grouped.date}`
    }
  ))));
}

// src/pages/dashboard/components/filters/filters-component.tsx
import React26, { useState as useState8 } from "react";
import {
  BallComponent as BallComponent3,
  DateInputComponent as DateInputComponent2,
  FlexComponent as FlexComponent11,
  MultiSelectInputComponent,
  SelectInputComponent,
  Input as Input4,
  TextComponent as TextComponent11,
  ToolbarButtonComponent
} from "@ontruck/fe-ui";
import styled21 from "styled-components";
import { IconComponent as IconComponent7, iconNames as iconNames8 } from "@ontruck/fe-icons";
import moment7 from "moment";
var CustomFlexContainer = styled21(FlexComponent11)`
  height: 100%;
  align-items: center;
  gap: 16px;
`;
var SmartViewsContainer = styled21.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
`;
var SmartViewsButton = styled21(ToolbarButtonComponent)`
  background-color: var(--grey200);
  height: 100%;
  min-height: 55px;
`;
var ToolbarContainer = styled21.div`
  display: flex;
  flex-grow: 1;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  max-height: 55px;
  border-bottom: var(--primary-top-bar-border);
  min-height: 55px;
`;
function TicketsListToolbar({
  refreshData,
  filters,
  setFilters
}) {
  const [createdAtAfterFormatted, setCreatedAtAfterFormatted] = useState8("");
  const translations = useAlianzaTranslations();
  const orderTypeOptions = [
    {
      value: "-created_at",
      label: translations.dashboard.filters.creationDate
    },
    {
      value: "-last_received_message",
      label: translations.dashboard.filters.modifiedDate
    }
  ];
  const stateOptions = [
    {
      value: "DRAFT" /* DRAFT */,
      label: translations.ticketStates.draft,
      color: TicketColorStates.DRAFT,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.DRAFT }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.draft))
    },
    {
      value: "PENDING" /* PENDING */,
      label: translations.ticketStates.pending,
      color: TicketColorStates.PENDING,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.PENDING }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.pending))
    },
    {
      value: "QUOTE_SENT" /* QUOTESENT */,
      label: translations.ticketStates.quoteSent,
      color: TicketColorStates.QUOTE_SENT,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.QUOTE_SENT }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.quoteSent))
    },
    {
      value: "ACCEPTED" /* ACCEPTED */,
      label: translations.ticketStates.accepted,
      color: TicketColorStates.ACCEPTED,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.ACCEPTED }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.accepted))
    },
    {
      value: "REJECTED" /* REJECTED */,
      label: translations.ticketStates.rejected,
      color: TicketColorStates.REJECTED,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.REJECTED }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.rejected))
    },
    {
      value: "CANCELLED" /* CANCELLED */,
      label: translations.ticketStates.cancelled,
      color: TicketColorStates.CANCELLED,
      component: /* @__PURE__ */ React26.createElement(FlexComponent11, { gap: "10px" }, /* @__PURE__ */ React26.createElement(BallComponent3, { backgroundColor: TicketColorStates.CANCELLED }), /* @__PURE__ */ React26.createElement(TextComponent11, null, translations.ticketStates.cancelled))
    }
  ];
  function handleRefreshData() {
    return __async(this, null, function* () {
      yield refreshData();
    });
  }
  function handleChangeDate(name, value) {
    const date = value ? moment7(value) : null;
    setCreatedAtAfterFormatted(date ? date.format("DD/MM/YYYY") : "");
    setFilters(__spreadProps(__spreadValues({}, filters), { created_at_after: date ? date.format("YYYY-MM-DD") : "" }));
  }
  function handleChangeOrderType(name, value) {
    const newFilters = __spreadValues({}, filters);
    if (value === "-last_received_message") {
      newFilters.ordering = "-last_received_message";
    } else {
      newFilters.ordering = "-created_at";
    }
    setFilters(newFilters);
  }
  return /* @__PURE__ */ React26.createElement(ToolbarContainer, null, /* @__PURE__ */ React26.createElement(CustomFlexContainer, null, /* @__PURE__ */ React26.createElement(SmartViewsContainer, null, /* @__PURE__ */ React26.createElement(SmartViewsButton, { onClick: () => void handleRefreshData() }, /* @__PURE__ */ React26.createElement(IconComponent7, { name: iconNames8.settings, size: "l" }))), /* @__PURE__ */ React26.createElement(
    SelectInputComponent,
    {
      handleChangeValue: handleChangeOrderType,
      label: translations.dashboard.filters.orderType,
      name: "orderType",
      options: orderTypeOptions,
      value: filters.ordering === "-last_received_message" ? "-last_received_message" : "-created_at",
      width: "200px"
    }
  ), /* @__PURE__ */ React26.createElement(
    DateInputComponent2,
    {
      handleChangeValue: handleChangeDate,
      label: translations.dashboard.filters.creationDate,
      name: "created_at_after",
      value: createdAtAfterFormatted,
      width: "200px"
    }
  ), /* @__PURE__ */ React26.createElement(
    MultiSelectInputComponent,
    {
      label: translations.dashboard.filters.status,
      labelSelected: translations.dashboard.filters.statusSelected,
      onChange: (state) => {
        setFilters(__spreadProps(__spreadValues({}, filters), { state }));
      },
      options: stateOptions,
      values: filters.state,
      width: "200px"
    }
  ), /* @__PURE__ */ React26.createElement(
    Input4,
    {
      handleChangeEvent: (e) => {
        setFilters(__spreadProps(__spreadValues({}, filters), { search: e.target.value }));
      },
      label: translations.dashboard.filters.search,
      name: "search",
      type: "search",
      value: filters.search,
      width: "300px"
    }
  )), /* @__PURE__ */ React26.createElement(FlexComponent11, null));
}

// src/pages/dashboard/dashboard-page.tsx
var TABLE_FOOTER_HEIGHT = 50;
var TableFooter = styled22.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${TABLE_FOOTER_HEIGHT}px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: var(--otk-theme-color-white);
  border-top: 1px solid var(--otk-theme-color-grey-200);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;
function DashboardPage() {
  const [filters, setFilters] = useState9({
    page: 1,
    page_size: 25,
    created_at_after: "",
    state: [],
    search: "",
    ordering: "-created_at"
  });
  const { groupedTickets, refreshData, count, isLoading } = useGetTicketsHook({ filters });
  const [firstLoad, setFirstLoad] = useState9(true);
  const translations = useAlianzaTranslations();
  useEffect3(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }
    void refreshData();
  }, [filters]);
  return /* @__PURE__ */ React27.createElement(PageLayout2, null, /* @__PURE__ */ React27.createElement(TicketsListToolbar, { filters, refreshData, setFilters }), !isLoading ? /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(
    "div",
    {
      style: {
        overflowX: "auto",
        overflowY: "auto",
        marginBottom: TABLE_FOOTER_HEIGHT,
        paddingBottom: TABLE_FOOTER_HEIGHT
      }
    },
    /* @__PURE__ */ React27.createElement(TicketsTableComponent, { groupedTickets })
  ), /* @__PURE__ */ React27.createElement(TableFooter, null, /* @__PURE__ */ React27.createElement(
    TablePaginationComponent,
    {
      justifyContent: "space-between",
      numberOfItems: count,
      onChangePageSize: (pageSize) => {
        setFilters(__spreadProps(__spreadValues({}, filters), { page_size: pageSize }));
      },
      onGoToNextPage: () => {
        setFilters(__spreadProps(__spreadValues({}, filters), { page: filters.page + 1 }));
      },
      onGoToPage: (page) => {
        setFilters(__spreadProps(__spreadValues({}, filters), { page }));
      },
      onGoToPreviousPage: () => {
        setFilters(__spreadProps(__spreadValues({}, filters), { page: filters.page - 1 }));
      },
      pageIndex: filters.page,
      pageSize: filters.page_size,
      pageSizes: [25, 50, 100, 120],
      resultsPerPageLabel: translations.dashboard.resultsPerPageLabel,
      width: "100%"
    }
  ))) : /* @__PURE__ */ React27.createElement(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "300px",
        width: "100%"
      }
    },
    /* @__PURE__ */ React27.createElement(BoxesSpinnerComponent, { color: "var(--otk-theme-color-grey-300)", sizeInPixels: 100 })
  ));
}

// src/config/config-provider.tsx
import React28 from "react";
function ConfigProvider({
  token,
  apiBase,
  children
}) {
  return /* @__PURE__ */ React28.createElement(
    ConfigContext.Provider,
    {
      value: {
        apiBase,
        token
      }
    },
    children
  );
}
export {
  AlianzaTranslationsProvider,
  ConfigProvider,
  DashboardPage,
  TicketPage,
  getTicketStateLabel,
  useAlianzaTranslations
};
